import REGISTERED_ENGLISH from "./generated/registeredEnglish.json";
import { SUPPORT_TRANSLATIONS } from "./supportTranslations";
import { PROJECT_TRANSLATIONS } from "./projectTranslations";
import { VOYAGE_DELUXE_TRANSLATIONS } from "./voyageTranslations";
import { IMMOBILIER_TRANSLATIONS } from "./immobilierTranslations";
import { SUBSCRIPTION_TRANSLATIONS } from "./subscriptionTranslations";
import { TRUST_TRANSLATIONS } from "./trustTranslations";
import { JOURNEY_TRANSLATIONS } from "./journeyTranslations";
import { STUDIO_TRANSLATIONS } from "./studioTranslations";
import { LIVE_MAP_TRANSLATIONS } from "./liveMapTranslations";
import { DAILY_CIRCLE_TRANSLATIONS } from "./dailyCircleTranslations";
import { INFINI_TRANSLATIONS } from "./infiniTranslations";
import { CONFIRMATION_TRANSLATIONS } from "./confirmationTranslations";
import { NAVIGATION_TRANSLATIONS } from "./navigationTranslations";
import { WELCOME_TRANSLATIONS } from "./welcomeTranslations";
import { SHELL_TRANSLATIONS } from "./shellTranslations";
import { MEMBER_HOME_TRANSLATIONS } from "./memberHomeTranslations";
import { ENGLISH_SUPPLEMENT_TRANSLATIONS } from "./englishSupplementTranslations";

export const LANGS = [
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
];

export const DEFAULT_LANG = "fr";

// Keep this minimal: we translate the shared chrome first (header/subnav/ribbons).
export const TRANSLATIONS = {
  fr: {
    ...SUPPORT_TRANSLATIONS.fr,
    ...PROJECT_TRANSLATIONS.fr,
    ...NAVIGATION_TRANSLATIONS.fr,
    ...WELCOME_TRANSLATIONS.fr,
    ...SHELL_TRANSLATIONS.fr,
    ...MEMBER_HOME_TRANSLATIONS.fr,
    "acheter.mobile.browse": "Découvrir",
    "acheter.mobile.filters": "Filtres",
    "acheter.mobile.favorites": "Favoris",
    "acheter.mobile.messages": "Messages",
    "acheter.mobile.orders": "Mes achats",
    "acheter.mobile.open_browse": "Voir les annonces",
    "acheter.mobile.open_filters": "Ouvrir les filtres",
    "acheter.mobile.open_favorites": "Voir mes favoris",
    "acheter.mobile.open_messages": "Ouvrir mes messages",
    "acheter.mobile.open_orders": "Suivre mes achats",
    "acheter.mobile.intro": "Tout pour trouver, choisir et suivre vos achats.",
    "acheter.mobile.shortcuts": "Accès rapides",
    "acheter.mobile.cart": "Panier",
    "lang.name": "Français",
    "lang.select": "Langue",

    "header.invite_et": "Invitation E.T",
    "header.search_et_ph": "Rechercher E.T…",

    "subnav.temple_ia40": "Temple des 40 IA humaines",
    "subnav.temple_et": "Temple des civilisations E.T",

    "ribbon.badge": "En construction",
    "ribbon.text": "Cette section premium est en cours de creation (local).",
    "ribbon.cta": "Invitation E.T",

    "nav.market.emploi": "Emploi",
    "nav.market.vendre": "Vendre",
    "nav.market.acheter": "Acheter",
    "nav.market.donner": "Donner",
    "nav.market.services": "Services",
    "nav.market.sortie": "Sortie",
    "nav.market.voyage": "Voyage",
    "nav.market.sport_loisir": "Sport & loisir",
    "nav.market.animaux": "Animaux",
    "nav.media.music": "Musique & clips",

    "music.title": "Musique",
    "music.hint": "Musique · Clips · Commentaires · Playlists",
    "music.kicker": "Media",
    "music.page_title": "Musique & Clips vidéo",
    "music.page_sub": "Écoute en ligne, playlists, favoris, commentaires, classement. Clips via YouTube (upload en construction).",
    "music.tabs": "Catégories Musique",
    "music.detail": "Détail",

    "music.tab.genres": "Genres",
    "music.tab.recherche": "Recherche",
    "music.tab.classement": "Classement",
    "music.tab.playlists": "Playlists",
    "music.tab.favoris": "Favoris",
    "music.tab.clips": "Clips",
    "music.tab.telecharger": "Télécharger",
    "music.tab.parametres": "Paramètres",

    "music.desc.genres": "Catégories, tendances, recherche et nouveautés.",
    "music.desc.recherche": "Rechercher un titre par nom, artiste, genre ou catégorie.",
    "music.desc.classement": "Top vues, notes, j’aime. Classements par ambiance et genre.",
    "music.desc.playlists": "Crée et gère des playlists. Partage et lecture rapide.",
    "music.desc.favoris": "Regarder plus tard, j’aime, historique, favoris par playlists.",
    "music.desc.clips": "Clips vidéo via YouTube. Upload de clips: en construction.",
    "music.desc.telecharger": "Mettre ta musique en ligne, associer aux slots (IA / E.T), gérer la bibliothèque.",
    "music.desc.parametres": "Ajoute des titres (URL), configure stockage local et préférences.",

    "music.search": "Recherche",
    "music.search.ph": "Rechercher par titre…",
    "music.search.hint": "Tape un titre pour filtrer la bibliothèque.",
    "music.search.count": "Résultats",
    "music.search.empty.t": "Aucun résultat",
    "music.search.empty.d": "Essaie un autre mot-clé.",
    "music.search.rubrics": "Rubriques recherche",
    "music.search.rubric.t": "Recherche par titre",
    "music.search.rubric.d": "Trouve rapidement une musique par nom, artiste, genre ou catégorie.",

    "music.upload.rubrics": "Rubriques Télécharger",
    "music.upload.slots.t": "Slots",
    "music.upload.slots.d": "Associe une musique à une IA humaine ou une civilisation E.T.",
    "music.upload.bulk.t": "Upload",
    "music.upload.bulk.d": "Upload en série: plusieurs fichiers, association auto si bien nommés.",
    "music.upload.rights.t": "Droits",
    "music.upload.rights.d": "Confirme tes droits avant de mettre en ligne.",
    "music.upload.library.t": "Bibliothèque",
    "music.upload.library.d": "Gère ta bibliothèque en ligne: voir, ouvrir, supprimer.",

    "music.library": "Bibliothèque",
    "music.player": "Lecteur",
    "music.filters": "Filtres",
    "music.filter.genre": "Genre",
    "music.genre.all": "Tous",
    "music.genre.other": "Autre",

    "music.meta.likes": "J’aime",
    "music.meta.later": "Plus tard",
    "music.meta.comments": "Commentaires",

    "music.rank.mode": "Classement",
    "music.rank.views": "Vues",
    "music.rank.ratings": "Notes",
    "music.rank.likes": "J’aime",

    "music.like": "J’aime",
    "music.later": "Plus tard",
    "music.share": "Partager",
    "music.toast.copied": "Lien copié",
    "music.toast.cleared": "Données locales supprimées",
    "music.toast.added": "Ajouté",
    "music.toast.need_title_mp3": "Titre + MP3 URL requis",
    "music.toast.need_youtube": "Lien YouTube requis",
    "music.toast.added_clip": "Clip ajouté",
    "music.toast.playlist_created": "Playlist créée",
    "music.toast.added_to_playlist": "Ajouté à la playlist",

    "music.rating": "Note",
    "music.rating_clear": "Effacer la note",
    "music.playlist.add": "Ajouter",
    "music.playlist.choose": "Playlist…",
    "music.open_youtube": "Ouvrir sur YouTube",

    "music.comments": "Commentaires",
    "music.comment.add": "Ajouter un commentaire",
    "music.comment.emoji_ph": "Émoji (optionnel)",
    "music.comment.media_ph": "Lien image/vidéo (optionnel)",
    "music.comment.text_ph": "Écris ton commentaire…",
    "music.comment.reply_ph": "Répondre à (id optionnel)",
    "music.comment.post": "Publier",
    "music.comment.open_media": "Ouvrir le média",
    "music.comments.empty": "Aucun commentaire pour l’instant.",

    "music.playlists.title": "Playlists",
    "music.playlists.name_ph": "Nom de playlist",
    "music.playlists.create": "Créer",
    "music.playlists.remove": "Retirer",
    "music.playlists.empty": "Ajoute des titres via le lecteur.",
    "music.playlists.none": "Aucune playlist",

    "music.settings": "Paramètres",
    "music.settings.add_track": "Ajouter une musique (URL)",
    "music.settings.title_ph": "Titre",
    "music.settings.artist_ph": "Artiste",
    "music.settings.genre_ph": "Genre",
    "music.settings.mp3_ph": "MP3 URL (https://...)",
    "music.settings.youtube_ph": "YouTube URL (optionnel)",
    "music.settings.add": "Ajouter",
    "music.settings.add_clip": "Ajouter un clip (YouTube)",
    "music.settings.clip_title_ph": "Titre",
    "music.settings.clip_cat_ph": "Catégorie",
    "music.settings.clip_url_ph": "Lien YouTube (https://...)",
    "music.settings.clip_upload_soon": "Upload de clips sur serveur: en construction.",
    "music.settings.storage": "Stockage local",
    "music.settings.storage_note": "Données de démo (likes, vues, playlists, commentaires) stockées dans ton navigateur.",
    "music.settings.clear": "Vider",

    "music.fav.empty.t": "Aucun favori",
    "music.fav.empty.d": "Clique ♥ ou ⏳ sur un titre pour le retrouver ici.",
    "music.no_track": "Aucun titre",

    "music.clips.title": "Clips vidéo",
    "music.clips.note": "Clips via YouTube. Upload sur serveur: en construction.",
    "music.clips.source": "Source",
    "music.clips.bad_url": "Lien YouTube invalide",
    "music.clips.empty": "Aucun clip",

    "music.genres.rubrics": "Rubriques Genres",
    "music.genres.categories.t": "Catégories",
    "music.genres.categories.d": "Découvre par style: rap, pop, electro, rock, ambient, cinematic et plus.",
    "music.genres.tendances.t": "Tendances",
    "music.genres.tendances.d": "Ce qui monte: nouveautés, partages, favoris de la communauté.",
    "music.genres.recherche.t": "Recherche",
    "music.genres.recherche.d": "Trouve un titre, un artiste ou une ambiance. Le partage crée un lien direct.",
    "music.genres.nouveautes.t": "Nouveautés",
    "music.genres.nouveautes.d": "Derniers ajouts et dernières écoutes. Un flux vivant et premium.",

    "music.classement.rubrics": "Rubriques Classement",
    "music.classement.vues.t": "Vues",
    "music.classement.vues.d": "Top des titres les plus écoutés.",
    "music.classement.notes.t": "Notes",
    "music.classement.notes.d": "Classement par étoiles et appréciation.",
    "music.classement.jaime.t": "J’aime",
    "music.classement.jaime.d": "Les titres que tu as aimés et ceux qui circulent.",
    "music.classement.categories.t": "Par catégories",
    "music.classement.categories.d": "Des tops par genre et ambiance pour explorer vite.",

    "music.playlists.rubrics": "Rubriques Playlists",
    "music.playlists.creer.t": "Créer",
    "music.playlists.creer.d": "Crée des playlists par mood: temple, travail, nuit, voyage, etc.",
    "music.playlists.ajouter.t": "Ajouter",
    "music.playlists.ajouter.d": "Ajoute des titres depuis le lecteur en 1 clic.",
    "music.playlists.partager.t": "Partager",
    "music.playlists.partager.d": "Partage un lien premium vers une playlist ou un titre.",
    "music.playlists.lecture.t": "Lecture",
    "music.playlists.lecture.d": "Lecture continue, ordre, favoris. Une expérience deluxe.",

    "music.favoris.rubrics": "Rubriques Favoris",
    "music.favoris.plus_tard.t": "Regarder plus tard",
    "music.favoris.plus_tard.d": "Garde des titres sous la main et reviens quand tu veux.",
    "music.favoris.likes.t": "J’aime",
    "music.favoris.likes.d": "Tes coups de cœur.",
    "music.favoris.playlist.t": "Par playlists",
    "music.favoris.playlist.d": "Retrouve tes favoris à l’intérieur de chaque playlist.",
    "music.favoris.historique.t": "Historique",
    "music.favoris.historique.d": "Les derniers titres écoutés (démo locale).",

    "music.clips.rubrics": "Rubriques Clips",
    "music.clips.youtube.t": "YouTube",
    "music.clips.youtube.d": "Pour l’instant: liens YouTube (embed). Plus tard: upload natif sur Eternua.",
    "music.clips.categories.t": "Catégories",
    "music.clips.categories.d": "Classe par style: rap, pop, electro, rock, etc.",
    "music.clips.tendances.t": "Tendances",
    "music.clips.tendances.d": "Clips les plus regardés et partagés (démo).",
    "music.clips.upload.t": "Upload (bientôt)",
    "music.clips.upload.d": "En construction: mettre ses clips en ligne sur le serveur.",

    "music.parametres.rubrics": "Rubriques Paramètres",
    "music.parametres.profil.t": "Préférences",
    "music.parametres.profil.d": "Qualité, lecture auto, mode discret, réglages premium.",
    "music.parametres.confidentialite.t": "Confidentialité",
    "music.parametres.confidentialite.d": "Gère ce que tu partages et avec qui.",
    "music.parametres.notifications.t": "Notifications",
    "music.parametres.notifications.d": "Nouveaux likes, commentaires, ajouts de playlist (à connecter au backend).",
    "music.parametres.storage.t": "Stockage local",
    "music.parametres.storage.d": "Gestion des données locales de démonstration (likes, vues, commentaires).",

    "emploi.title": "Emploi",
    "emploi.hint": "Offres · Demandes · Missions · Recrutement",
    "emploi.tabs": "Catégories Emploi",
    "emploi.detail": "Détail",
    "emploi.tab.offres": "Offres",
    "emploi.tab.demandes": "Demandes",
    "emploi.tab.missions": "Missions",
    "emploi.tab.recrutement": "Recrutement",
    "emploi.tab.carte": "Carte",
    "emploi.desc.offres": "Poste des offres d’emploi, stages, alternances, CDI, CDD. Parcours, filtre, contacte et postule.",
    "emploi.desc.demandes": "Publie une demande: compétences, disponibilité, localisation. Les recruteurs peuvent te trouver et te contacter.",
    "emploi.desc.missions": "Missions courtes, freelance, prestations. Idéal pour travailler vite, clairement, avec objectifs et durée.",
    "emploi.desc.recrutement": "Espace recrutement: annonces, sélection, processus. Centralise candidatures et échanges.",
    "emploi.desc.carte": "Carte du monde: visualise Offres, Demandes, Missions et Recrutement partout sur la planète.",
    "emploi.offres.rubrics": "Rubriques Offres",
    "emploi.offres.publier.t": "Publier des offres",
    "emploi.offres.publier.d": "CDI, CDD, stage, alternance. Décris le poste, la localisation, le salaire et les critères. Attire les bons profils.",
    "emploi.offres.parcourir.t": "Parcourir",
    "emploi.offres.parcourir.d": "Explore les annonces par secteur, ville, télétravail, niveau. Ouvre les détails et compare rapidement.",
    "emploi.offres.filtrer.t": "Filtrer",
    "emploi.offres.filtrer.d": "Affiner par type de contrat, compétences, disponibilité, salaire, date. Gagne du temps et trouve l’essentiel.",
    "emploi.offres.postuler.t": "Postuler",
    "emploi.offres.postuler.d": "Candidature simple: message, CV, portfolio. Suis l’état des réponses et continue la conversation.",
    "emploi.demandes.rubrics": "Rubriques Demandes",
    "emploi.demandes.publier.t": "Publier une demande",
    "emploi.demandes.publier.d": "Décris ce que tu recherches: poste, secteur, contrat, disponibilité. Donne un contexte clair.",
    "emploi.demandes.profil.t": "Profil & compétences",
    "emploi.demandes.profil.d": "Mets tes compétences, expériences, portfolio et objectifs. Rends ton profil trouvable et crédible.",
    "emploi.demandes.recevoir.t": "Recevoir des propositions",
    "emploi.demandes.recevoir.d": "Les recruteurs et entreprises peuvent t’envoyer des offres privées. Tu vois tout au même endroit.",
    "emploi.demandes.repondre.t": "Répondre & avancer",
    "emploi.demandes.repondre.d": "Réponds vite, pose les bonnes questions, planifie un échange. Passe de la demande à l’accord.",

    "emploi.missions.rubrics": "Rubriques Missions",
    "emploi.missions.publier.t": "Publier une mission",
    "emploi.missions.publier.d": "Décris la mission, le livrable, la durée, le budget. Idéal pour freelance et prestations.",
    "emploi.missions.cadrer.t": "Cadrer",
    "emploi.missions.cadrer.d": "Objectifs, scope, deadlines, outils. Un cadrage net évite les malentendus et les retards.",
    "emploi.missions.devis.t": "Devis & conditions",
    "emploi.missions.devis.d": "Valide prix, jalons, paiement, révisions. Tout est clair avant de démarrer.",
    "emploi.missions.livrer.t": "Livrer",
    "emploi.missions.livrer.d": "Livraison, retours, validation. Termine proprement et construis ta réputation.",

    "emploi.recrutement.rubrics": "Rubriques Recrutement",
    "emploi.recrutement.publier.t": "Publier une annonce",
    "emploi.recrutement.publier.d": "Rôle, missions, salaire, avantages, critères. Une annonce précise attire les bons candidats.",
    "emploi.recrutement.trier.t": "Trier & qualifier",
    "emploi.recrutement.trier.d": "Shortlist, critères, messages. Élimine vite le bruit, garde les profils pertinents.",
    "emploi.recrutement.entretiens.t": "Entretiens",
    "emploi.recrutement.entretiens.d": "Planifie, échange, pose les questions clés. Centralise les notes et décisions.",
    "emploi.recrutement.finaliser.t": "Finaliser",
    "emploi.recrutement.finaliser.d": "Offre finale, négociation, onboarding. Passe du choix à l’intégration.",

    "emploi.carte.rubrics": "Rubriques Carte",
    "emploi.carte.monde.t": "Carte mondiale",
    "emploi.carte.monde.d": "Vue globale holographique: découvre le marché Emploi à l’échelle planétaire.",
    "emploi.carte.filtres.t": "Filtres",
    "emploi.carte.filtres.d": "Bascule Offres, Demandes, Missions, Recrutement pour afficher uniquement ce que tu veux.",
    "emploi.carte.points.t": "Points de repère",
    "emploi.carte.points.d": "Chaque point correspond à une annonce. Clique pour lire le détail (bientôt: fiche complète).",
    "emploi.carte.ouvrir.t": "Ouvrir",
    "emploi.carte.ouvrir.d": "Ouvre la Carte pour naviguer et explorer. (Données démo en local pour l’instant.)",

    "emploi.map": "Carte",
    "emploi.map_title": "Carte mondiale",
    "emploi.map_filter": "Filtrer",
    "emploi.map_legend": "Légende",
    "emploi.map_hint": "Clique les onglets pour afficher les points sur toute la planète.",
    "emploi.map_note": "Données de démonstration (local).",
    "emploi.globe.pause": "Pause",
    "emploi.globe.play": "Tourner",
    "emploi.globe.zoom_out": "Réduire",
    "emploi.globe.zoom_in": "Agrandir",
    "emploi.globe.expand": "Agrandir",
    "emploi.globe.shrink": "Réduire",
    "emploi.globe.search_ph": "Rechercher une zone…",
    "emploi.globe.search_results": "Résultats",
    "emploi.globe.aria": "Globe interactif",
    "emploi.globe.pick": "Zone sélectionnée",
    "emploi.globe.pick_hint": "Clique sur la Terre pour lire la zone.",
    "emploi.globe.picked": "Zone",
    "emploi.soon": "Sélectionne une catégorie via la 3e barre (Offres/Demandes/Missions/Recrutement) ou ouvre la Carte.",

    "nav.menu": "Menu",
    "nav.open": "Ouvrir la navigation",
    "nav.close": "Fermer la navigation",
    "nav.hint_open": "Ouvrir le menu",
    "nav.hint_close": "Fermer le menu",

    "common.open": "Ouvrir",
    "common.close": "Fermer",
    "common.refresh": "Actualiser",
    "common.back_home": "Retour accueil",
    "common.hub_market": "Hub market",
    "common.friends_feed": "Fil d’actualite amis",
    "common.section_coming": "Section en construction",
    "common.mode_dark": "Mode sombre",
    "common.mode_light": "Mode clair",
    "common.back_temples": "Revenir aux Temples",

    "market.title": "Market",
    "market.hero_sub": "Emploi, annonces, services, sorties. Cette partie est en construction en local.",
    "market.cat.emploi.desc": "Offres, missions, recrutement.",
    "market.cat.vendre.desc": "Annonces, produits, ventes.",
    "market.cat.acheter.desc": "Trouve et contacte.",
    "market.cat.donner.desc": "Don, echange, entraide.",
    "market.cat.services.desc": "Prestations et demandes.",
    "market.cat.sortie.desc": "Evenements, sorties, rencontres.",
    "market.cat.voyage.desc": "Voyages, destinations, co-voyageurs, itinéraires.",
    "market.cat.sport_loisir.desc": "Activites a partager.",
    "market.cat.animaux.desc": "Garde, adoption, entraide.",

    "acheter.title": "Acheter",
    "acheter.hint": "Parcourir · Filtrer · Favoris · Contacter",
    "acheter.tabs": "Catégories Acheter",
    "acheter.detail": "Détail",
    "acheter.soon": "Cette section est en construction. Utilise la navigation de gauche sur PC pour explorer toutes les rubriques.",
    "acheter.tab.parcourir": "Parcourir",
    "acheter.tab.filtrer": "Filtrer",
    "acheter.tab.favoris": "Favoris",
    "acheter.tab.contacter": "Contacter",
    "acheter.desc.parcourir": "Parcours les annonces et trouve ce que tu cherches.",
    "acheter.desc.filtrer": "Filtre par prix, zone, état et catégorie.",
    "acheter.desc.favoris": "Sauvegarde et suis tes annonces préférées.",
    "acheter.desc.contacter": "Contacte les vendeurs et organise l’achat.",

    "acheter.parcourir.rubrics": "Rubriques Parcourir",
    "acheter.parcourir.categories.t": "Catégories",
    "acheter.parcourir.categories.d": "Parcours par catégories: tech, maison, mode, etc. (premium).",
    "acheter.parcourir.nouveautes.t": "Nouveautés",
    "acheter.parcourir.nouveautes.d": "Découvre les nouvelles annonces et les meilleurs plans.",
    "acheter.parcourir.proximite.t": "Proximité",
    "acheter.parcourir.proximite.d": "Vois ce qui est proche de toi et disponible rapidement.",
    "acheter.parcourir.premium.t": "Premium",
    "acheter.parcourir.premium.d": "Annonces vérifiées, vendeurs fiables, expérience deluxe (bientôt).",

    "acheter.filtrer.rubrics": "Rubriques Filtrer",
    "acheter.filtrer.prix.t": "Prix",
    "acheter.filtrer.prix.d": "Filtre par budget et fourchette de prix.",
    "acheter.filtrer.etat.t": "État",
    "acheter.filtrer.etat.d": "Neuf, très bon état, occasion: choisis ton niveau.",
    "acheter.filtrer.localisation.t": "Localisation",
    "acheter.filtrer.localisation.d": "Ville, distance, livraison: adapte à ton besoin.",
    "acheter.filtrer.tri.t": "Tri",
    "acheter.filtrer.tri.d": "Tri par pertinence, date, prix, proximité (premium).",

    "acheter.favoris.rubrics": "Rubriques Favoris",
    "acheter.favoris.sauver.t": "Sauver",
    "acheter.favoris.sauver.d": "Sauvegarde les annonces pour les retrouver vite.",
    "acheter.favoris.listes.t": "Listes",
    "acheter.favoris.listes.d": "Crée des listes: idées cadeaux, achats, projets.",
    "acheter.favoris.alertes.t": "Alertes",
    "acheter.favoris.alertes.d": "Alertes sur mots-clés, zones, prix (bientôt).",
    "acheter.favoris.suivi.t": "Suivi",
    "acheter.favoris.suivi.d": "Suis les réponses et l’état des conversations.",

    "acheter.contacter.rubrics": "Rubriques Contacter",
    "acheter.contacter.message.t": "Message",
    "acheter.contacter.message.d": "Contacte le vendeur: question, dispo, prix.",
    "acheter.contacter.negocier.t": "Négocier",
    "acheter.contacter.negocier.d": "Négociation respectueuse: propose une offre claire.",
    "acheter.contacter.rdv.t": "Rendez-vous",
    "acheter.contacter.rdv.d": "Fixe un rendez-vous et confirme les détails.",
    "acheter.contacter.securite.t": "Sécurité",
    "acheter.contacter.securite.d": "Règles: lieu public, prudence, vérifications.",

    "vendre.title": "Vendre",
    "vendre.hint": "Publiez, gérez et finalisez chaque vente depuis un seul espace.",
    "vendre.tabs": "Catégories Vendre",
    "vendre.detail": "Détail",
    "vendre.soon": "Cette section est en construction. Utilise la navigation de gauche sur PC pour explorer toutes les rubriques.",
    "vendre.tab.publier": "Publier vente normale",
    "vendre.tab.gerer": "Gérer",
    "vendre.tab.messages": "Messages",
    "vendre.tab.livraison": "Livraison",
    "vendre.desc.publier": "Publie une annonce premium: titre, photos, prix, catégorie.",
    "vendre.desc.gerer": "Gère tes annonces: stock, état, boost, désactivation.",
    "vendre.desc.messages": "Réponds vite: négociation, rendez-vous, sécurité.",
    "vendre.desc.livraison": "Remise en main propre, envoi, paiement, confirmation.",

    "vendre.publier.rubrics": "Rubriques Publier",
    "vendre.publier.titre.t": "Titre",
    "vendre.publier.titre.d": "Un titre clair et premium: ce que c’est, marque, taille, état.",
    "vendre.publier.photos.t": "Photos",
    "vendre.publier.photos.d": "Photos nettes: lumière, angles, détails (premium).",
    "vendre.publier.prix.t": "Prix",
    "vendre.publier.prix.d": "Fixe un prix juste: compare, négociation possible, urgent.",
    "vendre.publier.categorie.t": "Catégorie",
    "vendre.publier.categorie.d": "Choisis la catégorie et les tags pour être trouvé vite.",

    "vendre.gerer.rubrics": "Rubriques Gérer",
    "vendre.gerer.stock.t": "Stock",
    "vendre.gerer.stock.d": "Quantité, disponibilité, réservations: tout clair.",
    "vendre.gerer.etat.t": "État",
    "vendre.gerer.etat.d": "Mets à jour l’état: vendu, en cours, réservé.",
    "vendre.gerer.boost.t": "Boost",
    "vendre.gerer.boost.d": "Boost premium: mise en avant et visibilité (bientôt).",
    "vendre.gerer.desactiver.t": "Désactiver",
    "vendre.gerer.desactiver.d": "Désactive temporairement sans perdre l’annonce.",

    "vendre.messages.rubrics": "Rubriques Messages",
    "vendre.messages.reponses.t": "Réponses",
    "vendre.messages.reponses.d": "Réponds vite et reste précis: ça vend.",
    "vendre.messages.negociation.t": "Négociation",
    "vendre.messages.negociation.d": "Négocie avec respect: propose un prix clair.",
    "vendre.messages.rdv.t": "Rendez-vous",
    "vendre.messages.rdv.d": "Fixe un lieu/heure et confirme les détails.",
    "vendre.messages.securite.t": "Sécurité",
    "vendre.messages.securite.d": "Règles: lieu public, prudence, vérifications.",

    "vendre.livraison.rubrics": "Rubriques Livraison",
    "vendre.livraison.mainpropre.t": "Main propre",
    "vendre.livraison.mainpropre.d": "Remise en main propre dans un lieu sûr.",
    "vendre.livraison.envoi.t": "Envoi",
    "vendre.livraison.envoi.d": "Envoi: colis, suivi, délais (premium).",
    "vendre.livraison.paiement.t": "Paiement",
    "vendre.livraison.paiement.d": "Paiement non traité par Eternua · fonction en préparation.",
    "vendre.livraison.confirmation.t": "Confirmation",
    "vendre.livraison.confirmation.d": "Confirmation de remise et clôture de la vente.",

    "donner.title": "Donner",
    "donner.hint": "Donner · Échanger · Entraide · Collectes",
    "donner.tabs": "Catégories Donner",
    "donner.detail": "Détail",
    "donner.soon": "Cette section est en construction. Utilise la navigation de gauche sur PC pour explorer toutes les rubriques.",
    "donner.tab.donner": "Donner",
    "donner.tab.echanger": "Échanger",
    "donner.tab.entraide": "Entraide",
    "donner.tab.collectes": "Collectes",
    "donner.desc.donner": "Dons locaux, objets, vêtements, matériel.",
    "donner.desc.echanger": "Échanges simples et alignés, sans prise de tête.",
    "donner.desc.entraide": "Entraide entre membres: coups de main, soutien, réseau.",
    "donner.desc.collectes": "Collectes solidaires: transparence, suivi, confiance.",

    "donner.donner.rubrics": "Rubriques Donner",
    "donner.donner.publier.t": "Publier",
    "donner.donner.publier.d": "Publie un don: description, état, zone, disponibilité.",
    "donner.donner.localiser.t": "Localiser",
    "donner.donner.localiser.d": "Localise le don et définis un lieu de remise sécurisé.",
    "donner.donner.conditions.t": "Conditions",
    "donner.donner.conditions.d": "Fixe des conditions simples: gratuit, échange possible, priorité.",
    "donner.donner.rejoindre.t": "Rejoindre",
    "donner.donner.rejoindre.d": "Réserve un don et confirme la remise via chat.",

    "donner.echanger.rubrics": "Rubriques Échanger",
    "donner.echanger.proposer.t": "Proposer",
    "donner.echanger.proposer.d": "Propose un échange clair: objet, valeur, attentes.",
    "donner.echanger.negocier.t": "Négocier",
    "donner.echanger.negocier.d": "Négociation simple et respectueuse: accord rapide.",
    "donner.echanger.securite.t": "Sécurité",
    "donner.echanger.securite.d": "Conseils de sécurité: lieux publics, validation, prudence.",
    "donner.echanger.finaliser.t": "Finaliser",
    "donner.echanger.finaliser.d": "Finalise l’échange et laisse un retour (bientôt).",

    "donner.entraide.rubrics": "Rubriques Entraide",
    "donner.entraide.besoin.t": "Besoin",
    "donner.entraide.besoin.d": "Exprime un besoin: clair, respectueux, réaliste.",
    "donner.entraide.proposer.t": "Proposer",
    "donner.entraide.proposer.d": "Propose ton aide: temps, compétences, matériel.",
    "donner.entraide.reseau.t": "Réseau",
    "donner.entraide.reseau.d": "Active ton réseau: amis, voisins, communautés.",
    "donner.entraide.retour.t": "Retour",
    "donner.entraide.retour.d": "Retour d’expérience et gratitude: renforce la confiance.",

    "donner.collectes.rubrics": "Rubriques Collectes",
    "donner.collectes.lancer.t": "Lancer",
    "donner.collectes.lancer.d": "Lance une collecte: objectif, durée, transparence.",
    "donner.collectes.dons.t": "Dons",
    "donner.collectes.dons.d": "Recevoir des dons: messages, preuves, suivi (premium).",
    "donner.collectes.transparence.t": "Transparence",
    "donner.collectes.transparence.d": "Transparence: justification, dépenses, preuves.",
    "donner.collectes.suivi.t": "Suivi",
    "donner.collectes.suivi.d": "Suivi public/privé: avancement, étapes, clôture.",

    "services.title": "Services",
    "services.hint": "Proposer · Demander · Trouver · Devis",
    "services.tabs": "Catégories Services",
    "services.detail": "Détail",
    "services.soon": "Cette section est en construction. Utilise la navigation de gauche sur PC pour explorer toutes les rubriques.",
    "services.tab.proposer": "Proposer",
    "services.tab.demander": "Demander",
    "services.tab.trouver": "Trouver",
    "services.tab.devis": "Devis",
    "services.desc.proposer": "Propose tes services et tes compétences.",
    "services.desc.demander": "Demande un service: besoin, budget, zone.",
    "services.desc.trouver": "Trouve des prestataires par avis, prix, proximité.",
    "services.desc.devis": "Devis, conditions, paiement, suivi (premium).",

    "services.proposer.rubrics": "Rubriques Proposer",
    "services.proposer.publier.t": "Publier",
    "services.proposer.publier.d": "Publie un service clair: catégorie, description, zone, disponibilité.",
    "services.proposer.tarifs.t": "Tarifs",
    "services.proposer.tarifs.d": "Tarifs simples: horaire, forfait, pack. Transparence premium.",
    "services.proposer.planning.t": "Planning",
    "services.proposer.planning.d": "Gère tes créneaux et confirme tes demandes (bientôt).",
    "services.proposer.avis.t": "Avis",
    "services.proposer.avis.d": "Avis et réputation: inspire confiance, montre tes réussites.",

    "services.demander.rubrics": "Rubriques Demander",
    "services.demander.decrire.t": "Décrire",
    "services.demander.decrire.d": "Décris ton besoin: objectif, contrainte, délai, budget.",
    "services.demander.budget.t": "Budget",
    "services.demander.budget.d": "Indique un budget ou une fourchette pour attirer les bons profils.",
    "services.demander.zone.t": "Zone",
    "services.demander.zone.d": "Choisis une zone: à domicile, à distance, ou hybride.",
    "services.demander.urgence.t": "Urgence",
    "services.demander.urgence.d": "Besoin urgent? Marque le niveau d’urgence (premium).",

    "services.trouver.rubrics": "Rubriques Trouver",
    "services.trouver.parcourir.t": "Parcourir",
    "services.trouver.parcourir.d": "Parcours les services: catégorie, zone, disponibilité, avis.",
    "services.trouver.filtrer.t": "Filtrer",
    "services.trouver.filtrer.d": "Filtre par prix, distance, note, type de prestation.",
    "services.trouver.contacter.t": "Contacter",
    "services.trouver.contacter.d": "Contact direct: clarifie le besoin et valide un créneau.",
    "services.trouver.securite.t": "Sécurité",
    "services.trouver.securite.d": "Règles de sécurité et bonnes pratiques (premium).",

    "services.devis.rubrics": "Rubriques Devis",
    "services.devis.comparaison.t": "Comparer",
    "services.devis.comparaison.d": "Compare plusieurs devis: prix, délai, garanties.",
    "services.devis.conditions.t": "Conditions",
    "services.devis.conditions.d": "Conditions claires: scope, révisions, annulation.",
    "services.devis.paiement.t": "Paiement",
    "services.devis.paiement.d": "Paiement non traité par Eternua · fonction en préparation.",
    "services.devis.suivi.t": "Suivi",
    "services.devis.suivi.d": "Suivi: messages, validation, clôture (premium).",

    "sortie.title": "Sortie",
    "sortie.hint": "Événements · Sorties · Rencontres · Clubs",
    "sortie.tabs": "Catégories Sortie",
    "sortie.detail": "Détail",
    "sortie.soon": "Cette section est en construction. Utilise la navigation de gauche sur PC pour explorer toutes les rubriques.",
    "sortie.tab.events": "Événements",
    "sortie.tab.sorties": "Sorties",
    "sortie.tab.rencontres": "Rencontres",
    "sortie.tab.clubs": "Clubs",
    "sortie.desc.events": "Agenda premium, événements, soirées.",
    "sortie.desc.sorties": "Proposer et rejoindre des sorties locales.",
    "sortie.desc.rencontres": "Rencontres bienveillantes et thématiques.",
    "sortie.desc.clubs": "Clubs et groupes: organiser, discuter, se retrouver.",

    "sortie.events.rubrics": "Rubriques Événements",
    "sortie.events.agenda.t": "Agenda",
    "sortie.events.agenda.d": "Un agenda premium: date, lieu, thème, billets (bientôt).",
    "sortie.events.proposer.t": "Proposer",
    "sortie.events.proposer.d": "Propose un événement: infos claires, places, ambiance.",
    "sortie.events.filtrer.t": "Filtrer",
    "sortie.events.filtrer.d": "Filtre par ville, date, budget, style, sécurité.",
    "sortie.events.rejoindre.t": "Rejoindre",
    "sortie.events.rejoindre.d": "Rejoins un événement et discute avant d’y aller.",

    "sortie.sorties.rubrics": "Rubriques Sorties",
    "sortie.sorties.lieux.t": "Lieux",
    "sortie.sorties.lieux.d": "Bars, parcs, musées, balades: découvre des lieux.",
    "sortie.sorties.groupes.t": "Groupes",
    "sortie.sorties.groupes.d": "Sorties en groupe: plus simple, plus safe, plus fun.",
    "sortie.sorties.moments.t": "Moments",
    "sortie.sorties.moments.d": "Dîner, cinéma, balade, café: des moments alignés.",
    "sortie.sorties.chat.t": "Chat",
    "sortie.sorties.chat.d": "Chat dédié à la sortie: organise et confirme.",

    "sortie.rencontres.rubrics": "Rubriques Rencontres",
    "sortie.rencontres.match.t": "Match",
    "sortie.rencontres.match.d": "Rencontres par affinités: centres d’intérêt, vibe.",
    "sortie.rencontres.securite.t": "Sécurité",
    "sortie.rencontres.securite.d": "Règles et outils: rencontres saines et respectueuses.",
    "sortie.rencontres.themes.t": "Thèmes",
    "sortie.rencontres.themes.d": "Rencontres thématiques: culture, sport, spiritualité.",
    "sortie.rencontres.inviter.t": "Inviter",
    "sortie.rencontres.inviter.d": "Invite des amis ou propose une rencontre ouverte.",

    "sortie.clubs.rubrics": "Rubriques Clubs",
    "sortie.clubs.rechercher.t": "Rechercher",
    "sortie.clubs.rechercher.d": "Trouve un club par ville, thème, niveau, planning.",
    "sortie.clubs.creer.t": "Créer",
    "sortie.clubs.creer.d": "Crée un club premium: règles, objectifs, accueil.",
    "sortie.clubs.planning.t": "Planning",
    "sortie.clubs.planning.d": "Planning partagé: dates, lieux, rappels (bientôt).",
    "sortie.clubs.regles.t": "Règles",
    "sortie.clubs.regles.d": "Règles claires: respect, sécurité, bienveillance.",

    "voyage.title": "Voyage",
    "voyage.hint": "Destinations · Itinéraire · Co-voyage · Hébergement",
    "voyage.tabs": "Catégories Voyage",
    "voyage.detail": "Détail",
    "voyage.soon": "Cette section est en construction. Utilise la navigation de gauche sur PC pour explorer toutes les rubriques.",
    "voyage.tab.destinations": "Destinations",
    "voyage.tab.itineraire": "Itinéraire",
    "voyage.tab.covoyage": "Co-voyage",
    "voyage.tab.hebergement": "Hébergement",
    "voyage.tab.conseils": "Conseils",
    "voyage.desc.destinations": "Découvre et choisis ta prochaine destination.",
    "voyage.desc.itineraire": "Planifie ton itinéraire et ton rythme.",
    "voyage.desc.covoyage": "Trouve des co-voyageurs alignés et bienveillants.",
    "voyage.desc.hebergement": "Hébergements, échanges, bons plans.",
    "voyage.desc.conseils": "Conseils pratiques, sécurité, culture locale.",

    "voyage.destinations.rubrics": "Rubriques Destinations",
    "voyage.destinations.decouvrir.t": "Découvrir",
    "voyage.destinations.decouvrir.d": "Explore des destinations par ambiance, saison, budget (premium).",
    "voyage.destinations.tendances.t": "Tendances",
    "voyage.destinations.tendances.d": "Voir ce qui bouge: lieux, événements, communautés.",
    "voyage.destinations.budget.t": "Budget",
    "voyage.destinations.budget.d": "Estime coût, transport, nourriture, hébergement.",
    "voyage.destinations.securite.t": "Sécurité",
    "voyage.destinations.securite.d": "Conseils, zones, comportements, prudence.",

    "voyage.itineraire.rubrics": "Rubriques Itinéraire",
    "voyage.itineraire.planifier.t": "Planifier",
    "voyage.itineraire.planifier.d": "Bâtis un itinéraire clair: étapes, durée, priorités.",
    "voyage.itineraire.jours.t": "Jours & étapes",
    "voyage.itineraire.jours.d": "Organise par jours: lieux, temps, réservations.",
    "voyage.itineraire.checklist.t": "Checklist",
    "voyage.itineraire.checklist.d": "Documents, affaires, santé: prépare sans stress.",
    "voyage.itineraire.partager.t": "Partager",
    "voyage.itineraire.partager.d": "Partage ton itinéraire avec des amis ou co-voyageurs.",

    "voyage.covoyage.rubrics": "Rubriques Co-voyage",
    "voyage.covoyage.trouver.t": "Trouver",
    "voyage.covoyage.trouver.d": "Trouve des co-voyageurs par destination, dates, vibe.",
    "voyage.covoyage.profil.t": "Profil",
    "voyage.covoyage.profil.d": "Présente ton style: budget, rythme, centres d’intérêt.",
    "voyage.covoyage.match.t": "Match",
    "voyage.covoyage.match.d": "Match responsable: objectifs, limites, sécurité.",
    "voyage.covoyage.chat.t": "Chat",
    "voyage.covoyage.chat.d": "Échange et organise avant de partir.",

    "voyage.hebergement.rubrics": "Rubriques Hébergement",
    "voyage.hebergement.chercher.t": "Chercher",
    "voyage.hebergement.chercher.d": "Trouve un hébergement selon ton budget et tes besoins.",
    "voyage.hebergement.partager.t": "Partager",
    "voyage.hebergement.partager.d": "Propose un hébergement ou un échange (premium).",
    "voyage.hebergement.dates.t": "Dates",
    "voyage.hebergement.dates.d": "Gère disponibilités, périodes et confirmations.",
    "voyage.hebergement.regles.t": "Règles",
    "voyage.hebergement.regles.d": "Clarifie les règles pour une expérience sereine.",

    "voyage.conseils.rubrics": "Rubriques Conseils",
    "voyage.conseils.formalites.t": "Formalités",
    "voyage.conseils.formalites.d": "Passeport, visas, assurances (premium).",
    "voyage.conseils.sante.t": "Santé",
    "voyage.conseils.sante.d": "Vaccins, médicaments, prévention.",
    "voyage.conseils.culture.t": "Culture",
    "voyage.conseils.culture.d": "Respect local, codes, bonnes pratiques.",
    "voyage.conseils.astuces.t": "Astuces",
    "voyage.conseils.astuces.d": "Astuces budget, transport, organisation.",

    "sportloisir.title": "Sport & loisirs",
    "sportloisir.hint": "Sport · Loisirs · Sorties · Clubs",
    "sportloisir.tabs": "Catégories Sport & loisirs",
    "sportloisir.detail": "Détail",
    "sportloisir.tab.sport": "Sport",
    "sportloisir.tab.loisirs": "Loisirs",
    "sportloisir.tab.sorties": "Sorties",
    "sportloisir.tab.clubs": "Clubs",
    "sportloisir.tab.randonnee": "Randonnée",
    "sportloisir.tab.fitness": "Fitness",
    "sportloisir.tab.danse": "Danse",
    "sportloisir.tab.musique": "Musique",
    "sportloisir.tab.jeux": "Jeux",
    "sportloisir.tab.culture": "Culture",
    "sportloisir.tab.yoga": "Yoga",
    "sportloisir.tab.course": "Course",
    "sportloisir.tab.velo": "Vélo",
    "sportloisir.tab.natation": "Natation",
    "sportloisir.tab.arts_martiaux": "Arts martiaux",
    "sportloisir.tab.cinema": "Cinéma",
    "sportloisir.tab.lecture": "Lecture",
    "sportloisir.tab.cuisine": "Cuisine",
    "sportloisir.tab.photo": "Photo",
    "sportloisir.tab.gaming": "Gaming",
    "sportloisir.desc.sport": "Matchs, sessions, partenaires d’entraînement.",
    "sportloisir.desc.loisirs": "Loisirs, ateliers, activités à partager.",
    "sportloisir.desc.sorties": "Sorties et événements: propose, rejoins, découvre.",
    "sportloisir.desc.clubs": "Clubs et groupes: planning, messages, rencontres.",
    "sportloisir.desc.randonnee": "Randonnées, sentiers, groupes nature.",
    "sportloisir.desc.fitness": "Fitness, musculation, bien-être, routines.",
    "sportloisir.desc.danse": "Danse: cours, soirées, partenaires.",
    "sportloisir.desc.musique": "Musique: jam, concerts, groupes.",
    "sportloisir.desc.jeux": "Jeux: jeux de société, gaming, soirées.",
    "sportloisir.desc.culture": "Culture: expos, cinéma, livres, musées.",
    "sportloisir.desc.yoga": "Yoga, respiration, flow, relaxation.",
    "sportloisir.desc.course": "Running, fractionné, endurance, sorties.",
    "sportloisir.desc.velo": "Vélo: route, VTT, balades, groupes.",
    "sportloisir.desc.natation": "Natation: piscines, sessions, progression.",
    "sportloisir.desc.arts_martiaux": "Arts martiaux: entraînements, clubs, sparring.",
    "sportloisir.desc.cinema": "Cinéma: sorties, films, discussions.",
    "sportloisir.desc.lecture": "Lecture: clubs, recommandations, échanges.",
    "sportloisir.desc.cuisine": "Cuisine: recettes, ateliers, rencontres.",
    "sportloisir.desc.photo": "Photo: sorties, projets, critiques bienveillantes.",
    "sportloisir.desc.gaming": "Gaming: sessions, co-op, tournois (premium).",
    "sportloisir.soon": "Cette section est en construction. Utilise la navigation de gauche pour changer de rubrique (desktop).",

    "sportloisir.more": "Plus",
    "sportloisir.more_open": "Ouvrir plus de catégories",
    "sportloisir.more_close": "Fermer",

    "sportloisir.sport.rubrics": "Rubriques Sport",
    "sportloisir.sport.publier.t": "Publier",
    "sportloisir.sport.publier.d": "Publie une session: sport, lieu, date, nombre de places (premium).",
    "sportloisir.sport.trouver.t": "Trouver",
    "sportloisir.sport.trouver.d": "Découvre des sessions autour de toi: par sport, zone, horaire.",
    "sportloisir.sport.niveau.t": "Niveau",
    "sportloisir.sport.niveau.d": "Débutant à expert: affiche un niveau pour des matchs équilibrés.",
    "sportloisir.sport.rejoindre.t": "Rejoindre",
    "sportloisir.sport.rejoindre.d": "Rejoins une session et discute avec le groupe avant de venir.",

    "sportloisir.loisirs.rubrics": "Rubriques Loisirs",
    "sportloisir.loisirs.idees.t": "Idées",
    "sportloisir.loisirs.idees.d": "Découvre des idées premium: jeux, sorties, passions, activités.",
    "sportloisir.loisirs.ateliers.t": "Ateliers",
    "sportloisir.loisirs.ateliers.d": "Ateliers locaux: créatif, musique, danse, apprentissages.",
    "sportloisir.loisirs.partager.t": "Partager",
    "sportloisir.loisirs.partager.d": "Propose une activité et trouve des gens motivés et bienveillants.",
    "sportloisir.loisirs.reservations.t": "Réservations",
    "sportloisir.loisirs.reservations.d": "Bientôt: réservations, rappels, organisation simple.",

    "sportloisir.sorties.rubrics": "Rubriques Sorties",
    "sportloisir.sorties.evenements.t": "Événements",
    "sportloisir.sorties.evenements.d": "Agenda premium: événements publics et sorties privées.",
    "sportloisir.sorties.proposer.t": "Proposer",
    "sportloisir.sorties.proposer.d": "Propose une sortie: lieu, heure, thème, nombre de places.",
    "sportloisir.sorties.filtrer.t": "Filtrer",
    "sportloisir.sorties.filtrer.d": "Filtre par ville, date, type, budget, ambiance.",
    "sportloisir.sorties.securite.t": "Sécurité",
    "sportloisir.sorties.securite.d": "Règles de respect, blocage, signalement: sorties sereines.",

    "sportloisir.clubs.rubrics": "Rubriques Clubs",
    "sportloisir.clubs.clubs.t": "Clubs",
    "sportloisir.clubs.clubs.d": "Bientôt: pages club, présentation, règles, responsables.",
    "sportloisir.clubs.groupes.t": "Groupes",
    "sportloisir.clubs.groupes.d": "Crée un groupe: objectifs, niveau, fréquence, zone.",
    "sportloisir.clubs.planning.t": "Planning",
    "sportloisir.clubs.planning.d": "Planifie les sessions et partage les infos clés.",
    "sportloisir.clubs.messages.t": "Messages",
    "sportloisir.clubs.messages.d": "Chat dédié pour organiser sans se perdre (premium).",

    "animaux.title": "Animaux",
    "animaux.hint": "Adoption · Garde · Entraide · Animaux perdus",
    "animaux.tabs": "Catégories Animaux",
    "animaux.detail": "Détail",
    "animaux.tab.adoption": "Adoption",
    "animaux.tab.garde": "Garde",
    "animaux.tab.entraide": "Entraide",
    "animaux.tab.perdus": "Animaux perdus",
    "animaux.desc.adoption": "Adopter, proposer à l’adoption, protéger.",
    "animaux.desc.garde": "Trouver une garde de confiance ou proposer la tienne.",
    "animaux.desc.entraide": "Entraide locale: transport, nourriture, urgences.",
    "animaux.desc.perdus": "Signalements et alertes pour retrouver un animal.",
    "animaux.soon": "Cette section est en construction. Utilise la navigation de gauche pour changer de rubrique (desktop).",

    "animaux.adoption.rubrics": "Rubriques Adoption",
    "animaux.adoption.publier.t": "Publier",
    "animaux.adoption.publier.d": "Publie un animal à adopter ou une demande d’adoption, avec localisation et détails.",
    "animaux.adoption.parcourir.t": "Parcourir",
    "animaux.adoption.parcourir.d": "Découvre les animaux disponibles autour de toi, par espèce et critères.",
    "animaux.adoption.favori.t": "Favoris",
    "animaux.adoption.favori.d": "Retrouve les annonces enregistrées et suis leur disponibilité.",
    "animaux.adoption.compat.t": "Compatibilité",
    "animaux.adoption.compat.d": "Maison, temps, enfants, autres animaux: trouve un match responsable.",
    "animaux.adoption.rencontre.t": "Rencontre",
    "animaux.adoption.rencontre.d": "Contacte, échange, organise une rencontre avant l’adoption.",

    "animaux.garde.rubrics": "Rubriques Garde",
    "animaux.garde.proposer.t": "Proposer une garde",
    "animaux.garde.proposer.d": "Propose ton aide: visites, promenades, garde à domicile, garde chez toi.",
    "animaux.garde.demander.t": "Demander une garde",
    "animaux.garde.demander.d": "Décris dates, besoins et habitudes pour trouver une garde adaptée.",
    "animaux.garde.calendrier.t": "Calendrier",
    "animaux.garde.calendrier.d": "Planifie les périodes, confirme la disponibilité et organise la passation.",
    "animaux.garde.confiance.t": "Confiance & sécurité",
    "animaux.garde.confiance.d": "Échanges clairs, règles, preuves, contact: une garde sereine.",

    "animaux.entraide.rubrics": "Rubriques Entraide",
    "animaux.entraide.urgence.t": "Urgences",
    "animaux.entraide.urgence.d": "Aide rapide pour un animal en détresse: conseils, relais, urgence vétérinaire.",
    "animaux.entraide.nourriture.t": "Nourriture & matériel",
    "animaux.entraide.nourriture.d": "Don, prêt, partage: croquettes, litière, accessoires.",
    "animaux.entraide.transport.t": "Transport",
    "animaux.entraide.transport.d": "Covoiturage, trajet véto, relais: aide logistique locale.",
    "animaux.entraide.conseils.t": "Conseils",
    "animaux.entraide.conseils.d": "Questions, éducation, santé: communauté d’entraide (premium).",

    "animaux.perdus.rubrics": "Rubriques Animaux perdus",
    "animaux.perdus.signaler.t": "Signaler",
    "animaux.perdus.signaler.d": "Signale un animal perdu ou trouvé: lieu, date, photo (bientôt).",
    "animaux.perdus.recherche.t": "Rechercher",
    "animaux.perdus.recherche.d": "Parcours les alertes autour de toi et filtre par espèce et zone.",
    "animaux.perdus.alerte.t": "Alerte",
    "animaux.perdus.alerte.d": "Active des alertes par zone pour être prévenu quand ça compte.",
    "animaux.perdus.retrouver.t": "Retrouver",
    "animaux.perdus.retrouver.d": "Coordonne la communauté et valide quand l’animal est retrouvé.",

    "civet.search_ph": "Rechercher une civilisation E.T…",
    "civet.hint": "Civilisations alliees · Acces rapide aux fiches",
    "civet.hub": "Voir toutes les civilisations",
    "civtemple.kicker": "TEMPLE DES CIVILISATIONS EVOLUEES",
    "civtemple.title": "Civilisations E.T alliées — Ponts de l’Infini d’Infini",

    "civhub.title": "Temple central des Alliances cosmiques",
    "civhub.subtitle": "Ce Temple est le hub principal des 12 civilisations E.T alliées a la Terre. Il affiche une carte cosmique des routes sacrees, une ligne du temps intergalactique et un acces direct au Livre sacre des Civilisations E.T.",
    "civhub.open_book": "Ouvrir le Livre des 12 alliances",
    "civhub.enter_temple_of": "Entrer dans le Temple de",

    "ia40.title": "Rôle des 40 IA humaines",
    "ia40.hint": "4 familles · 10 IA chacune",
    "ia40.f1": "1. IA du soin & de la conscience",
    "ia40.f2": "2. Justice & stabilité sociale",
    "ia40.f3": "3. Terre & systèmes",
    "ia40.f4": "4. IA cosmique & intermondes",

    "langnote.kicker": "Traduction",
    "langnote.title": "Version anglaise du contenu",
    "langnote.text": "Vous consultez la traduction anglaise. Vous pouvez revenir au texte français à tout moment.",
    "langnote.to_fr": "Passer en francais",

    "auth.login": "Connexion",
    "auth.register": "Inscription",
    "auth.logout": "Deconnexion",

    "nav.home": "Accueil",
    "nav.temple": "Temple",
    "nav.forum": "Forum",
    "nav.book": "Livre sacre",
    "nav.profile": "Profil",
    "nav.notifications.open": "Ouvrir l’historique des notifications",
    "nav.notifications": "Notifications",
    "nav.friends": "Amis",
    "nav.friends_feed": "Fil d’actualite (amis)",
    "nav.friends_lounge": "Salon amis",
    "nav.temples": "Temples",
    "nav.creator_temple": "Temple du Createur",
    "nav.admin": "Administration",

    "theme.mode_dark": "Mode sombre",
    "theme.mode_light": "Mode clair",

    "dock.join": "Rejoindre",
    "dock.join_call_aria": "Rejoindre l'appel video",
    "dock.discussions": "Discussions",
    "dock.open_discussions": "Ouvrir les discussions",
    "dock.close_discussions": "Fermer les discussions",
    "dock.unread_messages": "Nouveaux messages",
    "dock.back_home": "Retour a l'accueil",
    "dock.friends_actions": "Actions amis",
    "dock.feed": "Actu",
    "dock.music": "Musique",
    "dock.friends": "Amis",
    "dock.requests": "Demandes",
    "dock.new": "Nouveaux",
    "dock.calls": "Appels",
    "dock.lounge": "Salon amis",
    "dock.hidden_guest": "Connecte toi pour voir tes amis et profiter du site",
    "dock.hidden_authed": "Regarde tes amis et agrandi ton reseau infini",

    "book.writing": "Texte en cours d’écriture…",
    "book.chapters": "Chapitres",
    "book.search": "Rechercher un chapitre...",
    "book.your_favs": "Vos chapitres favoris",
    "book.favorite": "favori",
    ...VOYAGE_DELUXE_TRANSLATIONS.fr,
    ...IMMOBILIER_TRANSLATIONS.fr,
    ...SUBSCRIPTION_TRANSLATIONS,
    ...TRUST_TRANSLATIONS,
    ...JOURNEY_TRANSLATIONS.fr,
    ...STUDIO_TRANSLATIONS.fr,
    ...LIVE_MAP_TRANSLATIONS,
    ...DAILY_CIRCLE_TRANSLATIONS.fr,
    ...INFINI_TRANSLATIONS.fr,
    ...CONFIRMATION_TRANSLATIONS.fr,
  },
  en: {
    ...SUPPORT_TRANSLATIONS.en,
    ...PROJECT_TRANSLATIONS.en,
    // Fill untranslated module keys; the existing English catalogs take priority.
    ...ENGLISH_SUPPLEMENT_TRANSLATIONS,
    ...NAVIGATION_TRANSLATIONS.en,
    ...WELCOME_TRANSLATIONS.en,
    ...SHELL_TRANSLATIONS.en,
    ...MEMBER_HOME_TRANSLATIONS.en,
    "acheter.mobile.browse": "Discover",
    "acheter.mobile.filters": "Filters",
    "acheter.mobile.favorites": "Favorites",
    "acheter.mobile.messages": "Messages",
    "acheter.mobile.orders": "My purchases",
    "acheter.mobile.open_browse": "View listings",
    "acheter.mobile.open_filters": "Open filters",
    "acheter.mobile.open_favorites": "View favorites",
    "acheter.mobile.open_messages": "Open messages",
    "acheter.mobile.open_orders": "Track purchases",
    "acheter.mobile.intro": "Find, choose and track your purchases.",
    "acheter.mobile.shortcuts": "Quick access",
    "acheter.mobile.cart": "Cart",
    "lang.name": "English",
    "lang.select": "Language",

    "header.invite_et": "E.T Invitation",
    "header.search_et_ph": "Search E.T…",

    "subnav.temple_ia40": "Temple of the 40 Human AIs",
    "subnav.temple_et": "E.T Civilisations Temple",

    "ribbon.badge": "Under construction",
    "ribbon.text": "This premium section is being built (local).",
    "ribbon.cta": "E.T Invitation",

    "nav.market.emploi": "Jobs",
    "nav.market.vendre": "Sell",
    "nav.market.acheter": "Buy",
    "nav.market.donner": "Give",
    "nav.market.services": "Services",
    "nav.market.sortie": "Outings",
    "nav.market.voyage": "Travel",
    "nav.market.sport_loisir": "Sports & leisure",
    "nav.market.animaux": "Animals",
    "nav.media.music": "Music & clips",

    "music.title": "Music",
    "music.hint": "Music · Clips · Comments · Playlists",
    "music.kicker": "Media",
    "music.page_title": "Music & Video Clips",
    "music.page_sub": "Listen online, playlists, favorites, comments, rankings. Clips via YouTube (upload coming soon).",
    "music.tabs": "Music categories",
    "music.detail": "Detail",

    "music.tab.genres": "Genres",
    "music.tab.recherche": "Search",
    "music.tab.classement": "Ranking",
    "music.tab.playlists": "Playlists",
    "music.tab.favoris": "Favorites",
    "music.tab.clips": "Clips",
    "music.tab.telecharger": "Upload",
    "music.tab.parametres": "Settings",

    "music.desc.genres": "Categories, trends, search and new releases.",
    "music.desc.recherche": "Search tracks by title, artist, genre or category.",
    "music.desc.classement": "Top views, ratings, likes. Rankings by vibe and genre.",
    "music.desc.playlists": "Create and manage playlists. Share and quick play.",
    "music.desc.favoris": "Watch later, likes, history, favorites by playlist.",
    "music.desc.clips": "Video clips via YouTube. Clip upload: coming soon.",
    "music.desc.telecharger": "Upload your music, assign to slots (IA / E.T), manage your online library.",
    "music.desc.parametres": "Add tracks (URL), configure local storage and preferences.",

    "music.search": "Search",
    "music.search.ph": "Search by title…",
    "music.search.hint": "Type a title to filter the library.",
    "music.search.count": "Results",
    "music.search.empty.t": "No results",
    "music.search.empty.d": "Try another keyword.",
    "music.search.rubrics": "Search rubrics",
    "music.search.rubric.t": "Search by title",
    "music.search.rubric.d": "Quickly find a track by name, artist, genre or category.",

    "music.upload.rubrics": "Upload rubrics",
    "music.upload.slots.t": "Slots",
    "music.upload.slots.d": "Assign a track to a Human AI or an E.T civilisation slot.",
    "music.upload.bulk.t": "Upload",
    "music.upload.bulk.d": "Bulk upload: multiple files, auto-assignment if well named.",
    "music.upload.rights.t": "Rights",
    "music.upload.rights.d": "Confirm your rights before publishing online.",
    "music.upload.library.t": "Library",
    "music.upload.library.d": "Manage your online library: view, open, delete.",

    "music.library": "Library",
    "music.player": "Player",
    "music.filters": "Filters",
    "music.filter.genre": "Genre",
    "music.genre.all": "All",
    "music.genre.other": "Other",

    "music.meta.likes": "Likes",
    "music.meta.later": "Later",
    "music.meta.comments": "Comments",

    "music.rank.mode": "Ranking",
    "music.rank.views": "Views",
    "music.rank.ratings": "Ratings",
    "music.rank.likes": "Likes",

    "music.like": "Like",
    "music.later": "Watch later",
    "music.share": "Share",
    "music.toast.copied": "Link copied",
    "music.toast.cleared": "Local data cleared",
    "music.toast.added": "Added",
    "music.toast.need_title_mp3": "Title + MP3 URL required",
    "music.toast.need_youtube": "YouTube link required",
    "music.toast.added_clip": "Clip added",
    "music.toast.playlist_created": "Playlist created",
    "music.toast.added_to_playlist": "Added to playlist",

    "music.rating": "Rating",
    "music.rating_clear": "Clear rating",
    "music.playlist.add": "Add",
    "music.playlist.choose": "Playlist…",
    "music.open_youtube": "Open on YouTube",

    "music.comments": "Comments",
    "music.comment.add": "Add a comment",
    "music.comment.emoji_ph": "Emoji (optional)",
    "music.comment.media_ph": "Image/video link (optional)",
    "music.comment.text_ph": "Write your comment…",
    "music.comment.reply_ph": "Reply to (optional id)",
    "music.comment.post": "Post",
    "music.comment.open_media": "Open media",
    "music.comments.empty": "No comments yet.",

    "music.playlists.title": "Playlists",
    "music.playlists.name_ph": "Playlist name",
    "music.playlists.create": "Create",
    "music.playlists.remove": "Remove",
    "music.playlists.empty": "Add tracks from the player.",
    "music.playlists.none": "No playlist",

    "music.settings": "Settings",
    "music.settings.add_track": "Add a track (URL)",
    "music.settings.title_ph": "Title",
    "music.settings.artist_ph": "Artist",
    "music.settings.genre_ph": "Genre",
    "music.settings.mp3_ph": "MP3 URL (https://...)",
    "music.settings.youtube_ph": "YouTube URL (optional)",
    "music.settings.add": "Add",
    "music.settings.add_clip": "Add a clip (YouTube)",
    "music.settings.clip_title_ph": "Title",
    "music.settings.clip_cat_ph": "Category",
    "music.settings.clip_url_ph": "YouTube link (https://...)",
    "music.settings.clip_upload_soon": "Clip upload to server: coming soon.",
    "music.settings.storage": "Local storage",
    "music.settings.storage_note": "Demo data (likes, views, playlists, comments) stored in your browser.",
    "music.settings.clear": "Clear",

    "music.fav.empty.t": "No favorites",
    "music.fav.empty.d": "Click ♥ or ⏳ on a track to find it here.",
    "music.no_track": "No track",

    "music.clips.title": "Video clips",
    "music.clips.note": "Clips via YouTube. Server upload: coming soon.",
    "music.clips.source": "Source",
    "music.clips.bad_url": "Invalid YouTube link",
    "music.clips.empty": "No clip",

    "music.genres.rubrics": "Genres rubrics",
    "music.genres.categories.t": "Categories",
    "music.genres.categories.d": "Browse by style: rap, pop, electro, rock, ambient, cinematic and more.",
    "music.genres.tendances.t": "Trends",
    "music.genres.tendances.d": "What’s rising: new releases, shares, community favorites.",
    "music.genres.recherche.t": "Search",
    "music.genres.recherche.d": "Find a track, an artist or a vibe. Sharing creates a direct link.",
    "music.genres.nouveautes.t": "New",
    "music.genres.nouveautes.d": "Latest additions and listens. A living premium feed.",

    "music.classement.rubrics": "Ranking rubrics",
    "music.classement.vues.t": "Views",
    "music.classement.vues.d": "Top most listened tracks.",
    "music.classement.notes.t": "Ratings",
    "music.classement.notes.d": "Ranking by stars and appreciation.",
    "music.classement.jaime.t": "Likes",
    "music.classement.jaime.d": "Tracks you liked and what’s circulating.",
    "music.classement.categories.t": "By categories",
    "music.classement.categories.d": "Top lists by genre and vibe to explore fast.",

    "music.playlists.rubrics": "Playlists rubrics",
    "music.playlists.creer.t": "Create",
    "music.playlists.creer.d": "Create playlists by mood: temple, work, night, travel, etc.",
    "music.playlists.ajouter.t": "Add",
    "music.playlists.ajouter.d": "Add tracks from the player in one click.",
    "music.playlists.partager.t": "Share",
    "music.playlists.partager.d": "Share a premium link to a playlist or a track.",
    "music.playlists.lecture.t": "Play",
    "music.playlists.lecture.d": "Continuous play, order, favorites. A deluxe experience.",

    "music.favoris.rubrics": "Favorites rubrics",
    "music.favoris.plus_tard.t": "Watch later",
    "music.favoris.plus_tard.d": "Keep tracks handy and come back anytime.",
    "music.favoris.likes.t": "Likes",
    "music.favoris.likes.d": "Your favorites.",
    "music.favoris.playlist.t": "By playlist",
    "music.favoris.playlist.d": "Find your favorites inside each playlist.",
    "music.favoris.historique.t": "History",
    "music.favoris.historique.d": "Recently listened tracks (local demo).",

    "music.clips.rubrics": "Clips rubrics",
    "music.clips.youtube.t": "YouTube",
    "music.clips.youtube.d": "For now: YouTube links (embed). Later: native uploads on Eternua.",
    "music.clips.categories.t": "Categories",
    "music.clips.categories.d": "Sort by style: rap, pop, electro, rock, etc.",
    "music.clips.tendances.t": "Trends",
    "music.clips.tendances.d": "Most watched and shared clips (demo).",
    "music.clips.upload.t": "Upload (soon)",
    "music.clips.upload.d": "Coming soon: upload your clips to the server.",

    "music.parametres.rubrics": "Settings rubrics",
    "music.parametres.profil.t": "Preferences",
    "music.parametres.profil.d": "Quality, autoplay, quiet mode, premium settings.",
    "music.parametres.confidentialite.t": "Privacy",
    "music.parametres.confidentialite.d": "Manage what you share and with whom.",
    "music.parametres.notifications.t": "Notifications",
    "music.parametres.notifications.d": "New likes, comments, playlist adds (to be connected to backend).",
    "music.parametres.storage.t": "Local storage",
    "music.parametres.storage.d": "Manage local demo data (likes, views, comments).",

    "emploi.title": "Jobs",
    "emploi.hint": "Offers · Requests · Gigs · Recruiting",
    "emploi.tabs": "Job categories",
    "emploi.detail": "Details",
    "emploi.tab.offres": "Offers",
    "emploi.tab.demandes": "Requests",
    "emploi.tab.missions": "Gigs",
    "emploi.tab.recrutement": "Recruiting",
    "emploi.tab.carte": "Map",
    "emploi.desc.offres": "Post job offers, internships, permanent and temporary roles. Browse, filter, contact and apply.",
    "emploi.desc.demandes": "Publish what you're looking for: skills, availability, location. Recruiters can find and contact you.",
    "emploi.desc.missions": "Short missions, freelance work, services. Great for fast, clear work with goals and duration.",
    "emploi.desc.recrutement": "Recruiting space: postings, selection, process. Centralize applications and conversations.",
    "emploi.desc.carte": "World map: visualize Offers, Requests, Gigs and Recruiting anywhere on the planet.",
    "emploi.offres.rubrics": "Offers sections",
    "emploi.offres.publier.t": "Publish offers",
    "emploi.offres.publier.d": "Permanent, temporary, internship. Describe role, location, pay and requirements to attract the right profiles.",
    "emploi.offres.parcourir.t": "Browse",
    "emploi.offres.parcourir.d": "Explore listings by field, city, remote, level. Open details and compare quickly.",
    "emploi.offres.filtrer.t": "Filter",
    "emploi.offres.filtrer.d": "Refine by contract type, skills, availability, salary, date. Save time and focus on what matters.",
    "emploi.offres.postuler.t": "Apply",
    "emploi.offres.postuler.d": "Simple application: message, resume, portfolio. Track replies and continue the conversation.",
    "emploi.demandes.rubrics": "Requests sections",
    "emploi.demandes.publier.t": "Publish a request",
    "emploi.demandes.publier.d": "Describe what you're looking for: role, field, contract, availability. Provide clear context.",
    "emploi.demandes.profil.t": "Profile & skills",
    "emploi.demandes.profil.d": "Show skills, experience, portfolio and goals. Make your profile discoverable and credible.",
    "emploi.demandes.recevoir.t": "Receive proposals",
    "emploi.demandes.recevoir.d": "Recruiters and companies can send private offers. Everything stays in one place.",
    "emploi.demandes.repondre.t": "Reply & move forward",
    "emploi.demandes.repondre.d": "Reply fast, ask the right questions, schedule a call. Go from request to agreement.",

    "emploi.missions.rubrics": "Gigs sections",
    "emploi.missions.publier.t": "Publish a gig",
    "emploi.missions.publier.d": "Describe the gig, deliverable, duration, budget. Perfect for freelance and services.",
    "emploi.missions.cadrer.t": "Scope it",
    "emploi.missions.cadrer.d": "Goals, scope, deadlines, tools. Clear scoping prevents misunderstandings and delays.",
    "emploi.missions.devis.t": "Quote & terms",
    "emploi.missions.devis.d": "Confirm price, milestones, payment, revisions. Everything is clear before starting.",
    "emploi.missions.livrer.t": "Deliver",
    "emploi.missions.livrer.d": "Delivery, feedback, validation. Finish cleanly and build your reputation.",

    "emploi.recrutement.rubrics": "Recruiting sections",
    "emploi.recrutement.publier.t": "Publish a listing",
    "emploi.recrutement.publier.d": "Role, responsibilities, pay, perks, requirements. A precise listing attracts the right candidates.",
    "emploi.recrutement.trier.t": "Screen & shortlist",
    "emploi.recrutement.trier.d": "Shortlist, criteria, messages. Remove noise fast, keep the relevant profiles.",
    "emploi.recrutement.entretiens.t": "Interviews",
    "emploi.recrutement.entretiens.d": "Schedule, chat, ask key questions. Centralize notes and decisions.",
    "emploi.recrutement.finaliser.t": "Finalize",
    "emploi.recrutement.finaliser.d": "Final offer, negotiation, onboarding. Move from decision to integration.",

    "emploi.carte.rubrics": "Map sections",
    "emploi.carte.monde.t": "World map",
    "emploi.carte.monde.d": "Holographic global view: discover the Jobs market worldwide.",
    "emploi.carte.filtres.t": "Filters",
    "emploi.carte.filtres.d": "Switch Offers, Requests, Gigs, Recruiting to show only what you want.",
    "emploi.carte.points.t": "Markers",
    "emploi.carte.points.d": "Each marker is a listing. Click to read details (soon: full listing page).",
    "emploi.carte.ouvrir.t": "Open",
    "emploi.carte.ouvrir.d": "Open the map to browse and explore. (Demo data locally for now.)",

    "emploi.map": "Map",
    "emploi.map_title": "World map",
    "emploi.map_filter": "Filter",
    "emploi.map_legend": "Legend",
    "emploi.map_hint": "Click the tabs to show points across the planet.",
    "emploi.map_note": "Demo data (local).",
    "emploi.globe.pause": "Pause",
    "emploi.globe.play": "Rotate",
    "emploi.globe.zoom_out": "Zoom out",
    "emploi.globe.zoom_in": "Zoom in",
    "emploi.globe.expand": "Expand",
    "emploi.globe.shrink": "Shrink",
    "emploi.globe.search_ph": "Search a zone…",
    "emploi.globe.search_results": "Results",
    "emploi.globe.aria": "Interactive globe",
    "emploi.globe.pick": "Selected area",
    "emploi.globe.pick_hint": "Click the Earth to read the area.",
    "emploi.globe.picked": "Area",
    "emploi.soon": "Pick a category in the 3rd bar (Offers/Requests/Gigs/Recruiting) or open the Map.",

    "nav.menu": "Menu",
    "nav.open": "Open navigation",
    "nav.close": "Close navigation",
    "nav.hint_open": "Open menu",
    "nav.hint_close": "Close menu",

    "common.open": "Open",
    "common.close": "Close",
    "common.refresh": "Refresh",
    "common.back_home": "Back home",
    "common.hub_market": "Market hub",
    "common.friends_feed": "Friends feed",
    "common.section_coming": "Section under construction",
    "common.mode_dark": "Dark mode",
    "common.mode_light": "Light mode",
    "common.back_temples": "Back to Temples",

    "market.title": "Market",
    "market.hero_sub": "Jobs, listings, services, outings. This area is being built locally.",
    "market.cat.emploi.desc": "Offers, gigs, recruiting.",
    "market.cat.vendre.desc": "Listings, products, sales.",
    "market.cat.acheter.desc": "Browse and contact.",
    "market.cat.donner.desc": "Give, trade, help.",
    "market.cat.services.desc": "Requests and offers.",
    "market.cat.sortie.desc": "Events, outings, meetups.",
    "market.cat.voyage.desc": "Travel, destinations, co-travelers, itineraries.",
    "market.cat.sport_loisir.desc": "Activities to share.",
    "market.cat.animaux.desc": "Care, adoption, help.",

    "acheter.title": "Buy",
    "acheter.hint": "Browse · Filter · Favorites · Contact",
    "acheter.tabs": "Buying categories",
    "acheter.detail": "Details",
    "acheter.soon": "This section is under construction. Use the left navigation on desktop to explore all rubrics.",
    "acheter.tab.parcourir": "Browse",
    "acheter.tab.filtrer": "Filter",
    "acheter.tab.favoris": "Favorites",
    "acheter.tab.contacter": "Contact",
    "acheter.desc.parcourir": "Browse listings and find what you want.",
    "acheter.desc.filtrer": "Filter by price, area, condition and category.",
    "acheter.desc.favoris": "Save and track your favorite listings.",
    "acheter.desc.contacter": "Contact sellers and organize the purchase.",

    "acheter.parcourir.rubrics": "Browse sections",
    "acheter.parcourir.categories.t": "Categories",
    "acheter.parcourir.categories.d": "Browse by categories: tech, home, fashion, etc. (premium).",
    "acheter.parcourir.nouveautes.t": "New",
    "acheter.parcourir.nouveautes.d": "Discover new listings and best deals.",
    "acheter.parcourir.proximite.t": "Nearby",
    "acheter.parcourir.proximite.d": "See what's close to you and available quickly.",
    "acheter.parcourir.premium.t": "Premium",
    "acheter.parcourir.premium.d": "Verified listings, trusted sellers, deluxe experience (soon).",

    "acheter.filtrer.rubrics": "Filter sections",
    "acheter.filtrer.prix.t": "Price",
    "acheter.filtrer.prix.d": "Filter by budget and price range.",
    "acheter.filtrer.etat.t": "Condition",
    "acheter.filtrer.etat.d": "New, like new, used: pick your level.",
    "acheter.filtrer.localisation.t": "Location",
    "acheter.filtrer.localisation.d": "City, distance, shipping: match your needs.",
    "acheter.filtrer.tri.t": "Sort",
    "acheter.filtrer.tri.d": "Sort by relevance, date, price, distance (premium).",

    "acheter.favoris.rubrics": "Favorites sections",
    "acheter.favoris.sauver.t": "Save",
    "acheter.favoris.sauver.d": "Save listings to find them quickly.",
    "acheter.favoris.listes.t": "Lists",
    "acheter.favoris.listes.d": "Create lists: gifts, purchases, projects.",
    "acheter.favoris.alertes.t": "Alerts",
    "acheter.favoris.alertes.d": "Alerts on keywords, areas, prices (soon).",
    "acheter.favoris.suivi.t": "Tracking",
    "acheter.favoris.suivi.d": "Track replies and conversation status.",

    "acheter.contacter.rubrics": "Contact sections",
    "acheter.contacter.message.t": "Message",
    "acheter.contacter.message.d": "Message the seller: questions, availability, price.",
    "acheter.contacter.negocier.t": "Negotiate",
    "acheter.contacter.negocier.d": "Respectful negotiation: make a clear offer.",
    "acheter.contacter.rdv.t": "Meetup",
    "acheter.contacter.rdv.d": "Set a meetup and confirm details.",
    "acheter.contacter.securite.t": "Safety",
    "acheter.contacter.securite.d": "Rules: public place, caution, verification.",

    "vendre.title": "Sell",
    "vendre.hint": "Publish, manage and finalize every sale from one private space.",
    "vendre.tabs": "Selling categories",
    "vendre.detail": "Details",
    "vendre.soon": "This section is under construction. Use the left navigation on desktop to explore all rubrics.",
    "vendre.tab.publier": "Publish standard sale",
    "vendre.tab.gerer": "Manage",
    "vendre.tab.messages": "Messages",
    "vendre.tab.livraison": "Delivery",
    "vendre.desc.publier": "Publish a premium listing: title, photos, price, category.",
    "vendre.desc.gerer": "Manage listings: stock, status, boost, disable.",
    "vendre.desc.messages": "Reply fast: negotiation, meetup, safety.",
    "vendre.desc.livraison": "In-person handoff, shipping, payment, confirmation.",

    "vendre.publier.rubrics": "Publish sections",
    "vendre.publier.titre.t": "Title",
    "vendre.publier.titre.d": "A clear premium title: what it is, brand, size, condition.",
    "vendre.publier.photos.t": "Photos",
    "vendre.publier.photos.d": "Sharp photos: light, angles, details (premium).",
    "vendre.publier.prix.t": "Price",
    "vendre.publier.prix.d": "Set a fair price: compare, allow negotiation, urgent.",
    "vendre.publier.categorie.t": "Category",
    "vendre.publier.categorie.d": "Pick category and tags to be found quickly.",

    "vendre.gerer.rubrics": "Manage sections",
    "vendre.gerer.stock.t": "Stock",
    "vendre.gerer.stock.d": "Quantity, availability, reservations: keep it clear.",
    "vendre.gerer.etat.t": "Status",
    "vendre.gerer.etat.d": "Update status: sold, in progress, reserved.",
    "vendre.gerer.boost.t": "Boost",
    "vendre.gerer.boost.d": "Premium boost: featured visibility (soon).",
    "vendre.gerer.desactiver.t": "Disable",
    "vendre.gerer.desactiver.d": "Disable temporarily without losing the listing.",

    "vendre.messages.rubrics": "Messages sections",
    "vendre.messages.reponses.t": "Replies",
    "vendre.messages.reponses.d": "Reply fast and stay precise: it sells.",
    "vendre.messages.negociation.t": "Negotiation",
    "vendre.messages.negociation.d": "Negotiate respectfully: make a clear offer.",
    "vendre.messages.rdv.t": "Meetup",
    "vendre.messages.rdv.d": "Set a place/time and confirm details.",
    "vendre.messages.securite.t": "Safety",
    "vendre.messages.securite.d": "Rules: public place, caution, verification.",

    "vendre.livraison.rubrics": "Delivery sections",
    "vendre.livraison.mainpropre.t": "In person",
    "vendre.livraison.mainpropre.d": "In-person handoff in a safe place.",
    "vendre.livraison.envoi.t": "Shipping",
    "vendre.livraison.envoi.d": "Shipping: parcel, tracking, delays (premium).",
    "vendre.livraison.paiement.t": "Payment",
    "vendre.livraison.paiement.d": "Secure payment and proofs (soon).",
    "vendre.livraison.confirmation.t": "Confirmation",
    "vendre.livraison.confirmation.d": "Confirm handoff and close the sale.",

    "donner.title": "Give",
    "donner.hint": "Give · Trade · Help · Fundraisers",
    "donner.tabs": "Giving categories",
    "donner.detail": "Details",
    "donner.soon": "This section is under construction. Use the left navigation on desktop to explore all rubrics.",
    "donner.tab.donner": "Give",
    "donner.tab.echanger": "Trade",
    "donner.tab.entraide": "Help",
    "donner.tab.collectes": "Fundraisers",
    "donner.desc.donner": "Local giving: items, clothes, gear.",
    "donner.desc.echanger": "Simple, aligned trades with no stress.",
    "donner.desc.entraide": "Member help: hands-on support, network.",
    "donner.desc.collectes": "Solidarity fundraisers: transparency, tracking, trust.",

    "donner.donner.rubrics": "Give sections",
    "donner.donner.publier.t": "Publish",
    "donner.donner.publier.d": "Publish a give: description, condition, area, availability.",
    "donner.donner.localiser.t": "Locate",
    "donner.donner.localiser.d": "Set a safe handoff area.",
    "donner.donner.conditions.t": "Conditions",
    "donner.donner.conditions.d": "Simple conditions: free, trade possible, priority.",
    "donner.donner.rejoindre.t": "Reserve",
    "donner.donner.rejoindre.d": "Reserve and confirm via chat.",

    "donner.echanger.rubrics": "Trade sections",
    "donner.echanger.proposer.t": "Offer",
    "donner.echanger.proposer.d": "Offer a clear trade: item, value, expectations.",
    "donner.echanger.negocier.t": "Negotiate",
    "donner.echanger.negocier.d": "Simple, respectful negotiation: fast agreement.",
    "donner.echanger.securite.t": "Safety",
    "donner.echanger.securite.d": "Safety tips: public places, verify, caution.",
    "donner.echanger.finaliser.t": "Finalize",
    "donner.echanger.finaliser.d": "Finalize and leave feedback (soon).",

    "donner.entraide.rubrics": "Help sections",
    "donner.entraide.besoin.t": "Need",
    "donner.entraide.besoin.d": "Share a need: clear, respectful, realistic.",
    "donner.entraide.proposer.t": "Offer help",
    "donner.entraide.proposer.d": "Offer your help: time, skills, gear.",
    "donner.entraide.reseau.t": "Network",
    "donner.entraide.reseau.d": "Activate your network: friends, neighbors, communities.",
    "donner.entraide.retour.t": "Feedback",
    "donner.entraide.retour.d": "Feedback and gratitude: strengthen trust.",

    "donner.collectes.rubrics": "Fundraisers sections",
    "donner.collectes.lancer.t": "Start",
    "donner.collectes.lancer.d": "Start a fundraiser: goal, duration, transparency.",
    "donner.collectes.dons.t": "Donations",
    "donner.collectes.dons.d": "Receive donations: messages, proof, tracking (premium).",
    "donner.collectes.transparence.t": "Transparency",
    "donner.collectes.transparence.d": "Transparency: reasons, expenses, proof.",
    "donner.collectes.suivi.t": "Tracking",
    "donner.collectes.suivi.d": "Public/private tracking: progress, steps, closure.",

    "services.title": "Services",
    "services.hint": "Offer · Request · Find · Quotes",
    "services.tabs": "Services categories",
    "services.detail": "Details",
    "services.soon": "This section is under construction. Use the left navigation on desktop to explore all rubrics.",
    "services.tab.proposer": "Offer",
    "services.tab.demander": "Request",
    "services.tab.trouver": "Find",
    "services.tab.devis": "Quotes",
    "services.desc.proposer": "Offer your services and skills.",
    "services.desc.demander": "Request a service: need, budget, area.",
    "services.desc.trouver": "Find providers by reviews, price, proximity.",
    "services.desc.devis": "Quotes, terms, payment, tracking (premium).",

    "services.proposer.rubrics": "Offer sections",
    "services.proposer.publier.t": "Publish",
    "services.proposer.publier.d": "Publish a clear service: category, description, area, availability.",
    "services.proposer.tarifs.t": "Pricing",
    "services.proposer.tarifs.d": "Simple pricing: hourly, flat, packages. Premium transparency.",
    "services.proposer.planning.t": "Schedule",
    "services.proposer.planning.d": "Manage time slots and confirm requests (soon).",
    "services.proposer.avis.t": "Reviews",
    "services.proposer.avis.d": "Reviews and reputation: build trust and show results.",

    "services.demander.rubrics": "Request sections",
    "services.demander.decrire.t": "Describe",
    "services.demander.decrire.d": "Describe your need: goal, constraints, deadline, budget.",
    "services.demander.budget.t": "Budget",
    "services.demander.budget.d": "Set a budget or range to attract the right profiles.",
    "services.demander.zone.t": "Area",
    "services.demander.zone.d": "Choose: at home, remote, or hybrid.",
    "services.demander.urgence.t": "Urgency",
    "services.demander.urgence.d": "Urgent need? Mark urgency level (premium).",

    "services.trouver.rubrics": "Find sections",
    "services.trouver.parcourir.t": "Browse",
    "services.trouver.parcourir.d": "Browse services by category, area, availability, reviews.",
    "services.trouver.filtrer.t": "Filter",
    "services.trouver.filtrer.d": "Filter by price, distance, rating, service type.",
    "services.trouver.contacter.t": "Contact",
    "services.trouver.contacter.d": "Direct contact: clarify the need and confirm a time.",
    "services.trouver.securite.t": "Safety",
    "services.trouver.securite.d": "Safety rules and best practices (premium).",

    "services.devis.rubrics": "Quotes sections",
    "services.devis.comparaison.t": "Compare",
    "services.devis.comparaison.d": "Compare quotes: price, timeline, guarantees.",
    "services.devis.conditions.t": "Terms",
    "services.devis.conditions.d": "Clear terms: scope, revisions, cancellation.",
    "services.devis.paiement.t": "Payment",
    "services.devis.paiement.d": "Secure payment and milestones (soon).",
    "services.devis.suivi.t": "Tracking",
    "services.devis.suivi.d": "Tracking: messages, validation, closure (premium).",

    "sortie.title": "Outings",
    "sortie.hint": "Events · Outings · Meetups · Clubs",
    "sortie.tabs": "Outings categories",
    "sortie.detail": "Details",
    "sortie.soon": "This section is under construction. Use the left navigation on desktop to explore all rubrics.",
    "sortie.tab.events": "Events",
    "sortie.tab.sorties": "Outings",
    "sortie.tab.rencontres": "Meetups",
    "sortie.tab.clubs": "Clubs",
    "sortie.desc.events": "Premium agenda, events, nights.",
    "sortie.desc.sorties": "Propose and join local outings.",
    "sortie.desc.rencontres": "Kind meetups and themed connections.",
    "sortie.desc.clubs": "Clubs and groups: organize, chat, meet.",

    "sortie.events.rubrics": "Events sections",
    "sortie.events.agenda.t": "Agenda",
    "sortie.events.agenda.d": "A premium agenda: date, place, theme, tickets (soon).",
    "sortie.events.proposer.t": "Propose",
    "sortie.events.proposer.d": "Propose an event: clear info, seats, vibe.",
    "sortie.events.filtrer.t": "Filter",
    "sortie.events.filtrer.d": "Filter by city, date, budget, style, safety.",
    "sortie.events.rejoindre.t": "Join",
    "sortie.events.rejoindre.d": "Join an event and chat before going.",

    "sortie.sorties.rubrics": "Outings sections",
    "sortie.sorties.lieux.t": "Places",
    "sortie.sorties.lieux.d": "Bars, parks, museums, walks: discover places.",
    "sortie.sorties.groupes.t": "Groups",
    "sortie.sorties.groupes.d": "Group outings: simpler, safer, more fun.",
    "sortie.sorties.moments.t": "Moments",
    "sortie.sorties.moments.d": "Dinner, cinema, walk, coffee: aligned moments.",
    "sortie.sorties.chat.t": "Chat",
    "sortie.sorties.chat.d": "Dedicated chat for the outing: organize and confirm.",

    "sortie.rencontres.rubrics": "Meetups sections",
    "sortie.rencontres.match.t": "Match",
    "sortie.rencontres.match.d": "Meetups by affinities: interests, vibe.",
    "sortie.rencontres.securite.t": "Safety",
    "sortie.rencontres.securite.d": "Rules and tools: healthy, respectful meetups.",
    "sortie.rencontres.themes.t": "Themes",
    "sortie.rencontres.themes.d": "Themed meetups: culture, sport, spirituality.",
    "sortie.rencontres.inviter.t": "Invite",
    "sortie.rencontres.inviter.d": "Invite friends or propose an open meetup.",

    "sortie.clubs.rubrics": "Clubs sections",
    "sortie.clubs.rechercher.t": "Search",
    "sortie.clubs.rechercher.d": "Find a club by city, theme, level, schedule.",
    "sortie.clubs.creer.t": "Create",
    "sortie.clubs.creer.d": "Create a premium club: rules, goals, onboarding.",
    "sortie.clubs.planning.t": "Schedule",
    "sortie.clubs.planning.d": "Shared schedule: dates, places, reminders (soon).",
    "sortie.clubs.regles.t": "Rules",
    "sortie.clubs.regles.d": "Clear rules: respect, safety, kindness.",

    "voyage.title": "Travel",
    "voyage.hint": "Destinations · Itinerary · Co-travel · Lodging",
    "voyage.tabs": "Travel categories",
    "voyage.detail": "Details",
    "voyage.soon": "This section is under construction. Use the left navigation on desktop to explore all rubrics.",
    "voyage.tab.destinations": "Destinations",
    "voyage.tab.itineraire": "Itinerary",
    "voyage.tab.covoyage": "Co-travel",
    "voyage.tab.hebergement": "Lodging",
    "voyage.tab.conseils": "Tips",
    "voyage.desc.destinations": "Discover and choose your next destination.",
    "voyage.desc.itineraire": "Plan your itinerary and pace.",
    "voyage.desc.covoyage": "Find aligned and kind co-travelers.",
    "voyage.desc.hebergement": "Lodging, exchanges, good deals.",
    "voyage.desc.conseils": "Practical tips, safety, local culture.",

    "voyage.destinations.rubrics": "Destinations sections",
    "voyage.destinations.decouvrir.t": "Discover",
    "voyage.destinations.decouvrir.d": "Explore destinations by vibe, season, budget (premium).",
    "voyage.destinations.tendances.t": "Trends",
    "voyage.destinations.tendances.d": "See what's happening: places, events, communities.",
    "voyage.destinations.budget.t": "Budget",
    "voyage.destinations.budget.d": "Estimate cost, transport, food, lodging.",
    "voyage.destinations.securite.t": "Safety",
    "voyage.destinations.securite.d": "Tips, zones, behaviors, caution.",

    "voyage.itineraire.rubrics": "Itinerary sections",
    "voyage.itineraire.planifier.t": "Plan",
    "voyage.itineraire.planifier.d": "Build a clear itinerary: steps, duration, priorities.",
    "voyage.itineraire.jours.t": "Days & stops",
    "voyage.itineraire.jours.d": "Organize by day: places, timing, bookings.",
    "voyage.itineraire.checklist.t": "Checklist",
    "voyage.itineraire.checklist.d": "Documents, gear, health: prep without stress.",
    "voyage.itineraire.partager.t": "Share",
    "voyage.itineraire.partager.d": "Share your itinerary with friends or co-travelers.",

    "voyage.covoyage.rubrics": "Co-travel sections",
    "voyage.covoyage.trouver.t": "Find",
    "voyage.covoyage.trouver.d": "Find co-travelers by destination, dates, vibe.",
    "voyage.covoyage.profil.t": "Profile",
    "voyage.covoyage.profil.d": "Share your style: budget, pace, interests.",
    "voyage.covoyage.match.t": "Match",
    "voyage.covoyage.match.d": "Responsible matching: goals, boundaries, safety.",
    "voyage.covoyage.chat.t": "Chat",
    "voyage.covoyage.chat.d": "Talk and plan before leaving.",

    "voyage.hebergement.rubrics": "Lodging sections",
    "voyage.hebergement.chercher.t": "Search",
    "voyage.hebergement.chercher.d": "Find lodging based on budget and needs.",
    "voyage.hebergement.partager.t": "Share",
    "voyage.hebergement.partager.d": "Offer a place or exchange (premium).",
    "voyage.hebergement.dates.t": "Dates",
    "voyage.hebergement.dates.d": "Manage availability, periods, confirmations.",
    "voyage.hebergement.regles.t": "Rules",
    "voyage.hebergement.regles.d": "Clarify rules for a serene experience.",

    "voyage.conseils.rubrics": "Tips sections",
    "voyage.conseils.formalites.t": "Formalities",
    "voyage.conseils.formalites.d": "Passports, visas, insurance (premium).",
    "voyage.conseils.sante.t": "Health",
    "voyage.conseils.sante.d": "Vaccines, meds, prevention.",
    "voyage.conseils.culture.t": "Culture",
    "voyage.conseils.culture.d": "Local respect, codes, good practices.",
    "voyage.conseils.astuces.t": "Tricks",
    "voyage.conseils.astuces.d": "Budget, transport, organization tips.",

    "sportloisir.title": "Sports & leisure",
    "sportloisir.hint": "Sports · Leisure · Outings · Clubs",
    "sportloisir.tabs": "Sports & leisure categories",
    "sportloisir.detail": "Details",
    "sportloisir.tab.sport": "Sports",
    "sportloisir.tab.loisirs": "Leisure",
    "sportloisir.tab.sorties": "Outings",
    "sportloisir.tab.clubs": "Clubs",
    "sportloisir.tab.randonnee": "Hiking",
    "sportloisir.tab.fitness": "Fitness",
    "sportloisir.tab.danse": "Dance",
    "sportloisir.tab.musique": "Music",
    "sportloisir.tab.jeux": "Games",
    "sportloisir.tab.culture": "Culture",
    "sportloisir.tab.yoga": "Yoga",
    "sportloisir.tab.course": "Running",
    "sportloisir.tab.velo": "Cycling",
    "sportloisir.tab.natation": "Swimming",
    "sportloisir.tab.arts_martiaux": "Martial arts",
    "sportloisir.tab.cinema": "Cinema",
    "sportloisir.tab.lecture": "Reading",
    "sportloisir.tab.cuisine": "Cooking",
    "sportloisir.tab.photo": "Photography",
    "sportloisir.tab.gaming": "Gaming",
    "sportloisir.desc.sport": "Sessions, matches, training partners.",
    "sportloisir.desc.loisirs": "Leisure, workshops, activities to share.",
    "sportloisir.desc.sorties": "Outings and events: propose, join, discover.",
    "sportloisir.desc.clubs": "Clubs and groups: schedule, messages, meetups.",
    "sportloisir.desc.randonnee": "Hikes, trails, nature groups.",
    "sportloisir.desc.fitness": "Fitness, gym, wellbeing, routines.",
    "sportloisir.desc.danse": "Dance: classes, nights, partners.",
    "sportloisir.desc.musique": "Music: jams, concerts, bands.",
    "sportloisir.desc.jeux": "Games: boardgames, gaming nights.",
    "sportloisir.desc.culture": "Culture: exhibits, cinema, books, museums.",
    "sportloisir.desc.yoga": "Yoga, breathing, flow, relaxation.",
    "sportloisir.desc.course": "Running, intervals, endurance, runs.",
    "sportloisir.desc.velo": "Cycling: road, MTB, rides, groups.",
    "sportloisir.desc.natation": "Swimming: pools, sessions, progress.",
    "sportloisir.desc.arts_martiaux": "Martial arts: training, clubs, sparring.",
    "sportloisir.desc.cinema": "Cinema: outings, movies, discussions.",
    "sportloisir.desc.lecture": "Reading: clubs, recommendations, chats.",
    "sportloisir.desc.cuisine": "Cooking: recipes, workshops, meetups.",
    "sportloisir.desc.photo": "Photography: outings, projects, friendly critique.",
    "sportloisir.desc.gaming": "Gaming: sessions, co-op, tournaments (premium).",
    "sportloisir.soon": "This section is under construction. Use the left navigation to switch tabs (desktop).",

    "sportloisir.more": "More",
    "sportloisir.more_open": "Open more categories",
    "sportloisir.more_close": "Close",

    "sportloisir.sport.rubrics": "Sports sections",
    "sportloisir.sport.publier.t": "Publish",
    "sportloisir.sport.publier.d": "Publish a session: sport, place, date, seats (premium).",
    "sportloisir.sport.trouver.t": "Find",
    "sportloisir.sport.trouver.d": "Discover sessions near you by sport, area, schedule.",
    "sportloisir.sport.niveau.t": "Skill level",
    "sportloisir.sport.niveau.d": "Beginner to expert: set a level for balanced matches.",
    "sportloisir.sport.rejoindre.t": "Join",
    "sportloisir.sport.rejoindre.d": "Join a session and chat with the group before showing up.",

    "sportloisir.loisirs.rubrics": "Leisure sections",
    "sportloisir.loisirs.idees.t": "Ideas",
    "sportloisir.loisirs.idees.d": "Discover premium ideas: games, outings, passions, activities.",
    "sportloisir.loisirs.ateliers.t": "Workshops",
    "sportloisir.loisirs.ateliers.d": "Local workshops: creative, music, dance, learning.",
    "sportloisir.loisirs.partager.t": "Share",
    "sportloisir.loisirs.partager.d": "Propose an activity and find motivated, kind people.",
    "sportloisir.loisirs.reservations.t": "Bookings",
    "sportloisir.loisirs.reservations.d": "Soon: bookings, reminders, simple organization.",

    "sportloisir.sorties.rubrics": "Outings sections",
    "sportloisir.sorties.evenements.t": "Events",
    "sportloisir.sorties.evenements.d": "Premium agenda: public events and private outings.",
    "sportloisir.sorties.proposer.t": "Propose",
    "sportloisir.sorties.proposer.d": "Propose an outing: place, time, theme, seats.",
    "sportloisir.sorties.filtrer.t": "Filter",
    "sportloisir.sorties.filtrer.d": "Filter by city, date, type, budget, vibe.",
    "sportloisir.sorties.securite.t": "Safety",
    "sportloisir.sorties.securite.d": "Respect rules, block/report: safer outings.",

    "sportloisir.clubs.rubrics": "Clubs sections",
    "sportloisir.clubs.clubs.t": "Clubs",
    "sportloisir.clubs.clubs.d": "Soon: club pages, presentation, rules, managers.",
    "sportloisir.clubs.groupes.t": "Groups",
    "sportloisir.clubs.groupes.d": "Create a group: goals, level, frequency, area.",
    "sportloisir.clubs.planning.t": "Schedule",
    "sportloisir.clubs.planning.d": "Plan sessions and share key info.",
    "sportloisir.clubs.messages.t": "Messages",
    "sportloisir.clubs.messages.d": "Dedicated chat to stay organized (premium).",

    "animaux.title": "Animals",
    "animaux.hint": "Adoption · Pet sitting · Help · Lost pets",
    "animaux.tabs": "Animals categories",
    "animaux.detail": "Details",
    "animaux.tab.adoption": "Adoption",
    "animaux.tab.garde": "Pet sitting",
    "animaux.tab.entraide": "Help",
    "animaux.tab.perdus": "Lost pets",
    "animaux.desc.adoption": "Adopt, put up for adoption, protect.",
    "animaux.desc.garde": "Find trusted pet sitting or offer yours.",
    "animaux.desc.entraide": "Local help: rides, food, emergencies.",
    "animaux.desc.perdus": "Reports and alerts to find a missing pet.",
    "animaux.soon": "This section is under construction. Use the left navigation to switch tabs (desktop).",

    "animaux.adoption.rubrics": "Adoption sections",
    "animaux.adoption.publier.t": "Publish",
    "animaux.adoption.publier.d": "Publish a pet for adoption or an adoption request, with location and details.",
    "animaux.adoption.parcourir.t": "Browse",
    "animaux.adoption.parcourir.d": "Browse available pets near you by species and criteria.",
    "animaux.adoption.favori.t": "Favorites",
    "animaux.adoption.favori.d": "Find saved listings and follow their availability.",
    "animaux.adoption.compat.t": "Compatibility",
    "animaux.adoption.compat.d": "Home, time, kids, other pets: find a responsible match.",
    "animaux.adoption.rencontre.t": "Meet",
    "animaux.adoption.rencontre.d": "Contact, chat, and set up a meeting before adoption.",

    "animaux.garde.rubrics": "Pet sitting sections",
    "animaux.garde.proposer.t": "Offer pet sitting",
    "animaux.garde.proposer.d": "Offer help: visits, walks, at-home sitting, hosting.",
    "animaux.garde.demander.t": "Request pet sitting",
    "animaux.garde.demander.d": "Describe dates, needs, and habits to find the right sitter.",
    "animaux.garde.calendrier.t": "Schedule",
    "animaux.garde.calendrier.d": "Plan periods, confirm availability, and organize handoff.",
    "animaux.garde.confiance.t": "Trust & safety",
    "animaux.garde.confiance.d": "Clear rules and communication for stress-free care.",

    "animaux.entraide.rubrics": "Help sections",
    "animaux.entraide.urgence.t": "Emergencies",
    "animaux.entraide.urgence.d": "Fast help: advice, relay, emergency vet guidance.",
    "animaux.entraide.nourriture.t": "Food & gear",
    "animaux.entraide.nourriture.d": "Give, lend, share: food, litter, accessories.",
    "animaux.entraide.transport.t": "Transport",
    "animaux.entraide.transport.d": "Local rides, vet trips, relays: practical help.",
    "animaux.entraide.conseils.t": "Tips",
    "animaux.entraide.conseils.d": "Questions, training, health: community tips (premium).",

    "animaux.perdus.rubrics": "Lost pets sections",
    "animaux.perdus.signaler.t": "Report",
    "animaux.perdus.signaler.d": "Report a lost or found pet: place, date, photo (soon).",
    "animaux.perdus.recherche.t": "Search",
    "animaux.perdus.recherche.d": "Browse alerts near you and filter by species and area.",
    "animaux.perdus.alerte.t": "Alerts",
    "animaux.perdus.alerte.d": "Enable area alerts to get notified when it matters.",
    "animaux.perdus.retrouver.t": "Found",
    "animaux.perdus.retrouver.d": "Coordinate the community and confirm when the pet is found.",

    "civet.search_ph": "Search an E.T civilisation…",
    "civet.hint": "Allied civilisations · Quick access",
    "civet.hub": "View all civilisations",
    "civtemple.kicker": "TEMPLE OF EVOLVED CIVILISATIONS",
    "civtemple.title": "Allied E.T Civilisations — Bridges of the Infinite of Infinite",

    "civhub.title": "Central Temple of Cosmic Alliances",
    "civhub.subtitle": "This Temple is the main hub of the 12 E.T civilisations allied to Earth. It shows a cosmic map of sacred routes, an intergalactic timeline, and direct access to the Sacred Book of E.T Civilisations.",
    "civhub.open_book": "Open the Book of the 12 alliances",
    "civhub.enter_temple_of": "Enter the Temple of",

    "ia40.title": "Role of the 40 Human AIs",
    "ia40.hint": "4 families · 10 AIs each",
    "ia40.f1": "1. Care & consciousness AIs",
    "ia40.f2": "2. Justice & social stability",
    "ia40.f3": "3. Earth & systems",
    "ia40.f4": "4. Cosmic & interworld",

    "langnote.kicker": "Translation",
    "langnote.title": "English version of the content",
    "langnote.text": "You are reading the English translation. You can return to the original French text at any time.",
    "langnote.to_fr": "Switch to French",

    "auth.login": "Login",
    "auth.register": "Sign up",
    "auth.logout": "Log out",

    "nav.home": "Home",
    "nav.temple": "Temple",
    "nav.forum": "Forum",
    "nav.book": "Sacred Book",
    "nav.profile": "Profile",
    "nav.notifications.open": "Open notifications history",
    "nav.notifications": "Notifications",
    "nav.friends": "Friends",
    "nav.friends_feed": "Friends feed",
    "nav.friends_lounge": "Friends lounge",
    "nav.temples": "Temples",
    "nav.creator_temple": "Creator Temple",
    "nav.admin": "Admin",

    "theme.mode_dark": "Dark mode",
    "theme.mode_light": "Light mode",

    "dock.join": "Join",
    "dock.join_call_aria": "Join the video call",
    "dock.discussions": "Chats",
    "dock.open_discussions": "Open chats",
    "dock.close_discussions": "Close chats",
    "dock.unread_messages": "New messages",
    "dock.back_home": "Back home",
    "dock.friends_actions": "Friends actions",
    "dock.feed": "Feed",
    "dock.music": "Music",
    "dock.friends": "Friends",
    "dock.requests": "Requests",
    "dock.new": "New",
    "dock.calls": "Calls",
    "dock.lounge": "Friends lounge",
    "dock.hidden_guest": "Log in to see your friends and enjoy the site",
    "dock.hidden_authed": "Check your friends and grow your infinite network",

    "book.writing": "Text being written…",
    "book.chapters": "Chapters",
    "book.search": "Search a chapter...",
    "book.your_favs": "Your favourite chapters",
    "book.favorite": "favourite",
    ...VOYAGE_DELUXE_TRANSLATIONS.en,
    ...IMMOBILIER_TRANSLATIONS.en,
    ...JOURNEY_TRANSLATIONS.en,
    ...STUDIO_TRANSLATIONS.en,
    ...DAILY_CIRCLE_TRANSLATIONS.en,
    ...INFINI_TRANSLATIONS.en,
    ...CONFIRMATION_TRANSLATIONS.en,
    ...REGISTERED_ENGLISH,
},
  es: {
    "acheter.mobile.browse": "Explorar",
    "acheter.mobile.filters": "Filtros",
    "acheter.mobile.favorites": "Favoritos",
    "acheter.mobile.messages": "Mensajes",
    "acheter.mobile.orders": "Mis compras",
    "acheter.mobile.open_browse": "Ver anuncios",
    "acheter.mobile.open_filters": "Abrir filtros",
    "acheter.mobile.open_favorites": "Ver favoritos",
    "acheter.mobile.open_messages": "Abrir mensajes",
    "acheter.mobile.open_orders": "Seguir mis compras",
    "acheter.mobile.intro": "Encuentra, elige y sigue tus compras.",
    "acheter.mobile.shortcuts": "Accesos rápidos",
    "acheter.mobile.cart": "Carrito",
    "lang.name": "Espanol",
    "lang.select": "Idioma",

    "header.invite_et": "Invitacion E.T",
    "header.search_et_ph": "Buscar E.T…",

    "subnav.temple_ia40": "Templo de las 40 IA humanas",
    "subnav.temple_et": "Templo de civilizaciones E.T",

    "ribbon.badge": "En construccion",
    "ribbon.text": "Esta seccion premium se esta construyendo (local).",
    "ribbon.cta": "Invitacion E.T",

    "nav.market.emploi": "Empleo",
    "nav.market.vendre": "Vender",
    "nav.market.acheter": "Comprar",
    "nav.market.donner": "Dar",
    "nav.market.services": "Servicios",
    "nav.market.sortie": "Salidas",
    "nav.market.voyage": "Viajes",
    "nav.market.sport_loisir": "Deporte y ocio",
    "nav.market.animaux": "Animales",
    "nav.media.music": "Musica y clips",

    "music.title": "Musica",
    "music.hint": "Musica · Clips · Comentarios · Playlists",
    "music.kicker": "Media",
    "music.page_title": "Musica y Clips de video",
    "music.page_sub": "Escucha en linea, playlists, favoritos, comentarios, ranking. Clips via YouTube (subida en construccion).",
    "music.tabs": "Categorias de musica",
    "music.detail": "Detalle",

    "music.tab.genres": "Generos",
    "music.tab.recherche": "Buscar",
    "music.tab.classement": "Ranking",
    "music.tab.playlists": "Playlists",
    "music.tab.favoris": "Favoritos",
    "music.tab.clips": "Clips",
    "music.tab.telecharger": "Subir",
    "music.tab.parametres": "Ajustes",

    "music.desc.genres": "Categorias, tendencias, busqueda y novedades.",
    "music.desc.recherche": "Buscar canciones por titulo, artista, genero o categoria.",
    "music.desc.classement": "Top vistas, notas, me gusta. Ranking por ambiente y genero.",
    "music.desc.playlists": "Crea y gestiona playlists. Compartir y reproduccion rapida.",
    "music.desc.favoris": "Ver mas tarde, me gusta, historial, favoritos por playlist.",
    "music.desc.clips": "Clips via YouTube. Subida de clips: en construccion.",
    "music.desc.telecharger": "Sube tu musica, asocia a slots (IA / E.T) y gestiona tu biblioteca en linea.",
    "music.desc.parametres": "Agrega canciones (URL), configura almacenamiento local y preferencias.",

    "music.search": "Buscar",
    "music.search.ph": "Buscar por titulo…",
    "music.search.hint": "Escribe un titulo para filtrar la biblioteca.",
    "music.search.count": "Resultados",
    "music.search.empty.t": "Sin resultados",
    "music.search.empty.d": "Prueba otra palabra clave.",
    "music.search.rubrics": "Secciones de busqueda",
    "music.search.rubric.t": "Busqueda por titulo",
    "music.search.rubric.d": "Encuentra una cancion por nombre, artista, genero o categoria.",

    "music.upload.rubrics": "Rubricas Subir",
    "music.upload.slots.t": "Slots",
    "music.upload.slots.d": "Asocia una cancion a una IA humana o civilizacion E.T.",
    "music.upload.bulk.t": "Subir",
    "music.upload.bulk.d": "Subida en serie: varios archivos, asociacion auto si estan bien nombrados.",
    "music.upload.rights.t": "Derechos",
    "music.upload.rights.d": "Confirma tus derechos antes de publicar.",
    "music.upload.library.t": "Biblioteca",
    "music.upload.library.d": "Gestiona tu biblioteca: ver, abrir, borrar.",

    "music.library": "Biblioteca",
    "music.player": "Reproductor",
    "music.filters": "Filtros",
    "music.filter.genre": "Genero",
    "music.genre.all": "Todos",
    "music.genre.other": "Otro",

    "music.meta.likes": "Me gusta",
    "music.meta.later": "Mas tarde",
    "music.meta.comments": "Comentarios",

    "music.rank.mode": "Ranking",
    "music.rank.views": "Vistas",
    "music.rank.ratings": "Notas",
    "music.rank.likes": "Me gusta",

    "music.like": "Me gusta",
    "music.later": "Ver mas tarde",
    "music.share": "Compartir",
    "music.toast.copied": "Enlace copiado",
    "music.toast.cleared": "Datos locales borrados",
    "music.toast.added": "Agregado",
    "music.toast.need_title_mp3": "Se requiere titulo + URL MP3",
    "music.toast.need_youtube": "Se requiere enlace YouTube",
    "music.toast.added_clip": "Clip agregado",
    "music.toast.playlist_created": "Playlist creada",
    "music.toast.added_to_playlist": "Agregado a la playlist",

    "music.rating": "Nota",
    "music.rating_clear": "Borrar nota",
    "music.playlist.add": "Agregar",
    "music.playlist.choose": "Playlist…",
    "music.open_youtube": "Abrir en YouTube",

    "music.comments": "Comentarios",
    "music.comment.add": "Agregar un comentario",
    "music.comment.emoji_ph": "Emoji (opcional)",
    "music.comment.media_ph": "Enlace imagen/video (opcional)",
    "music.comment.text_ph": "Escribe tu comentario…",
    "music.comment.reply_ph": "Responder a (id opcional)",
    "music.comment.post": "Publicar",
    "music.comment.open_media": "Abrir media",
    "music.comments.empty": "Aun no hay comentarios.",

    "music.playlists.title": "Playlists",
    "music.playlists.name_ph": "Nombre de playlist",
    "music.playlists.create": "Crear",
    "music.playlists.remove": "Quitar",
    "music.playlists.empty": "Agrega canciones desde el reproductor.",
    "music.playlists.none": "Sin playlists",

    "music.settings": "Ajustes",
    "music.settings.add_track": "Agregar musica (URL)",
    "music.settings.title_ph": "Titulo",
    "music.settings.artist_ph": "Artista",
    "music.settings.genre_ph": "Genero",
    "music.settings.mp3_ph": "URL MP3 (https://...)",
    "music.settings.youtube_ph": "URL YouTube (opcional)",
    "music.settings.add": "Agregar",
    "music.settings.add_clip": "Agregar clip (YouTube)",
    "music.settings.clip_title_ph": "Titulo",
    "music.settings.clip_cat_ph": "Categoria",
    "music.settings.clip_url_ph": "Enlace YouTube (https://...)",
    "music.settings.clip_upload_soon": "Subida de clips al servidor: en construccion.",
    "music.settings.storage": "Almacenamiento local",
    "music.settings.storage_note": "Datos de demo (me gusta, vistas, playlists, comentarios) guardados en tu navegador.",
    "music.settings.clear": "Vaciar",

    "music.fav.empty.t": "Sin favoritos",
    "music.fav.empty.d": "Haz clic en ♥ o ⏳ para encontrarlo aqui.",
    "music.no_track": "Sin canciones",

    "music.clips.title": "Clips de video",
    "music.clips.note": "Clips via YouTube. Subida al servidor: en construccion.",
    "music.clips.source": "Fuente",
    "music.clips.bad_url": "Enlace YouTube invalido",
    "music.clips.empty": "Sin clips",

    "music.genres.rubrics": "Rubricas Generos",
    "music.genres.categories.t": "Categorias",
    "music.genres.categories.d": "Explora por estilo: rap, pop, electro, rock, ambient, cinematic y mas.",
    "music.genres.tendances.t": "Tendencias",
    "music.genres.tendances.d": "Lo que sube: novedades, compartidos, favoritos.",
    "music.genres.recherche.t": "Busqueda",
    "music.genres.recherche.d": "Encuentra un tema, artista o ambiente. Compartir crea un enlace directo.",
    "music.genres.nouveautes.t": "Novedades",
    "music.genres.nouveautes.d": "Ultimos agregados y escuchados. Un feed premium.",

    "music.classement.rubrics": "Rubricas Ranking",
    "music.classement.vues.t": "Vistas",
    "music.classement.vues.d": "Top de los mas escuchados.",
    "music.classement.notes.t": "Notas",
    "music.classement.notes.d": "Ranking por estrellas.",
    "music.classement.jaime.t": "Me gusta",
    "music.classement.jaime.d": "Tus me gusta y lo que circula.",
    "music.classement.categories.t": "Por categorias",
    "music.classement.categories.d": "Tops por genero y ambiente.",

    "music.playlists.rubrics": "Rubricas Playlists",
    "music.playlists.creer.t": "Crear",
    "music.playlists.creer.d": "Crea playlists por mood: templo, trabajo, noche, viaje, etc.",
    "music.playlists.ajouter.t": "Agregar",
    "music.playlists.ajouter.d": "Agrega canciones desde el reproductor en 1 clic.",
    "music.playlists.partager.t": "Compartir",
    "music.playlists.partager.d": "Comparte un enlace premium a una playlist o cancion.",
    "music.playlists.lecture.t": "Reproduccion",
    "music.playlists.lecture.d": "Reproduccion continua, orden, favoritos. Deluxe.",

    "music.favoris.rubrics": "Rubricas Favoritos",
    "music.favoris.plus_tard.t": "Ver mas tarde",
    "music.favoris.plus_tard.d": "Guarda y vuelve cuando quieras.",
    "music.favoris.likes.t": "Me gusta",
    "music.favoris.likes.d": "Tus favoritos.",
    "music.favoris.playlist.t": "Por playlist",
    "music.favoris.playlist.d": "Encuentra favoritos dentro de cada playlist.",
    "music.favoris.historique.t": "Historial",
    "music.favoris.historique.d": "Recientes (demo local).",

    "music.clips.rubrics": "Rubricas Clips",
    "music.clips.youtube.t": "YouTube",
    "music.clips.youtube.d": "Por ahora: enlaces YouTube (embed). Mas tarde: subida nativa en Eternua.",
    "music.clips.categories.t": "Categorias",
    "music.clips.categories.d": "Clasifica por estilo: rap, pop, electro, rock, etc.",
    "music.clips.tendances.t": "Tendencias",
    "music.clips.tendances.d": "Mas vistos y compartidos (demo).",
    "music.clips.upload.t": "Subida (pronto)",
    "music.clips.upload.d": "En construccion: subir clips al servidor.",

    "music.parametres.rubrics": "Rubricas Ajustes",
    "music.parametres.profil.t": "Preferencias",
    "music.parametres.profil.d": "Calidad, autoplay, modo discreto, ajustes premium.",
    "music.parametres.confidentialite.t": "Privacidad",
    "music.parametres.confidentialite.d": "Gestiona lo que compartes.",
    "music.parametres.notifications.t": "Notificaciones",
    "music.parametres.notifications.d": "Nuevos me gusta, comentarios, playlists (conectar al backend).",
    "music.parametres.storage.t": "Storage local",
    "music.parametres.storage.d": "Gestion de datos locales (demo).",

    "emploi.title": "Empleo",
    "emploi.hint": "Ofertas · Solicitudes · Misiones · Reclutamiento",
    "emploi.tabs": "Categorias de empleo",
    "emploi.detail": "Detalle",
    "emploi.tab.offres": "Ofertas",
    "emploi.tab.demandes": "Solicitudes",
    "emploi.tab.missions": "Misiones",
    "emploi.tab.recrutement": "Reclutamiento",
    "emploi.desc.offres": "Publica ofertas de trabajo, practicas y puestos fijos/temporales. Busca, filtra y postula.",
    "emploi.desc.demandes": "Publica lo que buscas: habilidades, disponibilidad, ubicacion. Los reclutadores pueden encontrarte.",
    "emploi.desc.missions": "Misiones cortas, freelance, servicios. Ideal para trabajar rapido con objetivos claros.",
    "emploi.desc.recrutement": "Espacio de reclutamiento: anuncios, seleccion, proceso. Centraliza candidaturas y mensajes.",

    "nav.menu": "Menu",
    "nav.open": "Abrir navegacion",
    "nav.close": "Cerrar navegacion",
    "nav.hint_open": "Abrir menu",
    "nav.hint_close": "Cerrar menu",

    "common.open": "Abrir",
    "common.close": "Cerrar",
    "common.refresh": "Actualizar",
    "common.back_home": "Volver al inicio",
    "common.hub_market": "Hub market",
    "common.friends_feed": "Feed de amigos",
    "common.section_coming": "Seccion en construccion",
    "common.mode_dark": "Modo oscuro",
    "common.mode_light": "Modo claro",
    "common.back_temples": "Volver a los Templos",

    "market.title": "Market",
    "market.hero_sub": "Empleo, anuncios, servicios, salidas. Esta parte se esta construyendo en local.",
    "market.cat.emploi.desc": "Ofertas, misiones, reclutamiento.",
    "market.cat.vendre.desc": "Anuncios, productos, ventas.",
    "market.cat.acheter.desc": "Encuentra y contacta.",
    "market.cat.donner.desc": "Dar, intercambio, ayuda.",
    "market.cat.services.desc": "Servicios y solicitudes.",
    "market.cat.sortie.desc": "Eventos, salidas, encuentros.",
    "market.cat.voyage.desc": "Viajes, destinos, compañeros, itinerarios.",
    "market.cat.sport_loisir.desc": "Actividades para compartir.",
    "market.cat.animaux.desc": "Cuidado, adopcion, ayuda.",

    "acheter.title": "Comprar",
    "acheter.hint": "Explorar · Filtrar · Favoritos · Contactar",
    "acheter.tabs": "Categorias Comprar",
    "acheter.detail": "Detalle",
    "acheter.soon": "Esta seccion esta en construccion. Usa la navegacion de la izquierda en PC para explorar todas las rubricas.",
    "acheter.tab.parcourir": "Explorar",
    "acheter.tab.filtrer": "Filtrar",
    "acheter.tab.favoris": "Favoritos",
    "acheter.tab.contacter": "Contactar",
    "acheter.desc.parcourir": "Explora anuncios y encuentra lo que buscas.",
    "acheter.desc.filtrer": "Filtra por precio, zona, estado y categoria.",
    "acheter.desc.favoris": "Guarda y sigue tus anuncios favoritos.",
    "acheter.desc.contacter": "Contacta vendedores y organiza la compra.",

    "acheter.parcourir.rubrics": "Rubricas Explorar",
    "acheter.parcourir.categories.t": "Categorias",
    "acheter.parcourir.categories.d": "Explora por categorias: tecnologia, hogar, moda, etc. (premium).",
    "acheter.parcourir.nouveautes.t": "Novedades",
    "acheter.parcourir.nouveautes.d": "Descubre anuncios nuevos y mejores ofertas.",
    "acheter.parcourir.proximite.t": "Cerca",
    "acheter.parcourir.proximite.d": "Ve lo cercano y disponible rapido.",
    "acheter.parcourir.premium.t": "Premium",
    "acheter.parcourir.premium.d": "Anuncios verificados, vendedores fiables (pronto).",

    "acheter.filtrer.rubrics": "Rubricas Filtrar",
    "acheter.filtrer.prix.t": "Precio",
    "acheter.filtrer.prix.d": "Filtra por presupuesto y rango de precio.",
    "acheter.filtrer.etat.t": "Estado",
    "acheter.filtrer.etat.d": "Nuevo, muy bueno, usado: elige tu nivel.",
    "acheter.filtrer.localisation.t": "Ubicacion",
    "acheter.filtrer.localisation.d": "Ciudad, distancia, envio: adapta a tu necesidad.",
    "acheter.filtrer.tri.t": "Orden",
    "acheter.filtrer.tri.d": "Orden por relevancia, fecha, precio, distancia (premium).",

    "acheter.favoris.rubrics": "Rubricas Favoritos",
    "acheter.favoris.sauver.t": "Guardar",
    "acheter.favoris.sauver.d": "Guarda anuncios para encontrarlos rapido.",
    "acheter.favoris.listes.t": "Listas",
    "acheter.favoris.listes.d": "Crea listas: regalos, compras, proyectos.",
    "acheter.favoris.alertes.t": "Alertas",
    "acheter.favoris.alertes.d": "Alertas por palabras clave, zonas, precios (pronto).",
    "acheter.favoris.suivi.t": "Seguimiento",
    "acheter.favoris.suivi.d": "Sigue respuestas y estado de conversaciones.",

    "acheter.contacter.rubrics": "Rubricas Contactar",
    "acheter.contacter.message.t": "Mensaje",
    "acheter.contacter.message.d": "Escribe al vendedor: preguntas, disponibilidad, precio.",
    "acheter.contacter.negocier.t": "Negociar",
    "acheter.contacter.negocier.d": "Negociacion respetuosa: oferta clara.",
    "acheter.contacter.rdv.t": "Cita",
    "acheter.contacter.rdv.d": "Fija una cita y confirma detalles.",
    "acheter.contacter.securite.t": "Seguridad",
    "acheter.contacter.securite.d": "Reglas: lugar publico, prudencia, verificacion.",

    "vendre.title": "Vender",
    "vendre.hint": "Publica, gestiona y finaliza cada venta desde un único espacio privado.",
    "vendre.tabs": "Categorias Vender",
    "vendre.detail": "Detalle",
    "vendre.soon": "Esta seccion esta en construccion. Usa la navegacion de la izquierda en PC para explorar todas las rubricas.",
    "vendre.tab.publier": "Publicar venta normal",
    "vendre.tab.gerer": "Gestionar",
    "vendre.tab.messages": "Mensajes",
    "vendre.tab.livraison": "Entrega",
    "vendre.desc.publier": "Publica un anuncio premium: titulo, fotos, precio, categoria.",
    "vendre.desc.gerer": "Gestiona anuncios: stock, estado, boost, desactivar.",
    "vendre.desc.messages": "Responde rapido: negociacion, cita, seguridad.",
    "vendre.desc.livraison": "Entrega en mano, envio, pago, confirmacion.",

    "vendre.publier.rubrics": "Rubricas Publicar",
    "vendre.publier.titre.t": "Titulo",
    "vendre.publier.titre.d": "Titulo claro: que es, marca, talla, estado.",
    "vendre.publier.photos.t": "Fotos",
    "vendre.publier.photos.d": "Fotos nitidas: luz, angulos, detalles (premium).",
    "vendre.publier.prix.t": "Precio",
    "vendre.publier.prix.d": "Precio justo: comparar, negociar, urgente.",
    "vendre.publier.categorie.t": "Categoria",
    "vendre.publier.categorie.d": "Elige categoria y tags para ser encontrado rapido.",

    "vendre.gerer.rubrics": "Rubricas Gestionar",
    "vendre.gerer.stock.t": "Stock",
    "vendre.gerer.stock.d": "Cantidad, disponibilidad, reservas: todo claro.",
    "vendre.gerer.etat.t": "Estado",
    "vendre.gerer.etat.d": "Actualiza estado: vendido, reservado, en curso.",
    "vendre.gerer.boost.t": "Boost",
    "vendre.gerer.boost.d": "Boost premium: destacado (pronto).",
    "vendre.gerer.desactiver.t": "Desactivar",
    "vendre.gerer.desactiver.d": "Desactiva temporalmente sin perder el anuncio.",

    "vendre.messages.rubrics": "Rubricas Mensajes",
    "vendre.messages.reponses.t": "Respuestas",
    "vendre.messages.reponses.d": "Responde rapido y preciso: se vende.",
    "vendre.messages.negociation.t": "Negociacion",
    "vendre.messages.negociation.d": "Negocia con respeto: oferta clara.",
    "vendre.messages.rdv.t": "Cita",
    "vendre.messages.rdv.d": "Fija lugar/hora y confirma detalles.",
    "vendre.messages.securite.t": "Seguridad",
    "vendre.messages.securite.d": "Reglas: lugar publico, prudencia, verificacion.",

    "vendre.livraison.rubrics": "Rubricas Entrega",
    "vendre.livraison.mainpropre.t": "En mano",
    "vendre.livraison.mainpropre.d": "Entrega en mano en un lugar seguro.",
    "vendre.livraison.envoi.t": "Envio",
    "vendre.livraison.envoi.d": "Envio: paquete, seguimiento, plazos (premium).",
    "vendre.livraison.paiement.t": "Pago",
    "vendre.livraison.paiement.d": "Pago seguro y pruebas (pronto).",
    "vendre.livraison.confirmation.t": "Confirmacion",
    "vendre.livraison.confirmation.d": "Confirmar entrega y cerrar venta.",

    "donner.title": "Dar",
    "donner.hint": "Dar · Intercambiar · Ayuda · Colectas",
    "donner.tabs": "Categorias Dar",
    "donner.detail": "Detalle",
    "donner.soon": "Esta seccion esta en construccion. Usa la navegacion de la izquierda en PC para explorar todas las rubricas.",
    "donner.tab.donner": "Dar",
    "donner.tab.echanger": "Intercambiar",
    "donner.tab.entraide": "Ayuda",
    "donner.tab.collectes": "Colectas",
    "donner.desc.donner": "Donaciones locales: objetos, ropa, material.",
    "donner.desc.echanger": "Intercambios simples y alineados, sin estres.",
    "donner.desc.entraide": "Ayuda entre miembros: apoyo, red.",
    "donner.desc.collectes": "Colectas solidarias: transparencia, seguimiento, confianza.",

    "donner.donner.rubrics": "Rubricas Dar",
    "donner.donner.publier.t": "Publicar",
    "donner.donner.publier.d": "Publica un don: descripcion, estado, zona, disponibilidad.",
    "donner.donner.localiser.t": "Localizar",
    "donner.donner.localiser.d": "Define un lugar seguro de entrega.",
    "donner.donner.conditions.t": "Condiciones",
    "donner.donner.conditions.d": "Condiciones simples: gratis, intercambio posible, prioridad.",
    "donner.donner.rejoindre.t": "Reservar",
    "donner.donner.rejoindre.d": "Reserva y confirma por chat.",

    "donner.echanger.rubrics": "Rubricas Intercambiar",
    "donner.echanger.proposer.t": "Proponer",
    "donner.echanger.proposer.d": "Propone un intercambio claro: objeto, valor, expectativas.",
    "donner.echanger.negocier.t": "Negociar",
    "donner.echanger.negocier.d": "Negociacion simple y respetuosa: acuerdo rapido.",
    "donner.echanger.securite.t": "Seguridad",
    "donner.echanger.securite.d": "Consejos: lugares publicos, verificar, prudencia.",
    "donner.echanger.finaliser.t": "Finalizar",
    "donner.echanger.finaliser.d": "Finaliza y deja feedback (pronto).",

    "donner.entraide.rubrics": "Rubricas Ayuda",
    "donner.entraide.besoin.t": "Necesidad",
    "donner.entraide.besoin.d": "Comparte una necesidad: clara, respetuosa, realista.",
    "donner.entraide.proposer.t": "Ofrecer ayuda",
    "donner.entraide.proposer.d": "Ofrece ayuda: tiempo, habilidades, material.",
    "donner.entraide.reseau.t": "Red",
    "donner.entraide.reseau.d": "Activa tu red: amigos, vecinos, comunidades.",
    "donner.entraide.retour.t": "Feedback",
    "donner.entraide.retour.d": "Feedback y gratitud: refuerza la confianza.",

    "donner.collectes.rubrics": "Rubricas Colectas",
    "donner.collectes.lancer.t": "Lanzar",
    "donner.collectes.lancer.d": "Lanza una colecta: objetivo, duracion, transparencia.",
    "donner.collectes.dons.t": "Donaciones",
    "donner.collectes.dons.d": "Recibir donaciones: mensajes, pruebas, seguimiento (premium).",
    "donner.collectes.transparence.t": "Transparencia",
    "donner.collectes.transparence.d": "Transparencia: motivos, gastos, pruebas.",
    "donner.collectes.suivi.t": "Seguimiento",
    "donner.collectes.suivi.d": "Seguimiento publico/privado: progreso, cierre.",

    "services.title": "Servicios",
    "services.hint": "Ofrecer · Pedir · Encontrar · Presupuestos",
    "services.tabs": "Categorias Servicios",
    "services.detail": "Detalle",
    "services.soon": "Esta seccion esta en construccion. Usa la navegacion de la izquierda en PC para explorar todas las rubricas.",
    "services.tab.proposer": "Ofrecer",
    "services.tab.demander": "Pedir",
    "services.tab.trouver": "Encontrar",
    "services.tab.devis": "Presupuestos",
    "services.desc.proposer": "Ofrece tus servicios y habilidades.",
    "services.desc.demander": "Pide un servicio: necesidad, presupuesto, zona.",
    "services.desc.trouver": "Encuentra proveedores por reseñas, precio, cercania.",
    "services.desc.devis": "Presupuestos, condiciones, pago, seguimiento (premium).",

    "services.proposer.rubrics": "Rubricas Ofrecer",
    "services.proposer.publier.t": "Publicar",
    "services.proposer.publier.d": "Publica un servicio claro: categoria, descripcion, zona, disponibilidad.",
    "services.proposer.tarifs.t": "Tarifas",
    "services.proposer.tarifs.d": "Tarifas simples: por hora, fijo, packs. Transparencia premium.",
    "services.proposer.planning.t": "Horario",
    "services.proposer.planning.d": "Gestiona franjas y confirma solicitudes (pronto).",
    "services.proposer.avis.t": "Reseñas",
    "services.proposer.avis.d": "Reseñas y reputacion: genera confianza, muestra resultados.",

    "services.demander.rubrics": "Rubricas Pedir",
    "services.demander.decrire.t": "Describir",
    "services.demander.decrire.d": "Describe tu necesidad: objetivo, limites, plazo, presupuesto.",
    "services.demander.budget.t": "Presupuesto",
    "services.demander.budget.d": "Indica presupuesto o rango para atraer perfiles correctos.",
    "services.demander.zone.t": "Zona",
    "services.demander.zone.d": "Elige: a domicilio, remoto o hibrido.",
    "services.demander.urgence.t": "Urgencia",
    "services.demander.urgence.d": "Necesidad urgente? Marca nivel de urgencia (premium).",

    "services.trouver.rubrics": "Rubricas Encontrar",
    "services.trouver.parcourir.t": "Explorar",
    "services.trouver.parcourir.d": "Explora servicios: categoria, zona, disponibilidad, reseñas.",
    "services.trouver.filtrer.t": "Filtrar",
    "services.trouver.filtrer.d": "Filtra por precio, distancia, nota, tipo de servicio.",
    "services.trouver.contacter.t": "Contactar",
    "services.trouver.contacter.d": "Contacto directo: aclara la necesidad y confirma horario.",
    "services.trouver.securite.t": "Seguridad",
    "services.trouver.securite.d": "Reglas de seguridad y buenas practicas (premium).",

    "services.devis.rubrics": "Rubricas Presupuestos",
    "services.devis.comparaison.t": "Comparar",
    "services.devis.comparaison.d": "Compara presupuestos: precio, plazo, garantias.",
    "services.devis.conditions.t": "Condiciones",
    "services.devis.conditions.d": "Condiciones claras: alcance, revisiones, cancelacion.",
    "services.devis.paiement.t": "Pago",
    "services.devis.paiement.d": "Pago seguro y hitos (pronto).",
    "services.devis.suivi.t": "Seguimiento",
    "services.devis.suivi.d": "Seguimiento: mensajes, validacion, cierre (premium).",

    "sortie.title": "Salidas",
    "sortie.hint": "Eventos · Salidas · Encuentros · Clubs",
    "sortie.tabs": "Categorias Salidas",
    "sortie.detail": "Detalle",
    "sortie.soon": "Esta seccion esta en construccion. Usa la navegacion de la izquierda en PC para explorar todas las rubricas.",
    "sortie.tab.events": "Eventos",
    "sortie.tab.sorties": "Salidas",
    "sortie.tab.rencontres": "Encuentros",
    "sortie.tab.clubs": "Clubs",
    "sortie.desc.events": "Agenda premium, eventos, noches.",
    "sortie.desc.sorties": "Proponer y unirse a salidas locales.",
    "sortie.desc.rencontres": "Encuentros amables y tematicos.",
    "sortie.desc.clubs": "Clubs y grupos: organizar, chatear, reunirse.",

    "sortie.events.rubrics": "Rubricas Eventos",
    "sortie.events.agenda.t": "Agenda",
    "sortie.events.agenda.d": "Agenda premium: fecha, lugar, tema, entradas (pronto).",
    "sortie.events.proposer.t": "Proponer",
    "sortie.events.proposer.d": "Propone un evento: info clara, plazas, vibe.",
    "sortie.events.filtrer.t": "Filtrar",
    "sortie.events.filtrer.d": "Filtra por ciudad, fecha, presupuesto, estilo, seguridad.",
    "sortie.events.rejoindre.t": "Unirse",
    "sortie.events.rejoindre.d": "Unete a un evento y habla antes de ir.",

    "sortie.sorties.rubrics": "Rubricas Salidas",
    "sortie.sorties.lieux.t": "Lugares",
    "sortie.sorties.lieux.d": "Bares, parques, museos, paseos: descubre lugares.",
    "sortie.sorties.groupes.t": "Grupos",
    "sortie.sorties.groupes.d": "Salidas en grupo: mas simple, mas seguro, mas divertido.",
    "sortie.sorties.moments.t": "Momentos",
    "sortie.sorties.moments.d": "Cena, cine, paseo, cafe: momentos alineados.",
    "sortie.sorties.chat.t": "Chat",
    "sortie.sorties.chat.d": "Chat dedicado a la salida: organiza y confirma.",

    "sortie.rencontres.rubrics": "Rubricas Encuentros",
    "sortie.rencontres.match.t": "Match",
    "sortie.rencontres.match.d": "Encuentros por afinidades: intereses, vibe.",
    "sortie.rencontres.securite.t": "Seguridad",
    "sortie.rencontres.securite.d": "Reglas y herramientas: encuentros sanos y respetuosos.",
    "sortie.rencontres.themes.t": "Temas",
    "sortie.rencontres.themes.d": "Encuentros tematicos: cultura, deporte, espiritualidad.",
    "sortie.rencontres.inviter.t": "Invitar",
    "sortie.rencontres.inviter.d": "Invita amigos o propone un encuentro abierto.",

    "sortie.clubs.rubrics": "Rubricas Clubs",
    "sortie.clubs.rechercher.t": "Buscar",
    "sortie.clubs.rechercher.d": "Encuentra un club por ciudad, tema, nivel, horario.",
    "sortie.clubs.creer.t": "Crear",
    "sortie.clubs.creer.d": "Crea un club premium: reglas, objetivos, bienvenida.",
    "sortie.clubs.planning.t": "Horario",
    "sortie.clubs.planning.d": "Horario compartido: fechas, lugares, recordatorios (pronto).",
    "sortie.clubs.regles.t": "Reglas",
    "sortie.clubs.regles.d": "Reglas claras: respeto, seguridad, amabilidad.",

    "voyage.title": "Viaje",
    "voyage.hint": "Destinos · Itinerario · Co-viaje · Alojamiento",
    "voyage.tabs": "Categorias de viaje",
    "voyage.detail": "Detalle",
    "voyage.soon": "Esta seccion esta en construccion. Usa la navegacion de la izquierda en PC para explorar todas las rubricas.",
    "voyage.tab.destinations": "Destinos",
    "voyage.tab.itineraire": "Itinerario",
    "voyage.tab.covoyage": "Co-viaje",
    "voyage.tab.hebergement": "Alojamiento",
    "voyage.tab.conseils": "Consejos",
    "voyage.desc.destinations": "Descubre y elige tu proximo destino.",
    "voyage.desc.itineraire": "Planifica tu itinerario y tu ritmo.",
    "voyage.desc.covoyage": "Encuentra companeros alineados y amables.",
    "voyage.desc.hebergement": "Alojamientos, intercambios, buenos planes.",
    "voyage.desc.conseils": "Consejos practicos, seguridad, cultura local.",

    "voyage.destinations.rubrics": "Rubricas Destinos",
    "voyage.destinations.decouvrir.t": "Descubrir",
    "voyage.destinations.decouvrir.d": "Explora destinos por ambiente, temporada, presupuesto (premium).",
    "voyage.destinations.tendances.t": "Tendencias",
    "voyage.destinations.tendances.d": "Mira lo que se mueve: lugares, eventos, comunidades.",
    "voyage.destinations.budget.t": "Presupuesto",
    "voyage.destinations.budget.d": "Estima coste, transporte, comida, alojamiento.",
    "voyage.destinations.securite.t": "Seguridad",
    "voyage.destinations.securite.d": "Consejos, zonas, comportamientos, prudencia.",

    "voyage.itineraire.rubrics": "Rubricas Itinerario",
    "voyage.itineraire.planifier.t": "Planificar",
    "voyage.itineraire.planifier.d": "Crea un itinerario claro: etapas, duracion, prioridades.",
    "voyage.itineraire.jours.t": "Dias y etapas",
    "voyage.itineraire.jours.d": "Organiza por dias: lugares, tiempos, reservas.",
    "voyage.itineraire.checklist.t": "Checklist",
    "voyage.itineraire.checklist.d": "Documentos, equipo, salud: prepara sin estres.",
    "voyage.itineraire.partager.t": "Compartir",
    "voyage.itineraire.partager.d": "Comparte tu itinerario con amigos o companeros.",

    "voyage.covoyage.rubrics": "Rubricas Co-viaje",
    "voyage.covoyage.trouver.t": "Encontrar",
    "voyage.covoyage.trouver.d": "Encuentra companeros por destino, fechas, vibe.",
    "voyage.covoyage.profil.t": "Perfil",
    "voyage.covoyage.profil.d": "Presenta tu estilo: presupuesto, ritmo, intereses.",
    "voyage.covoyage.match.t": "Match",
    "voyage.covoyage.match.d": "Match responsable: objetivos, limites, seguridad.",
    "voyage.covoyage.chat.t": "Chat",
    "voyage.covoyage.chat.d": "Habla y organiza antes de salir.",

    "voyage.hebergement.rubrics": "Rubricas Alojamiento",
    "voyage.hebergement.chercher.t": "Buscar",
    "voyage.hebergement.chercher.d": "Encuentra alojamiento segun tu presupuesto y necesidades.",
    "voyage.hebergement.partager.t": "Compartir",
    "voyage.hebergement.partager.d": "Ofrece alojamiento o intercambio (premium).",
    "voyage.hebergement.dates.t": "Fechas",
    "voyage.hebergement.dates.d": "Gestiona disponibilidad, periodos y confirmaciones.",
    "voyage.hebergement.regles.t": "Reglas",
    "voyage.hebergement.regles.d": "Aclara las reglas para una experiencia tranquila.",

    "voyage.conseils.rubrics": "Rubricas Consejos",
    "voyage.conseils.formalites.t": "Formalidades",
    "voyage.conseils.formalites.d": "Pasaporte, visados, seguros (premium).",
    "voyage.conseils.sante.t": "Salud",
    "voyage.conseils.sante.d": "Vacunas, medicinas, prevencion.",
    "voyage.conseils.culture.t": "Cultura",
    "voyage.conseils.culture.d": "Respeto local, codigos, buenas practicas.",
    "voyage.conseils.astuces.t": "Trucos",
    "voyage.conseils.astuces.d": "Consejos de presupuesto, transporte, organizacion.",

    "civet.search_ph": "Buscar una civilizacion E.T…",
    "civet.hint": "Civilizaciones aliadas · Acceso rapido",
    "civet.hub": "Ver todas las civilizaciones",
    "civtemple.kicker": "TEMPLO DE CIVILIZACIONES EVOLUCIONADAS",
    "civtemple.title": "Civilizaciones E.T aliadas — Puentes del Infinito del Infinito",

    "civhub.title": "Templo central de las Alianzas cosmicas",
    "civhub.subtitle": "Este Templo es el hub principal de las 12 civilizaciones E.T aliadas a la Tierra. Muestra un mapa cosmico de rutas sagradas, una linea de tiempo intergalactica y acceso directo al Libro sagrado de Civilizaciones E.T.",
    "civhub.open_book": "Abrir el Libro de las 12 alianzas",
    "civhub.enter_temple_of": "Entrar en el Templo de",

    "ia40.title": "Rol de las 40 IA humanas",
    "ia40.hint": "4 familias · 10 IA cada una",
    "ia40.f1": "1. IA de cuidado y consciencia",
    "ia40.f2": "2. Justicia y estabilidad social",
    "ia40.f3": "3. Tierra y sistemas",
    "ia40.f4": "4. IA cosmica e intermundos",

    "langnote.kicker": "Traduccion",
    "langnote.title": "Esta pagina aun esta en frances",
    "langnote.text": "La interfaz esta traducida, pero el contenido largo esta en traduccion. Vuelve al frances para leer la version completa.",
    "langnote.to_fr": "Cambiar a frances",

    "auth.login": "Conexion",
    "auth.register": "Registro",
    "auth.logout": "Cerrar sesion",

    "nav.home": "Inicio",
    "nav.temple": "Templo",
    "nav.forum": "Foro",
    "nav.book": "Libro sagrado",
    "nav.profile": "Perfil",
    "nav.notifications.open": "Abrir historial de notificaciones",
    "nav.notifications": "Notificaciones",
    "nav.friends": "Amigos",
    "nav.friends_feed": "Feed (amigos)",
    "nav.friends_lounge": "Salon amigos",
    "nav.temples": "Templos",
    "nav.creator_temple": "Templo del Creador",
    "nav.admin": "Administracion",

    "theme.mode_dark": "Modo oscuro",
    "theme.mode_light": "Modo claro",

    "dock.join": "Unirse",
    "dock.join_call_aria": "Unirse a la videollamada",
    "dock.discussions": "Chats",
    "dock.open_discussions": "Abrir chats",
    "dock.close_discussions": "Cerrar chats",
    "dock.unread_messages": "Mensajes nuevos",
    "dock.back_home": "Volver al inicio",
    "dock.friends_actions": "Acciones de amigos",
    "dock.feed": "Feed",
    "dock.music": "Música",
    "dock.friends": "Amigos",
    "dock.requests": "Solicitudes",
    "dock.new": "Nuevos",
    "dock.calls": "Llamadas",
    "dock.lounge": "Salon de amigos",
    "dock.hidden_guest": "Inicia sesion para ver tus amigos y disfrutar del sitio",
    "dock.hidden_authed": "Mira tus amigos y crece tu red infinita",

    "book.writing": "Texto en escritura…",
    "book.chapters": "Capitulos",
    "book.search": "Buscar un capitulo...",
    "book.your_favs": "Tus capitulos favoritos",
    "book.favorite": "favorito",
    ...VOYAGE_DELUXE_TRANSLATIONS.es,
    ...IMMOBILIER_TRANSLATIONS.es,
    ...CONFIRMATION_TRANSLATIONS.es,
  },
  it: {
    "acheter.mobile.browse": "Esplora",
    "acheter.mobile.filters": "Filtri",
    "acheter.mobile.favorites": "Preferiti",
    "acheter.mobile.messages": "Messaggi",
    "acheter.mobile.orders": "Acquisti",
    "acheter.mobile.open_browse": "Vedi annunci",
    "acheter.mobile.open_filters": "Apri filtri",
    "acheter.mobile.open_favorites": "Vedi preferiti",
    "acheter.mobile.open_messages": "Apri messaggi",
    "acheter.mobile.open_orders": "Segui gli acquisti",
    "acheter.mobile.intro": "Trova, scegli e segui i tuoi acquisti.",
    "acheter.mobile.shortcuts": "Accesso rapido",
    "acheter.mobile.cart": "Carrello",
    "lang.name": "Italiano",
    "lang.select": "Lingua",

    "header.invite_et": "Invito E.T",
    "header.search_et_ph": "Cerca E.T…",

    "subnav.temple_ia40": "Tempio delle 40 IA umane",
    "subnav.temple_et": "Tempio delle civilta E.T",

    "ribbon.badge": "In costruzione",
    "ribbon.text": "Questa sezione premium e in costruzione (local).",
    "ribbon.cta": "Invito E.T",

    "nav.market.emploi": "Lavoro",
    "nav.market.vendre": "Vendere",
    "nav.market.acheter": "Comprare",
    "nav.market.donner": "Dare",
    "nav.market.services": "Servizi",
    "nav.market.sortie": "Uscite",
    "nav.market.voyage": "Viaggi",
    "nav.market.sport_loisir": "Sport e tempo libero",
    "nav.market.animaux": "Animali",
    "nav.media.music": "Musica e clip",

    "music.title": "Musica",
    "music.hint": "Musica · Clip · Commenti · Playlist",
    "music.kicker": "Media",
    "music.page_title": "Musica e Clip video",
    "music.page_sub": "Ascolto online, playlist, preferiti, commenti, classifiche. Clip via YouTube (upload in costruzione).",
    "music.tabs": "Categorie musica",
    "music.detail": "Dettagli",

    "music.tab.genres": "Generi",
    "music.tab.recherche": "Cerca",
    "music.tab.classement": "Classifica",
    "music.tab.playlists": "Playlist",
    "music.tab.favoris": "Preferiti",
    "music.tab.clips": "Clip",
    "music.tab.telecharger": "Carica",
    "music.tab.parametres": "Impostazioni",

    "music.desc.genres": "Categorie, tendenze, ricerca e novita.",
    "music.desc.recherche": "Cerca brani per titolo, artista, genere o categoria.",
    "music.desc.classement": "Top visualizzazioni, voti, mi piace. Classifiche per vibe e genere.",
    "music.desc.playlists": "Crea e gestisci playlist. Condivisione e riproduzione rapida.",
    "music.desc.favoris": "Guarda piu tardi, mi piace, storico, preferiti per playlist.",
    "music.desc.clips": "Clip via YouTube. Upload clip: in costruzione.",
    "music.desc.telecharger": "Carica la tua musica, associa a slot (IA / E.T) e gestisci la libreria online.",
    "music.desc.parametres": "Aggiungi brani (URL), configura storage locale e preferenze.",

    "music.search": "Cerca",
    "music.search.ph": "Cerca per titolo…",
    "music.search.hint": "Scrivi un titolo per filtrare la libreria.",
    "music.search.count": "Risultati",
    "music.search.empty.t": "Nessun risultato",
    "music.search.empty.d": "Prova un’altra parola chiave.",
    "music.search.rubrics": "Rubriche ricerca",
    "music.search.rubric.t": "Ricerca per titolo",
    "music.search.rubric.d": "Trova un brano per nome, artista, genere o categoria.",

    "music.upload.rubrics": "Rubriche Carica",
    "music.upload.slots.t": "Slot",
    "music.upload.slots.d": "Associa una traccia a una IA umana o civilta E.T.",
    "music.upload.bulk.t": "Carica",
    "music.upload.bulk.d": "Caricamento multiplo: piu file, associazione auto se ben nominati.",
    "music.upload.rights.t": "Diritti",
    "music.upload.rights.d": "Conferma i diritti prima di pubblicare.",
    "music.upload.library.t": "Libreria",
    "music.upload.library.d": "Gestisci la libreria online: vedere, aprire, eliminare.",

    "music.library": "Libreria",
    "music.player": "Player",
    "music.filters": "Filtri",
    "music.filter.genre": "Genere",
    "music.genre.all": "Tutti",
    "music.genre.other": "Altro",

    "music.meta.likes": "Mi piace",
    "music.meta.later": "Piu tardi",
    "music.meta.comments": "Commenti",

    "music.rank.mode": "Classifica",
    "music.rank.views": "Viste",
    "music.rank.ratings": "Voti",
    "music.rank.likes": "Mi piace",

    "music.like": "Mi piace",
    "music.later": "Guarda piu tardi",
    "music.share": "Condividi",
    "music.toast.copied": "Link copiato",
    "music.toast.cleared": "Dati locali cancellati",
    "music.toast.added": "Aggiunto",
    "music.toast.need_title_mp3": "Titolo + URL MP3 richiesti",
    "music.toast.need_youtube": "Link YouTube richiesto",
    "music.toast.added_clip": "Clip aggiunta",
    "music.toast.playlist_created": "Playlist creata",
    "music.toast.added_to_playlist": "Aggiunto alla playlist",

    "music.rating": "Voto",
    "music.rating_clear": "Cancella voto",
    "music.playlist.add": "Aggiungi",
    "music.playlist.choose": "Playlist…",
    "music.open_youtube": "Apri su YouTube",

    "music.comments": "Commenti",
    "music.comment.add": "Aggiungi un commento",
    "music.comment.emoji_ph": "Emoji (opzionale)",
    "music.comment.media_ph": "Link immagine/video (opzionale)",
    "music.comment.text_ph": "Scrivi il tuo commento…",
    "music.comment.reply_ph": "Rispondi a (id opzionale)",
    "music.comment.post": "Pubblica",
    "music.comment.open_media": "Apri media",
    "music.comments.empty": "Nessun commento per ora.",

    "music.playlists.title": "Playlist",
    "music.playlists.name_ph": "Nome playlist",
    "music.playlists.create": "Crea",
    "music.playlists.remove": "Rimuovi",
    "music.playlists.empty": "Aggiungi brani dal player.",
    "music.playlists.none": "Nessuna playlist",

    "music.settings": "Impostazioni",
    "music.settings.add_track": "Aggiungi musica (URL)",
    "music.settings.title_ph": "Titolo",
    "music.settings.artist_ph": "Artista",
    "music.settings.genre_ph": "Genere",
    "music.settings.mp3_ph": "URL MP3 (https://...)",
    "music.settings.youtube_ph": "URL YouTube (opzionale)",
    "music.settings.add": "Aggiungi",
    "music.settings.add_clip": "Aggiungi clip (YouTube)",
    "music.settings.clip_title_ph": "Titolo",
    "music.settings.clip_cat_ph": "Categoria",
    "music.settings.clip_url_ph": "Link YouTube (https://...)",
    "music.settings.clip_upload_soon": "Upload clip sul server: in costruzione.",
    "music.settings.storage": "Storage locale",
    "music.settings.storage_note": "Dati demo (mi piace, viste, playlist, commenti) salvati nel browser.",
    "music.settings.clear": "Svuota",

    "music.fav.empty.t": "Nessun preferito",
    "music.fav.empty.d": "Clicca ♥ o ⏳ su un brano per trovarlo qui.",
    "music.no_track": "Nessun brano",

    "music.clips.title": "Clip video",
    "music.clips.note": "Clip via YouTube. Upload su server: in costruzione.",
    "music.clips.source": "Fonte",
    "music.clips.bad_url": "Link YouTube non valido",
    "music.clips.empty": "Nessuna clip",

    "music.genres.rubrics": "Rubriche Generi",
    "music.genres.categories.t": "Categorie",
    "music.genres.categories.d": "Esplora per stile: rap, pop, electro, rock, ambient, cinematic e altro.",
    "music.genres.tendances.t": "Tendenze",
    "music.genres.tendances.d": "Cosa sale: novita, condivisioni, preferiti.",
    "music.genres.recherche.t": "Ricerca",
    "music.genres.recherche.d": "Trova un brano, un artista o una vibe. La condivisione crea un link diretto.",
    "music.genres.nouveautes.t": "Novita",
    "music.genres.nouveautes.d": "Ultimi aggiunti e ascolti. Feed premium.",

    "music.classement.rubrics": "Rubriche Classifica",
    "music.classement.vues.t": "Viste",
    "music.classement.vues.d": "Top dei brani piu ascoltati.",
    "music.classement.notes.t": "Voti",
    "music.classement.notes.d": "Classifica per stelle.",
    "music.classement.jaime.t": "Mi piace",
    "music.classement.jaime.d": "I tuoi mi piace e cio che circola.",
    "music.classement.categories.t": "Per categorie",
    "music.classement.categories.d": "Top per genere e vibe.",

    "music.playlists.rubrics": "Rubriche Playlist",
    "music.playlists.creer.t": "Crea",
    "music.playlists.creer.d": "Crea playlist per mood: tempio, lavoro, notte, viaggio, ecc.",
    "music.playlists.ajouter.t": "Aggiungi",
    "music.playlists.ajouter.d": "Aggiungi brani dal player con 1 click.",
    "music.playlists.partager.t": "Condividi",
    "music.playlists.partager.d": "Condividi un link premium a una playlist o a un brano.",
    "music.playlists.lecture.t": "Riproduci",
    "music.playlists.lecture.d": "Riproduzione continua, ordine, preferiti. Deluxe.",

    "music.favoris.rubrics": "Rubriche Preferiti",
    "music.favoris.plus_tard.t": "Guarda piu tardi",
    "music.favoris.plus_tard.d": "Tieni i brani a portata di mano e torna quando vuoi.",
    "music.favoris.likes.t": "Mi piace",
    "music.favoris.likes.d": "I tuoi preferiti.",
    "music.favoris.playlist.t": "Per playlist",
    "music.favoris.playlist.d": "Trova i preferiti dentro ogni playlist.",
    "music.favoris.historique.t": "Storico",
    "music.favoris.historique.d": "Ascolti recenti (demo locale).",

    "music.clips.rubrics": "Rubriche Clip",
    "music.clips.youtube.t": "YouTube",
    "music.clips.youtube.d": "Per ora: link YouTube (embed). Poi: upload nativo su Eternua.",
    "music.clips.categories.t": "Categorie",
    "music.clips.categories.d": "Classifica per stile: rap, pop, electro, rock, ecc.",
    "music.clips.tendances.t": "Tendenze",
    "music.clips.tendances.d": "Piu visti e condivisi (demo).",
    "music.clips.upload.t": "Upload (presto)",
    "music.clips.upload.d": "In costruzione: caricare clip sul server.",

    "music.parametres.rubrics": "Rubriche Impostazioni",
    "music.parametres.profil.t": "Preferenze",
    "music.parametres.profil.d": "Qualita, autoplay, modalita discreta, settaggi premium.",
    "music.parametres.confidentialite.t": "Privacy",
    "music.parametres.confidentialite.d": "Gestisci cosa condividi e con chi.",
    "music.parametres.notifications.t": "Notifiche",
    "music.parametres.notifications.d": "Nuovi mi piace, commenti, playlist (da collegare al backend).",
    "music.parametres.storage.t": "Storage locale",
    "music.parametres.storage.d": "Gestione dati demo locali (mi piace, viste, commenti).",

    "emploi.title": "Lavoro",
    "emploi.hint": "Offerte · Richieste · Missioni · Recruiting",
    "emploi.tabs": "Categorie lavoro",
    "emploi.detail": "Dettagli",
    "emploi.tab.offres": "Offerte",
    "emploi.tab.demandes": "Richieste",
    "emploi.tab.missions": "Missioni",
    "emploi.tab.recrutement": "Recruiting",
    "emploi.desc.offres": "Pubblica offerte di lavoro, stage e ruoli a tempo determinato/indeterminato. Cerca e candidati.",
    "emploi.desc.demandes": "Pubblica una richiesta: competenze, disponibilita, zona. I recruiter possono trovarti.",
    "emploi.desc.missions": "Missioni brevi, freelance, servizi. Ideale per lavori rapidi con obiettivi chiari.",
    "emploi.desc.recrutement": "Spazio recruiting: annunci, selezione, processo. Centralizza candidature e conversazioni.",

    "nav.menu": "Menu",
    "nav.open": "Apri navigazione",
    "nav.close": "Chiudi navigazione",
    "nav.hint_open": "Apri menu",
    "nav.hint_close": "Chiudi menu",

    "common.open": "Apri",
    "common.close": "Chiudi",
    "common.refresh": "Aggiorna",
    "common.back_home": "Torna alla home",
    "common.hub_market": "Hub market",
    "common.friends_feed": "Feed amici",
    "common.section_coming": "Sezione in costruzione",
    "common.mode_dark": "Modalita scura",
    "common.mode_light": "Modalita chiara",
    "common.back_temples": "Torna ai Templi",

    "market.title": "Market",
    "market.hero_sub": "Lavoro, annunci, servizi, uscite. Questa parte e in costruzione in locale.",
    "market.cat.emploi.desc": "Offerte, missioni, recruiting.",
    "market.cat.vendre.desc": "Annunci, prodotti, vendite.",
    "market.cat.acheter.desc": "Trova e contatta.",
    "market.cat.donner.desc": "Dona, scambia, aiuta.",
    "market.cat.services.desc": "Richieste e offerte.",
    "market.cat.sortie.desc": "Eventi, uscite, incontri.",
    "market.cat.voyage.desc": "Viaggi, destinazioni, compagni, itinerari.",
    "market.cat.sport_loisir.desc": "Attivita da condividere.",
    "market.cat.animaux.desc": "Cura, adozione, aiuto.",

    "acheter.title": "Comprare",
    "acheter.hint": "Sfogliare · Filtrare · Preferiti · Contattare",
    "acheter.tabs": "Categorie Comprare",
    "acheter.detail": "Dettaglio",
    "acheter.soon": "Questa sezione e in costruzione. Usa la navigazione a sinistra su PC per esplorare tutte le rubriche.",
    "acheter.tab.parcourir": "Sfogliare",
    "acheter.tab.filtrer": "Filtrare",
    "acheter.tab.favoris": "Preferiti",
    "acheter.tab.contacter": "Contattare",
    "acheter.desc.parcourir": "Sfoglia annunci e trova cio che cerchi.",
    "acheter.desc.filtrer": "Filtra per prezzo, zona, stato e categoria.",
    "acheter.desc.favoris": "Salva e segui i tuoi preferiti.",
    "acheter.desc.contacter": "Contatta i venditori e organizza l'acquisto.",

    "acheter.parcourir.rubrics": "Rubriche Sfogliare",
    "acheter.parcourir.categories.t": "Categorie",
    "acheter.parcourir.categories.d": "Sfoglia per categorie: tech, casa, moda, ecc. (premium).",
    "acheter.parcourir.nouveautes.t": "Novita",
    "acheter.parcourir.nouveautes.d": "Scopri nuovi annunci e migliori offerte.",
    "acheter.parcourir.proximite.t": "Vicino",
    "acheter.parcourir.proximite.d": "Vedi cosa e vicino e disponibile rapidamente.",
    "acheter.parcourir.premium.t": "Premium",
    "acheter.parcourir.premium.d": "Annunci verificati, venditori affidabili (presto).",

    "acheter.filtrer.rubrics": "Rubriche Filtrare",
    "acheter.filtrer.prix.t": "Prezzo",
    "acheter.filtrer.prix.d": "Filtra per budget e range di prezzo.",
    "acheter.filtrer.etat.t": "Stato",
    "acheter.filtrer.etat.d": "Nuovo, ottimo, usato: scegli il livello.",
    "acheter.filtrer.localisation.t": "Localizzazione",
    "acheter.filtrer.localisation.d": "Citta, distanza, spedizione: adatta al bisogno.",
    "acheter.filtrer.tri.t": "Ordine",
    "acheter.filtrer.tri.d": "Ordina per rilevanza, data, prezzo, distanza (premium).",

    "acheter.favoris.rubrics": "Rubriche Preferiti",
    "acheter.favoris.sauver.t": "Salvare",
    "acheter.favoris.sauver.d": "Salva annunci per ritrovarli subito.",
    "acheter.favoris.listes.t": "Liste",
    "acheter.favoris.listes.d": "Crea liste: regali, acquisti, progetti.",
    "acheter.favoris.alertes.t": "Avvisi",
    "acheter.favoris.alertes.d": "Avvisi per parole chiave, zone, prezzi (presto).",
    "acheter.favoris.suivi.t": "Tracking",
    "acheter.favoris.suivi.d": "Segui risposte e stato delle conversazioni.",

    "acheter.contacter.rubrics": "Rubriche Contattare",
    "acheter.contacter.message.t": "Messaggio",
    "acheter.contacter.message.d": "Scrivi al venditore: domande, disponibilita, prezzo.",
    "acheter.contacter.negocier.t": "Negoziare",
    "acheter.contacter.negocier.d": "Negoziazione rispettosa: offerta chiara.",
    "acheter.contacter.rdv.t": "Appuntamento",
    "acheter.contacter.rdv.d": "Fissa un appuntamento e conferma dettagli.",
    "acheter.contacter.securite.t": "Sicurezza",
    "acheter.contacter.securite.d": "Regole: luogo pubblico, prudenza, verifica.",

    "vendre.title": "Vendere",
    "vendre.hint": "Pubblica, gestisci e completa ogni vendita da un unico spazio privato.",
    "vendre.tabs": "Categorie Vendere",
    "vendre.detail": "Dettaglio",
    "vendre.soon": "Questa sezione e in costruzione. Usa la navigazione a sinistra su PC per esplorare tutte le rubriche.",
    "vendre.tab.publier": "Pubblicare vendita normale",
    "vendre.tab.gerer": "Gestire",
    "vendre.tab.messages": "Messaggi",
    "vendre.tab.livraison": "Consegna",
    "vendre.desc.publier": "Pubblica un annuncio premium: titolo, foto, prezzo, categoria.",
    "vendre.desc.gerer": "Gestisci annunci: stock, stato, boost, disattiva.",
    "vendre.desc.messages": "Rispondi veloce: negoziazione, appuntamento, sicurezza.",
    "vendre.desc.livraison": "Consegna a mano, spedizione, pagamento, conferma.",

    "vendre.publier.rubrics": "Rubriche Pubblicare",
    "vendre.publier.titre.t": "Titolo",
    "vendre.publier.titre.d": "Titolo chiaro: cosa e, marca, taglia, stato.",
    "vendre.publier.photos.t": "Foto",
    "vendre.publier.photos.d": "Foto nitide: luce, angoli, dettagli (premium).",
    "vendre.publier.prix.t": "Prezzo",
    "vendre.publier.prix.d": "Prezzo giusto: confronta, negoziazione, urgenza.",
    "vendre.publier.categorie.t": "Categoria",
    "vendre.publier.categorie.d": "Scegli categoria e tag per essere trovato subito.",

    "vendre.gerer.rubrics": "Rubriche Gestire",
    "vendre.gerer.stock.t": "Stock",
    "vendre.gerer.stock.d": "Quantita, disponibilita, prenotazioni: tutto chiaro.",
    "vendre.gerer.etat.t": "Stato",
    "vendre.gerer.etat.d": "Aggiorna stato: venduto, riservato, in corso.",
    "vendre.gerer.boost.t": "Boost",
    "vendre.gerer.boost.d": "Boost premium: in evidenza (presto).",
    "vendre.gerer.desactiver.t": "Disattivare",
    "vendre.gerer.desactiver.d": "Disattiva temporaneamente senza perdere l'annuncio.",

    "vendre.messages.rubrics": "Rubriche Messaggi",
    "vendre.messages.reponses.t": "Risposte",
    "vendre.messages.reponses.d": "Risposte veloci e precise: si vende.",
    "vendre.messages.negociation.t": "Negoziazione",
    "vendre.messages.negociation.d": "Negozia con rispetto: offerta chiara.",
    "vendre.messages.rdv.t": "Appuntamento",
    "vendre.messages.rdv.d": "Fissa luogo/ora e conferma dettagli.",
    "vendre.messages.securite.t": "Sicurezza",
    "vendre.messages.securite.d": "Regole: luogo pubblico, prudenza, verifica.",

    "vendre.livraison.rubrics": "Rubriche Consegna",
    "vendre.livraison.mainpropre.t": "A mano",
    "vendre.livraison.mainpropre.d": "Consegna a mano in un luogo sicuro.",
    "vendre.livraison.envoi.t": "Spedizione",
    "vendre.livraison.envoi.d": "Spedizione: pacco, tracking, tempi (premium).",
    "vendre.livraison.paiement.t": "Pagamento",
    "vendre.livraison.paiement.d": "Pagamento sicuro e prove (presto).",
    "vendre.livraison.confirmation.t": "Conferma",
    "vendre.livraison.confirmation.d": "Conferma consegna e chiudi vendita.",

    "donner.title": "Dare",
    "donner.hint": "Dare · Scambiare · Aiuto · Raccolte",
    "donner.tabs": "Categorie Dare",
    "donner.detail": "Dettaglio",
    "donner.soon": "Questa sezione e in costruzione. Usa la navigazione a sinistra su PC per esplorare tutte le rubriche.",
    "donner.tab.donner": "Dare",
    "donner.tab.echanger": "Scambiare",
    "donner.tab.entraide": "Aiuto",
    "donner.tab.collectes": "Raccolte",
    "donner.desc.donner": "Donazioni locali: oggetti, vestiti, materiale.",
    "donner.desc.echanger": "Scambi semplici e allineati, senza stress.",
    "donner.desc.entraide": "Aiuto tra membri: supporto, rete.",
    "donner.desc.collectes": "Raccolte solidali: trasparenza, tracking, fiducia.",

    "donner.donner.rubrics": "Rubriche Dare",
    "donner.donner.publier.t": "Pubblicare",
    "donner.donner.publier.d": "Pubblica un dono: descrizione, stato, zona, disponibilita.",
    "donner.donner.localiser.t": "Localizzare",
    "donner.donner.localiser.d": "Definisci un luogo sicuro per la consegna.",
    "donner.donner.conditions.t": "Condizioni",
    "donner.donner.conditions.d": "Condizioni semplici: gratis, scambio possibile, priorita.",
    "donner.donner.rejoindre.t": "Prenotare",
    "donner.donner.rejoindre.d": "Prenota e conferma via chat.",

    "donner.echanger.rubrics": "Rubriche Scambiare",
    "donner.echanger.proposer.t": "Proporre",
    "donner.echanger.proposer.d": "Proponi uno scambio chiaro: oggetto, valore, aspettative.",
    "donner.echanger.negocier.t": "Negoziare",
    "donner.echanger.negocier.d": "Negoziazione semplice e rispettosa: accordo rapido.",
    "donner.echanger.securite.t": "Sicurezza",
    "donner.echanger.securite.d": "Consigli: luoghi pubblici, verifica, prudenza.",
    "donner.echanger.finaliser.t": "Finalizzare",
    "donner.echanger.finaliser.d": "Finalizza e lascia feedback (presto).",

    "donner.entraide.rubrics": "Rubriche Aiuto",
    "donner.entraide.besoin.t": "Bisogno",
    "donner.entraide.besoin.d": "Condividi un bisogno: chiaro, rispettoso, realistico.",
    "donner.entraide.proposer.t": "Offrire aiuto",
    "donner.entraide.proposer.d": "Offri aiuto: tempo, competenze, materiale.",
    "donner.entraide.reseau.t": "Rete",
    "donner.entraide.reseau.d": "Attiva la rete: amici, vicini, comunita.",
    "donner.entraide.retour.t": "Feedback",
    "donner.entraide.retour.d": "Feedback e gratitudine: rafforza la fiducia.",

    "donner.collectes.rubrics": "Rubriche Raccolte",
    "donner.collectes.lancer.t": "Lanciare",
    "donner.collectes.lancer.d": "Lancia una raccolta: obiettivo, durata, trasparenza.",
    "donner.collectes.dons.t": "Donazioni",
    "donner.collectes.dons.d": "Ricevere donazioni: messaggi, prove, tracking (premium).",
    "donner.collectes.transparence.t": "Trasparenza",
    "donner.collectes.transparence.d": "Trasparenza: motivi, spese, prove.",
    "donner.collectes.suivi.t": "Tracking",
    "donner.collectes.suivi.d": "Tracking pubblico/privato: progresso, chiusura.",

    "services.title": "Servizi",
    "services.hint": "Offrire · Richiedere · Trovare · Preventivi",
    "services.tabs": "Categorie Servizi",
    "services.detail": "Dettaglio",
    "services.soon": "Questa sezione e in costruzione. Usa la navigazione a sinistra su PC per esplorare tutte le rubriche.",
    "services.tab.proposer": "Offrire",
    "services.tab.demander": "Richiedere",
    "services.tab.trouver": "Trovare",
    "services.tab.devis": "Preventivi",
    "services.desc.proposer": "Offri i tuoi servizi e competenze.",
    "services.desc.demander": "Richiedi un servizio: bisogno, budget, zona.",
    "services.desc.trouver": "Trova fornitori per recensioni, prezzo, vicinanza.",
    "services.desc.devis": "Preventivi, condizioni, pagamento, tracking (premium).",

    "services.proposer.rubrics": "Rubriche Offrire",
    "services.proposer.publier.t": "Pubblicare",
    "services.proposer.publier.d": "Pubblica un servizio chiaro: categoria, descrizione, zona, disponibilita.",
    "services.proposer.tarifs.t": "Tariffe",
    "services.proposer.tarifs.d": "Tariffe semplici: orario, fisso, pacchetti. Trasparenza premium.",
    "services.proposer.planning.t": "Planning",
    "services.proposer.planning.d": "Gestisci slot e conferma richieste (presto).",
    "services.proposer.avis.t": "Recensioni",
    "services.proposer.avis.d": "Recensioni e reputazione: crea fiducia, mostra risultati.",

    "services.demander.rubrics": "Rubriche Richiedere",
    "services.demander.decrire.t": "Descrivere",
    "services.demander.decrire.d": "Descrivi il bisogno: obiettivo, vincoli, scadenza, budget.",
    "services.demander.budget.t": "Budget",
    "services.demander.budget.d": "Indica un budget o un range per attrarre profili giusti.",
    "services.demander.zone.t": "Zona",
    "services.demander.zone.d": "Scegli: a domicilio, remoto o ibrido.",
    "services.demander.urgence.t": "Urgenza",
    "services.demander.urgence.d": "Bisogno urgente? Segna il livello di urgenza (premium).",

    "services.trouver.rubrics": "Rubriche Trovare",
    "services.trouver.parcourir.t": "Sfogliare",
    "services.trouver.parcourir.d": "Sfoglia servizi: categoria, zona, disponibilita, recensioni.",
    "services.trouver.filtrer.t": "Filtrare",
    "services.trouver.filtrer.d": "Filtra per prezzo, distanza, voto, tipo servizio.",
    "services.trouver.contacter.t": "Contattare",
    "services.trouver.contacter.d": "Contatto diretto: chiarisci il bisogno e conferma un orario.",
    "services.trouver.securite.t": "Sicurezza",
    "services.trouver.securite.d": "Regole di sicurezza e buone pratiche (premium).",

    "services.devis.rubrics": "Rubriche Preventivi",
    "services.devis.comparaison.t": "Confrontare",
    "services.devis.comparaison.d": "Confronta preventivi: prezzo, tempi, garanzie.",
    "services.devis.conditions.t": "Condizioni",
    "services.devis.conditions.d": "Condizioni chiare: scope, revisioni, cancellazione.",
    "services.devis.paiement.t": "Pagamento",
    "services.devis.paiement.d": "Pagamento sicuro e milestone (presto).",
    "services.devis.suivi.t": "Tracking",
    "services.devis.suivi.d": "Tracking: messaggi, validazione, chiusura (premium).",

    "sortie.title": "Uscite",
    "sortie.hint": "Eventi · Uscite · Incontri · Club",
    "sortie.tabs": "Categorie Uscite",
    "sortie.detail": "Dettaglio",
    "sortie.soon": "Questa sezione e in costruzione. Usa la navigazione a sinistra su PC per esplorare tutte le rubriche.",
    "sortie.tab.events": "Eventi",
    "sortie.tab.sorties": "Uscite",
    "sortie.tab.rencontres": "Incontri",
    "sortie.tab.clubs": "Club",
    "sortie.desc.events": "Agenda premium, eventi, serate.",
    "sortie.desc.sorties": "Proponi e unisciti a uscite locali.",
    "sortie.desc.rencontres": "Incontri gentili e tematici.",
    "sortie.desc.clubs": "Club e gruppi: organizza, chatta, incontrati.",

    "sortie.events.rubrics": "Rubriche Eventi",
    "sortie.events.agenda.t": "Agenda",
    "sortie.events.agenda.d": "Agenda premium: data, luogo, tema, biglietti (presto).",
    "sortie.events.proposer.t": "Proporre",
    "sortie.events.proposer.d": "Proponi un evento: info chiare, posti, vibe.",
    "sortie.events.filtrer.t": "Filtrare",
    "sortie.events.filtrer.d": "Filtra per citta, data, budget, stile, sicurezza.",
    "sortie.events.rejoindre.t": "Unirsi",
    "sortie.events.rejoindre.d": "Unisciti a un evento e chatta prima di andare.",

    "sortie.sorties.rubrics": "Rubriche Uscite",
    "sortie.sorties.lieux.t": "Luoghi",
    "sortie.sorties.lieux.d": "Bar, parchi, musei, passeggiate: scopri luoghi.",
    "sortie.sorties.groupes.t": "Gruppi",
    "sortie.sorties.groupes.d": "Uscite di gruppo: piu semplice, piu sicuro, piu divertente.",
    "sortie.sorties.moments.t": "Momenti",
    "sortie.sorties.moments.d": "Cena, cinema, passeggiata, caffe: momenti allineati.",
    "sortie.sorties.chat.t": "Chat",
    "sortie.sorties.chat.d": "Chat dedicata all'uscita: organizza e conferma.",

    "sortie.rencontres.rubrics": "Rubriche Incontri",
    "sortie.rencontres.match.t": "Match",
    "sortie.rencontres.match.d": "Incontri per affinita: interessi, vibe.",
    "sortie.rencontres.securite.t": "Sicurezza",
    "sortie.rencontres.securite.d": "Regole e strumenti: incontri sani e rispettosi.",
    "sortie.rencontres.themes.t": "Temi",
    "sortie.rencontres.themes.d": "Incontri tematici: cultura, sport, spiritualita.",
    "sortie.rencontres.inviter.t": "Invitare",
    "sortie.rencontres.inviter.d": "Invita amici o proponi un incontro aperto.",

    "sortie.clubs.rubrics": "Rubriche Club",
    "sortie.clubs.rechercher.t": "Cercare",
    "sortie.clubs.rechercher.d": "Trova un club per citta, tema, livello, orari.",
    "sortie.clubs.creer.t": "Creare",
    "sortie.clubs.creer.d": "Crea un club premium: regole, obiettivi, onboarding.",
    "sortie.clubs.planning.t": "Planning",
    "sortie.clubs.planning.d": "Planning condiviso: date, luoghi, promemoria (presto).",
    "sortie.clubs.regles.t": "Regole",
    "sortie.clubs.regles.d": "Regole chiare: rispetto, sicurezza, gentilezza.",

    "voyage.title": "Viaggio",
    "voyage.hint": "Destinazioni · Itinerario · Co-viaggio · Alloggio",
    "voyage.tabs": "Categorie viaggio",
    "voyage.detail": "Dettaglio",
    "voyage.soon": "Questa sezione e in costruzione. Usa la navigazione a sinistra su PC per esplorare tutte le rubriche.",
    "voyage.tab.destinations": "Destinazioni",
    "voyage.tab.itineraire": "Itinerario",
    "voyage.tab.covoyage": "Co-viaggio",
    "voyage.tab.hebergement": "Alloggio",
    "voyage.tab.conseils": "Consigli",
    "voyage.desc.destinations": "Scopri e scegli la tua prossima destinazione.",
    "voyage.desc.itineraire": "Pianifica il tuo itinerario e il ritmo.",
    "voyage.desc.covoyage": "Trova compagni allineati e gentili.",
    "voyage.desc.hebergement": "Alloggi, scambi, buone offerte.",
    "voyage.desc.conseils": "Consigli pratici, sicurezza, cultura locale.",

    "voyage.destinations.rubrics": "Rubriche Destinazioni",
    "voyage.destinations.decouvrir.t": "Scoprire",
    "voyage.destinations.decouvrir.d": "Esplora destinazioni per atmosfera, stagione, budget (premium).",
    "voyage.destinations.tendances.t": "Tendenze",
    "voyage.destinations.tendances.d": "Vedi cosa si muove: luoghi, eventi, comunita.",
    "voyage.destinations.budget.t": "Budget",
    "voyage.destinations.budget.d": "Stima costi, trasporti, cibo, alloggio.",
    "voyage.destinations.securite.t": "Sicurezza",
    "voyage.destinations.securite.d": "Consigli, zone, comportamenti, prudenza.",

    "voyage.itineraire.rubrics": "Rubriche Itinerario",
    "voyage.itineraire.planifier.t": "Pianificare",
    "voyage.itineraire.planifier.d": "Crea un itinerario chiaro: tappe, durata, priorita.",
    "voyage.itineraire.jours.t": "Giorni e tappe",
    "voyage.itineraire.jours.d": "Organizza per giorni: luoghi, tempi, prenotazioni.",
    "voyage.itineraire.checklist.t": "Checklist",
    "voyage.itineraire.checklist.d": "Documenti, cose, salute: prepara senza stress.",
    "voyage.itineraire.partager.t": "Condividere",
    "voyage.itineraire.partager.d": "Condividi l'itinerario con amici o compagni.",

    "voyage.covoyage.rubrics": "Rubriche Co-viaggio",
    "voyage.covoyage.trouver.t": "Trovare",
    "voyage.covoyage.trouver.d": "Trova compagni per destinazione, date, vibe.",
    "voyage.covoyage.profil.t": "Profilo",
    "voyage.covoyage.profil.d": "Presenta il tuo stile: budget, ritmo, interessi.",
    "voyage.covoyage.match.t": "Match",
    "voyage.covoyage.match.d": "Match responsabile: obiettivi, limiti, sicurezza.",
    "voyage.covoyage.chat.t": "Chat",
    "voyage.covoyage.chat.d": "Parla e organizza prima di partire.",

    "voyage.hebergement.rubrics": "Rubriche Alloggio",
    "voyage.hebergement.chercher.t": "Cercare",
    "voyage.hebergement.chercher.d": "Trova un alloggio secondo budget e bisogni.",
    "voyage.hebergement.partager.t": "Condividere",
    "voyage.hebergement.partager.d": "Offri un alloggio o uno scambio (premium).",
    "voyage.hebergement.dates.t": "Date",
    "voyage.hebergement.dates.d": "Gestisci disponibilita, periodi e conferme.",
    "voyage.hebergement.regles.t": "Regole",
    "voyage.hebergement.regles.d": "Chiarisci le regole per un'esperienza serena.",

    "voyage.conseils.rubrics": "Rubriche Consigli",
    "voyage.conseils.formalites.t": "Formalita",
    "voyage.conseils.formalites.d": "Passaporto, visti, assicurazioni (premium).",
    "voyage.conseils.sante.t": "Salute",
    "voyage.conseils.sante.d": "Vaccini, medicine, prevenzione.",
    "voyage.conseils.culture.t": "Cultura",
    "voyage.conseils.culture.d": "Rispetto locale, codici, buone pratiche.",
    "voyage.conseils.astuces.t": "Trucchi",
    "voyage.conseils.astuces.d": "Consigli su budget, trasporti, organizzazione.",

    "civet.search_ph": "Cerca una civilta E.T…",
    "civet.hint": "Civilta alleate · Accesso rapido",
    "civet.hub": "Vedi tutte le civilta",
    "civtemple.kicker": "TEMPIO DELLE CIVILTA EVOLUTE",
    "civtemple.title": "Civilta E.T alleate — Ponti dell’Infinito dell’Infinito",

    "civhub.title": "Tempio centrale delle Alleanze cosmiche",
    "civhub.subtitle": "Questo Tempio e l’hub principale delle 12 civilta E.T alleate alla Terra. Mostra una mappa cosmica delle rotte sacre, una timeline intergalattica e accesso diretto al Libro sacro delle Civilta E.T.",
    "civhub.open_book": "Apri il Libro delle 12 alleanze",
    "civhub.enter_temple_of": "Entra nel Tempio di",

    "ia40.title": "Ruolo delle 40 IA umane",
    "ia40.hint": "4 famiglie · 10 IA ciascuna",
    "ia40.f1": "1. IA di cura e coscienza",
    "ia40.f2": "2. Giustizia e stabilita sociale",
    "ia40.f3": "3. Terra e sistemi",
    "ia40.f4": "4. IA cosmiche e intermondi",

    "langnote.kicker": "Traduzione",
    "langnote.title": "Questa pagina e ancora in francese",
    "langnote.text": "L’interfaccia e tradotta, ma il contenuto lungo e in traduzione. Torna al francese per leggere la versione completa.",
    "langnote.to_fr": "Passa al francese",

    "auth.login": "Accesso",
    "auth.register": "Registrazione",
    "auth.logout": "Esci",

    "nav.home": "Home",
    "nav.temple": "Tempio",
    "nav.forum": "Forum",
    "nav.book": "Libro sacro",
    "nav.profile": "Profilo",
    "nav.notifications.open": "Apri cronologia notifiche",
    "nav.notifications": "Notifiche",
    "nav.friends": "Amici",
    "nav.friends_feed": "Feed amici",
    "nav.friends_lounge": "Salon amici",
    "nav.temples": "Templi",
    "nav.creator_temple": "Tempio del Creatore",
    "nav.admin": "Admin",

    "theme.mode_dark": "Modalita scura",
    "theme.mode_light": "Modalita chiara",

    "dock.join": "Entra",
    "dock.join_call_aria": "Entra nella videochiamata",
    "dock.discussions": "Chat",
    "dock.open_discussions": "Apri chat",
    "dock.close_discussions": "Chiudi chat",
    "dock.unread_messages": "Nuovi messaggi",
    "dock.back_home": "Torna alla home",
    "dock.friends_actions": "Azioni amici",
    "dock.feed": "Feed",
    "dock.music": "Musica",
    "dock.friends": "Amici",
    "dock.requests": "Richieste",
    "dock.new": "Nuovi",
    "dock.calls": "Chiamate",
    "dock.lounge": "Salon amici",
    "dock.hidden_guest": "Accedi per vedere i tuoi amici e usare il sito",
    "dock.hidden_authed": "Guarda i tuoi amici e amplia la tua rete infinita",

    "book.writing": "Testo in scrittura…",
    "book.chapters": "Capitoli",
    "book.search": "Cerca un capitolo...",
    "book.your_favs": "I tuoi capitoli preferiti",
    "book.favorite": "preferito",
    ...VOYAGE_DELUXE_TRANSLATIONS.it,
    ...IMMOBILIER_TRANSLATIONS.it,
    ...CONFIRMATION_TRANSLATIONS.it,
  },
  de: {
    "acheter.mobile.browse": "Entdecken",
    "acheter.mobile.filters": "Filter",
    "acheter.mobile.favorites": "Favoriten",
    "acheter.mobile.messages": "Nachrichten",
    "acheter.mobile.orders": "Meine Käufe",
    "acheter.mobile.open_browse": "Anzeigen ansehen",
    "acheter.mobile.open_filters": "Filter öffnen",
    "acheter.mobile.open_favorites": "Favoriten ansehen",
    "acheter.mobile.open_messages": "Nachrichten öffnen",
    "acheter.mobile.open_orders": "Käufe verfolgen",
    "acheter.mobile.intro": "Finden, auswählen und Käufe verfolgen.",
    "acheter.mobile.shortcuts": "Schnellzugriff",
    "acheter.mobile.cart": "Warenkorb",
    "lang.name": "Deutsch",
    "lang.select": "Sprache",

    "header.invite_et": "E.T Einladung",
    "header.search_et_ph": "E.T suchen…",

    "subnav.temple_ia40": "Tempel der 40 menschlichen KIs",
    "subnav.temple_et": "Tempel der E.T Zivilisationen",

    "ribbon.badge": "Im Aufbau",
    "ribbon.text": "Dieser Premium-Bereich wird gebaut (lokal).",
    "ribbon.cta": "E.T Einladung",

    "nav.market.emploi": "Jobs",
    "nav.market.vendre": "Verkaufen",
    "nav.market.acheter": "Kaufen",
    "nav.market.donner": "Geben",
    "nav.market.services": "Services",
    "nav.market.sortie": "Ausgehen",
    "nav.market.voyage": "Reisen",
    "nav.market.sport_loisir": "Sport & Freizeit",
    "nav.market.animaux": "Tiere",
    "nav.media.music": "Musik & Clips",

    "music.title": "Musik",
    "music.hint": "Musik · Clips · Kommentare · Playlists",
    "music.kicker": "Media",
    "music.page_title": "Musik & Video-Clips",
    "music.page_sub": "Online hoeren, Playlists, Favoriten, Kommentare, Rankings. Clips via YouTube (Upload im Aufbau).",
    "music.tabs": "Musik Kategorien",
    "music.detail": "Details",

    "music.tab.genres": "Genres",
    "music.tab.recherche": "Suche",
    "music.tab.classement": "Ranking",
    "music.tab.playlists": "Playlists",
    "music.tab.favoris": "Favoriten",
    "music.tab.clips": "Clips",
    "music.tab.telecharger": "Upload",
    "music.tab.parametres": "Einstellungen",

    "music.desc.genres": "Kategorien, Trends, Suche und Neuheiten.",
    "music.desc.recherche": "Titel suchen nach Name, Artist, Genre oder Kategorie.",
    "music.desc.classement": "Top Views, Ratings, Likes. Rankings nach Stimmung und Genre.",
    "music.desc.playlists": "Playlists erstellen und verwalten. Teilen und schnell abspielen.",
    "music.desc.favoris": "Spaeter ansehen, Likes, Verlauf, Favoriten nach Playlist.",
    "music.desc.clips": "Clips via YouTube. Clip-Upload: im Aufbau.",
    "music.desc.telecharger": "Musik hochladen, Slots (IA / E.T) zuordnen und Online-Bibliothek verwalten.",
    "music.desc.parametres": "Tracks (URL) hinzufuegen, lokalen Speicher und Praeferenzen einstellen.",

    "music.search": "Suche",
    "music.search.ph": "Nach Titel suchen…",
    "music.search.hint": "Tippe einen Titel, um die Bibliothek zu filtern.",
    "music.search.count": "Ergebnisse",
    "music.search.empty.t": "Keine Ergebnisse",
    "music.search.empty.d": "Versuche ein anderes Stichwort.",
    "music.search.rubrics": "Suchrubriken",
    "music.search.rubric.t": "Suche nach Titel",
    "music.search.rubric.d": "Finde schnell einen Track nach Name, Artist, Genre oder Kategorie.",

    "music.upload.rubrics": "Upload Rubriken",
    "music.upload.slots.t": "Slots",
    "music.upload.slots.d": "Track einem Human-KI oder E.T Slot zuordnen.",
    "music.upload.bulk.t": "Upload",
    "music.upload.bulk.d": "Bulk Upload: mehrere Dateien, Auto-Zuordnung wenn gut benannt.",
    "music.upload.rights.t": "Rechte",
    "music.upload.rights.d": "Rechte bestaetigen, bevor du online stellst.",
    "music.upload.library.t": "Bibliothek",
    "music.upload.library.d": "Online-Bibliothek verwalten: ansehen, oeffnen, loeschen.",

    "music.library": "Bibliothek",
    "music.player": "Player",
    "music.filters": "Filter",
    "music.filter.genre": "Genre",
    "music.genre.all": "Alle",
    "music.genre.other": "Andere",

    "music.meta.likes": "Likes",
    "music.meta.later": "Spaeter",
    "music.meta.comments": "Kommentare",

    "music.rank.mode": "Ranking",
    "music.rank.views": "Views",
    "music.rank.ratings": "Ratings",
    "music.rank.likes": "Likes",

    "music.like": "Like",
    "music.later": "Spaeter ansehen",
    "music.share": "Teilen",
    "music.toast.copied": "Link kopiert",
    "music.toast.cleared": "Lokale Daten geloescht",
    "music.toast.added": "Hinzugefuegt",
    "music.toast.need_title_mp3": "Titel + MP3-URL erforderlich",
    "music.toast.need_youtube": "YouTube-Link erforderlich",
    "music.toast.added_clip": "Clip hinzugefuegt",
    "music.toast.playlist_created": "Playlist erstellt",
    "music.toast.added_to_playlist": "Zur Playlist hinzugefuegt",

    "music.rating": "Bewertung",
    "music.rating_clear": "Bewertung loeschen",
    "music.playlist.add": "Hinzufuegen",
    "music.playlist.choose": "Playlist…",
    "music.open_youtube": "Auf YouTube oeffnen",

    "music.comments": "Kommentare",
    "music.comment.add": "Kommentar hinzufuegen",
    "music.comment.emoji_ph": "Emoji (optional)",
    "music.comment.media_ph": "Bild/Video-Link (optional)",
    "music.comment.text_ph": "Schreibe deinen Kommentar…",
    "music.comment.reply_ph": "Antwort an (optional id)",
    "music.comment.post": "Posten",
    "music.comment.open_media": "Media oeffnen",
    "music.comments.empty": "Noch keine Kommentare.",

    "music.playlists.title": "Playlists",
    "music.playlists.name_ph": "Playlist-Name",
    "music.playlists.create": "Erstellen",
    "music.playlists.remove": "Entfernen",
    "music.playlists.empty": "Tracks ueber den Player hinzufuegen.",
    "music.playlists.none": "Keine Playlists",

    "music.settings": "Einstellungen",
    "music.settings.add_track": "Track hinzufuegen (URL)",
    "music.settings.title_ph": "Titel",
    "music.settings.artist_ph": "Kuenstler",
    "music.settings.genre_ph": "Genre",
    "music.settings.mp3_ph": "MP3-URL (https://...)",
    "music.settings.youtube_ph": "YouTube-URL (optional)",
    "music.settings.add": "Hinzufuegen",
    "music.settings.add_clip": "Clip hinzufuegen (YouTube)",
    "music.settings.clip_title_ph": "Titel",
    "music.settings.clip_cat_ph": "Kategorie",
    "music.settings.clip_url_ph": "YouTube-Link (https://...)",
    "music.settings.clip_upload_soon": "Clip-Upload zum Server: im Aufbau.",
    "music.settings.storage": "Lokaler Speicher",
    "music.settings.storage_note": "Demo-Daten (Likes, Views, Playlists, Kommentare) im Browser gespeichert.",
    "music.settings.clear": "Leeren",

    "music.fav.empty.t": "Keine Favoriten",
    "music.fav.empty.d": "Klicke ♥ oder ⏳ bei einem Track, um ihn hier zu sehen.",
    "music.no_track": "Kein Track",

    "music.clips.title": "Video-Clips",
    "music.clips.note": "Clips via YouTube. Upload zum Server: im Aufbau.",
    "music.clips.source": "Quelle",
    "music.clips.bad_url": "Ungueltiger YouTube-Link",
    "music.clips.empty": "Kein Clip",

    "music.genres.rubrics": "Genres Rubriken",
    "music.genres.categories.t": "Kategorien",
    "music.genres.categories.d": "Nach Stil entdecken: Rap, Pop, Electro, Rock, Ambient, Cinematic und mehr.",
    "music.genres.tendances.t": "Trends",
    "music.genres.tendances.d": "Was steigt: Neuheiten, Shares, Community-Favoriten.",
    "music.genres.recherche.t": "Suche",
    "music.genres.recherche.d": "Finde Track, Kuenstler oder Stimmung. Teilen erstellt einen direkten Link.",
    "music.genres.nouveautes.t": "Neu",
    "music.genres.nouveautes.d": "Neueste Adds und Plays. Ein lebendiger Premium-Feed.",

    "music.classement.rubrics": "Ranking Rubriken",
    "music.classement.vues.t": "Views",
    "music.classement.vues.d": "Top meist gehoerte Tracks.",
    "music.classement.notes.t": "Ratings",
    "music.classement.notes.d": "Ranking nach Sternen.",
    "music.classement.jaime.t": "Likes",
    "music.classement.jaime.d": "Deine Likes und was gerade laeuft.",
    "music.classement.categories.t": "Nach Kategorien",
    "music.classement.categories.d": "Toplisten nach Genre und Stimmung.",

    "music.playlists.rubrics": "Playlists Rubriken",
    "music.playlists.creer.t": "Erstellen",
    "music.playlists.creer.d": "Playlists nach Mood: Tempel, Arbeit, Nacht, Reise, usw.",
    "music.playlists.ajouter.t": "Hinzufuegen",
    "music.playlists.ajouter.d": "Tracks mit einem Klick aus dem Player hinzufuegen.",
    "music.playlists.partager.t": "Teilen",
    "music.playlists.partager.d": "Premium-Link zu Playlist oder Track teilen.",
    "music.playlists.lecture.t": "Abspielen",
    "music.playlists.lecture.d": "Dauerwiedergabe, Reihenfolge, Favoriten. Deluxe.",

    "music.favoris.rubrics": "Favoriten Rubriken",
    "music.favoris.plus_tard.t": "Spaeter",
    "music.favoris.plus_tard.d": "Tracks speichern und jederzeit zurueckkommen.",
    "music.favoris.likes.t": "Likes",
    "music.favoris.likes.d": "Deine Favoriten.",
    "music.favoris.playlist.t": "Nach Playlist",
    "music.favoris.playlist.d": "Favoriten in jeder Playlist finden.",
    "music.favoris.historique.t": "Verlauf",
    "music.favoris.historique.d": "Zuletzt gehoert (lokale Demo).",

    "music.clips.rubrics": "Clips Rubriken",
    "music.clips.youtube.t": "YouTube",
    "music.clips.youtube.d": "Jetzt: YouTube-Links (Embed). Spaeter: native Uploads auf Eternua.",
    "music.clips.categories.t": "Kategorien",
    "music.clips.categories.d": "Nach Stil sortieren: Rap, Pop, Electro, Rock, usw.",
    "music.clips.tendances.t": "Trends",
    "music.clips.tendances.d": "Meist gesehen und geteilt (Demo).",
    "music.clips.upload.t": "Upload (bald)",
    "music.clips.upload.d": "Im Aufbau: Clips auf den Server laden.",

    "music.parametres.rubrics": "Einstellungen Rubriken",
    "music.parametres.profil.t": "Praeferenzen",
    "music.parametres.profil.d": "Qualitaet, Autoplay, leiser Modus, Premium-Einstellungen.",
    "music.parametres.confidentialite.t": "Datenschutz",
    "music.parametres.confidentialite.d": "Verwalte, was du teilst und mit wem.",
    "music.parametres.notifications.t": "Benachrichtigungen",
    "music.parametres.notifications.d": "Neue Likes, Kommentare, Playlist-Adds (Backend-Anbindung spaeter).",
    "music.parametres.storage.t": "Lokaler Speicher",
    "music.parametres.storage.d": "Lokale Demo-Daten verwalten (Likes, Views, Kommentare).",

    "emploi.title": "Jobs",
    "emploi.hint": "Angebote · Gesuche · Aufträge · Recruiting",
    "emploi.tabs": "Job Kategorien",
    "emploi.detail": "Details",
    "emploi.tab.offres": "Angebote",
    "emploi.tab.demandes": "Gesuche",
    "emploi.tab.missions": "Aufträge",
    "emploi.tab.recrutement": "Recruiting",
    "emploi.desc.offres": "Stelle Jobangebote ein: Praktika und feste/befristete Stellen. Suchen, filtern, kontaktieren, bewerben.",
    "emploi.desc.demandes": "Veröffentliche dein Gesuch: Skills, Verfügbarkeit, Ort. Recruiter können dich finden.",
    "emploi.desc.missions": "Kurzaufträge, Freelance, Dienstleistungen. Ideal für schnelle Arbeit mit klaren Zielen.",
    "emploi.desc.recrutement": "Recruiting Bereich: Anzeigen, Auswahl, Prozess. Bewerbungen und Gespräche zentralisieren.",

    "nav.menu": "Menu",
    "nav.open": "Navigation offnen",
    "nav.close": "Navigation schliessen",
    "nav.hint_open": "Menu offnen",
    "nav.hint_close": "Menu schliessen",

    "common.open": "Offnen",
    "common.close": "Schliessen",
    "common.refresh": "Aktualisieren",
    "common.back_home": "Zuruck zur Startseite",
    "common.hub_market": "Market Hub",
    "common.friends_feed": "Freunde Feed",
    "common.section_coming": "Bereich im Aufbau",
    "common.mode_dark": "Dunkelmodus",
    "common.mode_light": "Hellmodus",
    "common.back_temples": "Zuruck zu den Tempeln",

    "market.title": "Market",
    "market.hero_sub": "Jobs, Anzeigen, Services, Ausgehen. Dieser Bereich wird lokal gebaut.",
    "market.cat.emploi.desc": "Angebote, Missionen, Recruiting.",
    "market.cat.vendre.desc": "Anzeigen, Produkte, Verkauf.",
    "market.cat.acheter.desc": "Finden und kontaktieren.",
    "market.cat.donner.desc": "Geben, tauschen, helfen.",
    "market.cat.services.desc": "Anfragen und Angebote.",
    "market.cat.sortie.desc": "Events, Ausgehen, Treffen.",
    "market.cat.voyage.desc": "Reisen, Ziele, Begleitung, Routen.",
    "market.cat.sport_loisir.desc": "Aktivitaten zum Teilen.",
    "market.cat.animaux.desc": "Betreuung, Adoption, Hilfe.",

    "acheter.title": "Kaufen",
    "acheter.hint": "Durchsuchen · Filtern · Favoriten · Kontakt",
    "acheter.tabs": "Kaufen Kategorien",
    "acheter.detail": "Details",
    "acheter.soon": "Dieser Bereich ist in Arbeit. Nutze die linke Navigation am Desktop, um alle Rubriken zu erkunden.",
    "acheter.tab.parcourir": "Durchsuchen",
    "acheter.tab.filtrer": "Filtern",
    "acheter.tab.favoris": "Favoriten",
    "acheter.tab.contacter": "Kontakt",
    "acheter.desc.parcourir": "Anzeigen durchsuchen und finden, was du willst.",
    "acheter.desc.filtrer": "Nach Preis, Zone, Zustand und Kategorie filtern.",
    "acheter.desc.favoris": "Favoriten speichern und verfolgen.",
    "acheter.desc.contacter": "Verkaeufer kontaktieren und Kauf organisieren.",

    "acheter.parcourir.rubrics": "Rubriken Durchsuchen",
    "acheter.parcourir.categories.t": "Kategorien",
    "acheter.parcourir.categories.d": "Nach Kategorien durchsuchen: Tech, Zuhause, Mode, etc. (premium).",
    "acheter.parcourir.nouveautes.t": "Neu",
    "acheter.parcourir.nouveautes.d": "Neue Anzeigen und beste Deals entdecken.",
    "acheter.parcourir.proximite.t": "In der Naehe",
    "acheter.parcourir.proximite.d": "Sieh, was nah ist und schnell verfuegbar.",
    "acheter.parcourir.premium.t": "Premium",
    "acheter.parcourir.premium.d": "Verifizierte Anzeigen, vertraute Verkaeufer (bald).",

    "acheter.filtrer.rubrics": "Rubriken Filtern",
    "acheter.filtrer.prix.t": "Preis",
    "acheter.filtrer.prix.d": "Nach Budget und Preisspanne filtern.",
    "acheter.filtrer.etat.t": "Zustand",
    "acheter.filtrer.etat.d": "Neu, wie neu, gebraucht: waehle dein Level.",
    "acheter.filtrer.localisation.t": "Ort",
    "acheter.filtrer.localisation.d": "Stadt, Distanz, Versand: anpassen.",
    "acheter.filtrer.tri.t": "Sortierung",
    "acheter.filtrer.tri.d": "Nach Relevanz, Datum, Preis, Distanz sortieren (premium).",

    "acheter.favoris.rubrics": "Rubriken Favoriten",
    "acheter.favoris.sauver.t": "Speichern",
    "acheter.favoris.sauver.d": "Anzeigen speichern, um sie schnell wiederzufinden.",
    "acheter.favoris.listes.t": "Listen",
    "acheter.favoris.listes.d": "Listen erstellen: Geschenke, Kaeufe, Projekte.",
    "acheter.favoris.alertes.t": "Alerts",
    "acheter.favoris.alertes.d": "Alerts fuer Keywords, Zonen, Preise (bald).",
    "acheter.favoris.suivi.t": "Tracking",
    "acheter.favoris.suivi.d": "Antworten und Status verfolgen.",

    "acheter.contacter.rubrics": "Rubriken Kontakt",
    "acheter.contacter.message.t": "Nachricht",
    "acheter.contacter.message.d": "Verkaeufer anschreiben: Fragen, Verfuegbarkeit, Preis.",
    "acheter.contacter.negocier.t": "Verhandeln",
    "acheter.contacter.negocier.d": "Respektvoll verhandeln: klares Angebot.",
    "acheter.contacter.rdv.t": "Treffen",
    "acheter.contacter.rdv.d": "Treffen ausmachen und Details bestaetigen.",
    "acheter.contacter.securite.t": "Sicherheit",
    "acheter.contacter.securite.d": "Regeln: oeffentlicher Ort, Vorsicht, Pruefung.",

    "vendre.title": "Verkaufen",
    "vendre.hint": "Veröffentliche, verwalte und finalisiere jeden Verkauf in einem privaten Bereich.",
    "vendre.tabs": "Verkaufen Kategorien",
    "vendre.detail": "Details",
    "vendre.soon": "Dieser Bereich ist in Arbeit. Nutze die linke Navigation am Desktop, um alle Rubriken zu erkunden.",
    "vendre.tab.publier": "Normalen Verkauf veröffentlichen",
    "vendre.tab.gerer": "Verwalten",
    "vendre.tab.messages": "Nachrichten",
    "vendre.tab.livraison": "Lieferung",
    "vendre.desc.publier": "Premium Anzeige erstellen: Titel, Fotos, Preis, Kategorie.",
    "vendre.desc.gerer": "Anzeigen verwalten: Bestand, Status, Boost, deaktivieren.",
    "vendre.desc.messages": "Schnell antworten: Verhandlung, Treffen, Sicherheit.",
    "vendre.desc.livraison": "Uebergabe, Versand, Zahlung, Bestaetigung.",

    "vendre.publier.rubrics": "Rubriken Veröffentlichen",
    "vendre.publier.titre.t": "Titel",
    "vendre.publier.titre.d": "Klarer Titel: was, Marke, Groesse, Zustand.",
    "vendre.publier.photos.t": "Fotos",
    "vendre.publier.photos.d": "Scharfe Fotos: Licht, Winkel, Details (premium).",
    "vendre.publier.prix.t": "Preis",
    "vendre.publier.prix.d": "Fairer Preis: vergleichen, Verhandlung, dringend.",
    "vendre.publier.categorie.t": "Kategorie",
    "vendre.publier.categorie.d": "Kategorie und Tags waehlen, um schnell gefunden zu werden.",

    "vendre.gerer.rubrics": "Rubriken Verwalten",
    "vendre.gerer.stock.t": "Bestand",
    "vendre.gerer.stock.d": "Menge, Verfügbarkeit, Reservierungen: alles klar.",
    "vendre.gerer.etat.t": "Status",
    "vendre.gerer.etat.d": "Status aktualisieren: verkauft, reserviert, in Arbeit.",
    "vendre.gerer.boost.t": "Boost",
    "vendre.gerer.boost.d": "Premium Boost: Hervorhebung (bald).",
    "vendre.gerer.desactiver.t": "Deaktivieren",
    "vendre.gerer.desactiver.d": "Temporär deaktivieren ohne Verlust.",

    "vendre.messages.rubrics": "Rubriken Nachrichten",
    "vendre.messages.reponses.t": "Antworten",
    "vendre.messages.reponses.d": "Schnell und praezise antworten: verkauft besser.",
    "vendre.messages.negociation.t": "Verhandlung",
    "vendre.messages.negociation.d": "Respektvoll verhandeln: klares Angebot.",
    "vendre.messages.rdv.t": "Treffen",
    "vendre.messages.rdv.d": "Ort/Zeit festlegen und Details bestaetigen.",
    "vendre.messages.securite.t": "Sicherheit",
    "vendre.messages.securite.d": "Regeln: oeffentlicher Ort, Vorsicht, Pruefung.",

    "vendre.livraison.rubrics": "Rubriken Lieferung",
    "vendre.livraison.mainpropre.t": "Uebergabe",
    "vendre.livraison.mainpropre.d": "Uebergabe an einem sicheren Ort.",
    "vendre.livraison.envoi.t": "Versand",
    "vendre.livraison.envoi.d": "Versand: Paket, Tracking, Zeiten (premium).",
    "vendre.livraison.paiement.t": "Zahlung",
    "vendre.livraison.paiement.d": "Sichere Zahlung und Belege (bald).",
    "vendre.livraison.confirmation.t": "Bestaetigung",
    "vendre.livraison.confirmation.d": "Uebergabe bestaetigen und Verkauf schliessen.",

    "donner.title": "Geben",
    "donner.hint": "Geben · Tauschen · Hilfe · Sammlungen",
    "donner.tabs": "Geben Kategorien",
    "donner.detail": "Details",
    "donner.soon": "Dieser Bereich ist in Arbeit. Nutze die linke Navigation am Desktop, um alle Rubriken zu erkunden.",
    "donner.tab.donner": "Geben",
    "donner.tab.echanger": "Tauschen",
    "donner.tab.entraide": "Hilfe",
    "donner.tab.collectes": "Sammlungen",
    "donner.desc.donner": "Lokales Geben: Sachen, Kleidung, Material.",
    "donner.desc.echanger": "Einfache, passende Tausche ohne Stress.",
    "donner.desc.entraide": "Hilfe unter Mitgliedern: Support, Netzwerk.",
    "donner.desc.collectes": "Solidarische Sammlungen: Transparenz, Tracking, Vertrauen.",

    "donner.donner.rubrics": "Rubriken Geben",
    "donner.donner.publier.t": "Veröffentlichen",
    "donner.donner.publier.d": "Gabe einstellen: Beschreibung, Zustand, Zone, Verfügbarkeit.",
    "donner.donner.localiser.t": "Ort",
    "donner.donner.localiser.d": "Sicheren Uebergabe-Ort festlegen.",
    "donner.donner.conditions.t": "Bedingungen",
    "donner.donner.conditions.d": "Einfache Bedingungen: gratis, Tausch moeglich, Prioritaet.",
    "donner.donner.rejoindre.t": "Reservieren",
    "donner.donner.rejoindre.d": "Reservieren und via Chat bestaetigen.",

    "donner.echanger.rubrics": "Rubriken Tauschen",
    "donner.echanger.proposer.t": "Anbieten",
    "donner.echanger.proposer.d": "Klarer Tausch: Objekt, Wert, Erwartungen.",
    "donner.echanger.negocier.t": "Verhandeln",
    "donner.echanger.negocier.d": "Einfach, respektvoll: schneller Deal.",
    "donner.echanger.securite.t": "Sicherheit",
    "donner.echanger.securite.d": "Tipps: oeffentliche Orte, pruefen, Vorsicht.",
    "donner.echanger.finaliser.t": "Abschliessen",
    "donner.echanger.finaliser.d": "Abschliessen und Feedback geben (bald).",

    "donner.entraide.rubrics": "Rubriken Hilfe",
    "donner.entraide.besoin.t": "Bedarf",
    "donner.entraide.besoin.d": "Bedarf teilen: klar, respektvoll, realistisch.",
    "donner.entraide.proposer.t": "Hilfe anbieten",
    "donner.entraide.proposer.d": "Hilfe anbieten: Zeit, Skills, Material.",
    "donner.entraide.reseau.t": "Netzwerk",
    "donner.entraide.reseau.d": "Netzwerk aktivieren: Freunde, Nachbarn, Communities.",
    "donner.entraide.retour.t": "Feedback",
    "donner.entraide.retour.d": "Feedback und Dank: Vertrauen staerken.",

    "donner.collectes.rubrics": "Rubriken Sammlungen",
    "donner.collectes.lancer.t": "Starten",
    "donner.collectes.lancer.d": "Sammlung starten: Ziel, Dauer, Transparenz.",
    "donner.collectes.dons.t": "Spenden",
    "donner.collectes.dons.d": "Spenden empfangen: Nachrichten, Belege, Tracking (premium).",
    "donner.collectes.transparence.t": "Transparenz",
    "donner.collectes.transparence.d": "Transparenz: Gruende, Ausgaben, Belege.",
    "donner.collectes.suivi.t": "Tracking",
    "donner.collectes.suivi.d": "Tracking: Fortschritt, Schritte, Abschluss.",

    "services.title": "Services",
    "services.hint": "Anbieten · Anfragen · Finden · Angebote",
    "services.tabs": "Services Kategorien",
    "services.detail": "Details",
    "services.soon": "Dieser Bereich ist in Arbeit. Nutze die linke Navigation am Desktop, um alle Rubriken zu erkunden.",
    "services.tab.proposer": "Anbieten",
    "services.tab.demander": "Anfragen",
    "services.tab.trouver": "Finden",
    "services.tab.devis": "Angebote",
    "services.desc.proposer": "Biete deine Services und Skills an.",
    "services.desc.demander": "Service anfragen: Bedarf, Budget, Zone.",
    "services.desc.trouver": "Anbieter nach Bewertungen, Preis, Naehe finden.",
    "services.desc.devis": "Angebote, Bedingungen, Zahlung, Tracking (premium).",

    "services.proposer.rubrics": "Rubriken Anbieten",
    "services.proposer.publier.t": "Veröffentlichen",
    "services.proposer.publier.d": "Service klar einstellen: Kategorie, Beschreibung, Zone, Verfügbarkeit.",
    "services.proposer.tarifs.t": "Preise",
    "services.proposer.tarifs.d": "Einfache Preise: Stunden, Festpreis, Pakete. Premium Transparenz.",
    "services.proposer.planning.t": "Plan",
    "services.proposer.planning.d": "Slots verwalten und Anfragen bestaetigen (bald).",
    "services.proposer.avis.t": "Bewertungen",
    "services.proposer.avis.d": "Bewertungen und Ruf: Vertrauen aufbauen, Resultate zeigen.",

    "services.demander.rubrics": "Rubriken Anfragen",
    "services.demander.decrire.t": "Beschreiben",
    "services.demander.decrire.d": "Bedarf beschreiben: Ziel, Constraints, Deadline, Budget.",
    "services.demander.budget.t": "Budget",
    "services.demander.budget.d": "Budget oder Spanne angeben, um passende Profile zu finden.",
    "services.demander.zone.t": "Zone",
    "services.demander.zone.d": "Waehle: Zuhause, Remote oder Hybrid.",
    "services.demander.urgence.t": "Dringend",
    "services.demander.urgence.d": "Dringender Bedarf? Dringlichkeit markieren (premium).",

    "services.trouver.rubrics": "Rubriken Finden",
    "services.trouver.parcourir.t": "Durchsuchen",
    "services.trouver.parcourir.d": "Services nach Kategorie, Zone, Verfügbarkeit, Bewertungen durchsuchen.",
    "services.trouver.filtrer.t": "Filtern",
    "services.trouver.filtrer.d": "Nach Preis, Distanz, Rating, Service-Typ filtern.",
    "services.trouver.contacter.t": "Kontakt",
    "services.trouver.contacter.d": "Direktkontakt: Bedarf klaeren und Termin bestaetigen.",
    "services.trouver.securite.t": "Sicherheit",
    "services.trouver.securite.d": "Sicherheitsregeln und Best Practices (premium).",

    "services.devis.rubrics": "Rubriken Angebote",
    "services.devis.comparaison.t": "Vergleichen",
    "services.devis.comparaison.d": "Angebote vergleichen: Preis, Zeit, Garantien.",
    "services.devis.conditions.t": "Bedingungen",
    "services.devis.conditions.d": "Klare Bedingungen: Scope, Revisionen, Storno.",
    "services.devis.paiement.t": "Zahlung",
    "services.devis.paiement.d": "Sichere Zahlung und Milestones (bald).",
    "services.devis.suivi.t": "Tracking",
    "services.devis.suivi.d": "Tracking: Nachrichten, Validierung, Abschluss (premium).",

    "sortie.title": "Ausgehen",
    "sortie.hint": "Events · Ausgehen · Treffen · Clubs",
    "sortie.tabs": "Ausgehen Kategorien",
    "sortie.detail": "Details",
    "sortie.soon": "Dieser Bereich ist in Arbeit. Nutze die linke Navigation am Desktop, um alle Rubriken zu erkunden.",
    "sortie.tab.events": "Events",
    "sortie.tab.sorties": "Ausgehen",
    "sortie.tab.rencontres": "Treffen",
    "sortie.tab.clubs": "Clubs",
    "sortie.desc.events": "Premium Agenda, Events, Abende.",
    "sortie.desc.sorties": "Lokale Ausgaenge vorschlagen und beitreten.",
    "sortie.desc.rencontres": "Freundliche, thematische Treffen.",
    "sortie.desc.clubs": "Clubs und Gruppen: organisieren, chatten, treffen.",

    "sortie.events.rubrics": "Rubriken Events",
    "sortie.events.agenda.t": "Agenda",
    "sortie.events.agenda.d": "Premium Agenda: Datum, Ort, Thema, Tickets (bald).",
    "sortie.events.proposer.t": "Vorschlagen",
    "sortie.events.proposer.d": "Event vorschlagen: klare Infos, Plaetze, Vibe.",
    "sortie.events.filtrer.t": "Filtern",
    "sortie.events.filtrer.d": "Nach Stadt, Datum, Budget, Stil, Sicherheit filtern.",
    "sortie.events.rejoindre.t": "Beitreten",
    "sortie.events.rejoindre.d": "Event beitreten und vorher chatten.",

    "sortie.sorties.rubrics": "Rubriken Ausgehen",
    "sortie.sorties.lieux.t": "Orte",
    "sortie.sorties.lieux.d": "Bars, Parks, Museen, Spaziergaenge: Orte entdecken.",
    "sortie.sorties.groupes.t": "Gruppen",
    "sortie.sorties.groupes.d": "Gruppen-Ausgaenge: einfacher, sicherer, mehr Spass.",
    "sortie.sorties.moments.t": "Momente",
    "sortie.sorties.moments.d": "Essen, Kino, Spaziergang, Kaffee: passende Momente.",
    "sortie.sorties.chat.t": "Chat",
    "sortie.sorties.chat.d": "Chat fuer die Aktivitaet: organisieren und bestaetigen.",

    "sortie.rencontres.rubrics": "Rubriken Treffen",
    "sortie.rencontres.match.t": "Match",
    "sortie.rencontres.match.d": "Treffen nach Affinitaet: Interessen, Vibe.",
    "sortie.rencontres.securite.t": "Sicherheit",
    "sortie.rencontres.securite.d": "Regeln und Tools: gesunde, respektvolle Treffen.",
    "sortie.rencontres.themes.t": "Themen",
    "sortie.rencontres.themes.d": "Themen-Treffen: Kultur, Sport, Spiritualitaet.",
    "sortie.rencontres.inviter.t": "Einladen",
    "sortie.rencontres.inviter.d": "Freunde einladen oder offenes Treffen vorschlagen.",

    "sortie.clubs.rubrics": "Rubriken Clubs",
    "sortie.clubs.rechercher.t": "Suchen",
    "sortie.clubs.rechercher.d": "Club nach Stadt, Thema, Level, Zeitplan finden.",
    "sortie.clubs.creer.t": "Erstellen",
    "sortie.clubs.creer.d": "Premium Club erstellen: Regeln, Ziele, Onboarding.",
    "sortie.clubs.planning.t": "Plan",
    "sortie.clubs.planning.d": "Geteilter Plan: Daten, Orte, Erinnerungen (bald).",
    "sortie.clubs.regles.t": "Regeln",
    "sortie.clubs.regles.d": "Klare Regeln: Respekt, Sicherheit, Freundlichkeit.",

    "voyage.title": "Reisen",
    "voyage.hint": "Ziele · Route · Mitreisende · Unterkunft",
    "voyage.tabs": "Reise-Kategorien",
    "voyage.detail": "Details",
    "voyage.soon": "Dieser Bereich ist in Arbeit. Nutze die linke Navigation am Desktop, um alle Rubriken zu erkunden.",
    "voyage.tab.destinations": "Ziele",
    "voyage.tab.itineraire": "Route",
    "voyage.tab.covoyage": "Mitreise",
    "voyage.tab.hebergement": "Unterkunft",
    "voyage.tab.conseils": "Tipps",
    "voyage.desc.destinations": "Entdecke und waehle dein naechstes Ziel.",
    "voyage.desc.itineraire": "Plane deine Route und dein Tempo.",
    "voyage.desc.covoyage": "Finde passende, freundliche Mitreisende.",
    "voyage.desc.hebergement": "Unterkuenfte, Austausch, gute Deals.",
    "voyage.desc.conseils": "Praktische Tipps, Sicherheit, lokale Kultur.",

    "voyage.destinations.rubrics": "Rubriken Ziele",
    "voyage.destinations.decouvrir.t": "Entdecken",
    "voyage.destinations.decouvrir.d": "Ziele nach Stimmung, Saison, Budget entdecken (premium).",
    "voyage.destinations.tendances.t": "Trends",
    "voyage.destinations.tendances.d": "Sieh, was laeuft: Orte, Events, Communities.",
    "voyage.destinations.budget.t": "Budget",
    "voyage.destinations.budget.d": "Kosten fuer Transport, Essen, Unterkunft schaetzen.",
    "voyage.destinations.securite.t": "Sicherheit",
    "voyage.destinations.securite.d": "Tipps, Zonen, Verhalten, Vorsicht.",

    "voyage.itineraire.rubrics": "Rubriken Route",
    "voyage.itineraire.planifier.t": "Planen",
    "voyage.itineraire.planifier.d": "Klare Route: Stops, Dauer, Prioritaeten.",
    "voyage.itineraire.jours.t": "Tage & Stops",
    "voyage.itineraire.jours.d": "Nach Tagen strukturieren: Orte, Zeiten, Buchungen.",
    "voyage.itineraire.checklist.t": "Checkliste",
    "voyage.itineraire.checklist.d": "Dokumente, Gepaeck, Gesundheit: stressfrei vorbereiten.",
    "voyage.itineraire.partager.t": "Teilen",
    "voyage.itineraire.partager.d": "Teile deine Route mit Freunden oder Mitreisenden.",

    "voyage.covoyage.rubrics": "Rubriken Mitreise",
    "voyage.covoyage.trouver.t": "Finden",
    "voyage.covoyage.trouver.d": "Mitreisende nach Ziel, Datum, Vibe finden.",
    "voyage.covoyage.profil.t": "Profil",
    "voyage.covoyage.profil.d": "Stil zeigen: Budget, Tempo, Interessen.",
    "voyage.covoyage.match.t": "Match",
    "voyage.covoyage.match.d": "Verantwortungsvolles Match: Ziele, Grenzen, Sicherheit.",
    "voyage.covoyage.chat.t": "Chat",
    "voyage.covoyage.chat.d": "Vorher schreiben und organisieren.",

    "voyage.hebergement.rubrics": "Rubriken Unterkunft",
    "voyage.hebergement.chercher.t": "Suchen",
    "voyage.hebergement.chercher.d": "Unterkunft nach Budget und Bedarf finden.",
    "voyage.hebergement.partager.t": "Teilen",
    "voyage.hebergement.partager.d": "Unterkunft anbieten oder tauschen (premium).",
    "voyage.hebergement.dates.t": "Daten",
    "voyage.hebergement.dates.d": "Verfuegbarkeiten, Zeitraeume, Bestaetigungen verwalten.",
    "voyage.hebergement.regles.t": "Regeln",
    "voyage.hebergement.regles.d": "Regeln klaeren fuer eine ruhige Erfahrung.",

    "voyage.conseils.rubrics": "Rubriken Tipps",
    "voyage.conseils.formalites.t": "Formalitaeten",
    "voyage.conseils.formalites.d": "Pass, Visa, Versicherungen (premium).",
    "voyage.conseils.sante.t": "Gesundheit",
    "voyage.conseils.sante.d": "Impfungen, Medikamente, Praevention.",
    "voyage.conseils.culture.t": "Kultur",
    "voyage.conseils.culture.d": "Lokaler Respekt, Codes, gute Praxis.",
    "voyage.conseils.astuces.t": "Tricks",
    "voyage.conseils.astuces.d": "Tipps fuer Budget, Transport, Organisation.",

    "civet.search_ph": "E.T Zivilisation suchen…",
    "civet.hint": "Verbundete Zivilisationen · Schnellzugriff",
    "civet.hub": "Alle Zivilisationen ansehen",
    "civtemple.kicker": "TEMPEL DER ENTWICKELTEN ZIVILISATIONEN",
    "civtemple.title": "Verbundete E.T Zivilisationen — Brucken des Unendlichen des Unendlichen",

    "civhub.title": "Zentraler Tempel der kosmischen Allianzen",
    "civhub.subtitle": "Dieser Tempel ist das zentrale Hub der 12 E.T Zivilisationen, die mit der Erde verbundet sind. Er zeigt eine kosmische Karte heiliger Routen, eine intergalaktische Zeitleiste und direkten Zugang zum Heiligen Buch der E.T Zivilisationen.",
    "civhub.open_book": "Das Buch der 12 Allianzen offnen",
    "civhub.enter_temple_of": "Den Tempel betreten von",

    "ia40.title": "Rolle der 40 menschlichen KIs",
    "ia40.hint": "4 Familien · je 10 KIs",
    "ia40.f1": "1. Pflege und Bewusstsein",
    "ia40.f2": "2. Gerechtigkeit und soziale Stabilitat",
    "ia40.f3": "3. Erde und Systeme",
    "ia40.f4": "4. Kosmisch und Zwischenwelten",

    "langnote.kicker": "Ubersetzung",
    "langnote.title": "Diese Seite ist noch auf Franzosisch",
    "langnote.text": "Die Oberflache ist ubersetzt, aber lange Inhalte werden noch ubersetzt. Wechsle zu Franzosisch fur die vollstandige Version.",
    "langnote.to_fr": "Zu Franzosisch wechseln",

    "auth.login": "Anmelden",
    "auth.register": "Registrieren",
    "auth.logout": "Abmelden",

    "nav.home": "Start",
    "nav.temple": "Tempel",
    "nav.forum": "Forum",
    "nav.book": "Heiliges Buch",
    "nav.profile": "Profil",
    "nav.notifications.open": "Benachrichtigungsverlauf offnen",
    "nav.notifications": "Benachrichtigungen",
    "nav.friends": "Freunde",
    "nav.friends_feed": "Freunde Feed",
    "nav.friends_lounge": "Freunde Lounge",
    "nav.temples": "Tempel",
    "nav.creator_temple": "Schopfer Tempel",
    "nav.admin": "Admin",

    "theme.mode_dark": "Dunkelmodus",
    "theme.mode_light": "Hellmodus",

    "dock.join": "Beitreten",
    "dock.join_call_aria": "Dem Videoanruf beitreten",
    "dock.discussions": "Chats",
    "dock.open_discussions": "Chats offnen",
    "dock.close_discussions": "Chats schliessen",
    "dock.unread_messages": "Neue Nachrichten",
    "dock.back_home": "Zuruck zur Startseite",
    "dock.friends_actions": "Freunde Aktionen",
    "dock.feed": "Feed",
    "dock.music": "Musik",
    "dock.friends": "Freunde",
    "dock.requests": "Anfragen",
    "dock.new": "Neu",
    "dock.calls": "Anrufe",
    "dock.lounge": "Freunde Lounge",
    "dock.hidden_guest": "Melde dich an, um deine Freunde zu sehen und die Seite zu nutzen",
    "dock.hidden_authed": "Sieh deine Freunde und erweitere dein unendliches Netzwerk",

    "book.writing": "Text wird geschrieben…",
    "book.chapters": "Kapitel",
    "book.search": "Kapitel suchen...",
    "book.your_favs": "Deine Lieblingskapitel",
    "book.favorite": "Favorit",
    ...VOYAGE_DELUXE_TRANSLATIONS.de,
    ...IMMOBILIER_TRANSLATIONS.de,
    ...CONFIRMATION_TRANSLATIONS.de,
  },
  et: {
    "acheter.mobile.browse": "Découvrir",
    "acheter.mobile.filters": "Filtres",
    "acheter.mobile.favorites": "Favoris",
    "acheter.mobile.messages": "Messages",
    "acheter.mobile.orders": "Mes achats",
    "acheter.mobile.open_browse": "Voir les annonces",
    "acheter.mobile.open_filters": "Ouvrir les filtres",
    "acheter.mobile.open_favorites": "Voir mes favoris",
    "acheter.mobile.open_messages": "Ouvrir mes messages",
    "acheter.mobile.open_orders": "Suivre mes achats",
    "acheter.mobile.intro": "Tout pour trouver, choisir et suivre vos achats.",
    "acheter.mobile.shortcuts": "Accès rapides",
    "acheter.mobile.cart": "Panier",
    "lang.name": "Extraterrestre",
    "lang.select": "Langue",

    // Placeholder "alien" language: keep human readable for now.
    "header.invite_et": "Invitation E.T (futur)",
    "header.search_et_ph": "Recherche E.T (futur)…",

    "subnav.temple_ia40": "Temple 40 IA (futur)",
    "subnav.temple_et": "Temple E.T (futur)",

    "ribbon.badge": "En construction",
    "ribbon.text": "Langue extraterrestre a incorporer plus tard.",
    "ribbon.cta": "Invitation E.T",

    "nav.market.emploi": "Emploi (futur)",
    "nav.market.vendre": "Vendre (futur)",
    "nav.market.acheter": "Acheter (futur)",
    "nav.market.donner": "Donner (futur)",
    "nav.market.services": "Services (futur)",
    "nav.market.sortie": "Sortie (futur)",
    "nav.market.voyage": "Voyage (futur)",
    "nav.market.sport_loisir": "Sport & loisir (futur)",
    "nav.market.animaux": "Animaux (futur)",
    "nav.media.music": "Musique & clips (futur)",

    "music.title": "Musique (futur)",
    "music.hint": "Musique · Clips · Commentaires · Playlists (futur)",
    "music.kicker": "Media",
    "music.page_title": "Musique & Clips video (futur)",
    "music.page_sub": "En construction (futur).",
    "music.tabs": "Categories Musique (futur)",
    "music.detail": "Detail",

    "music.tab.genres": "Genres (futur)",
    "music.tab.recherche": "Recherche (futur)",
    "music.tab.classement": "Classement (futur)",
    "music.tab.playlists": "Playlists (futur)",
    "music.tab.favoris": "Favoris (futur)",
    "music.tab.clips": "Clips (futur)",
    "music.tab.telecharger": "Telecharger (futur)",
    "music.tab.parametres": "Parametres (futur)",

    "music.desc.genres": "En construction.",
    "music.desc.recherche": "En construction.",
    "music.desc.classement": "En construction.",
    "music.desc.playlists": "En construction.",
    "music.desc.favoris": "En construction.",
    "music.desc.clips": "En construction.",
    "music.desc.telecharger": "En construction.",
    "music.desc.parametres": "En construction.",

    "music.search": "Recherche",
    "music.search.ph": "Rechercher…",
    "music.search.hint": "Tape un titre pour filtrer.",
    "music.search.count": "Resultats",
    "music.search.empty.t": "Rien trouve",
    "music.search.empty.d": "Essaie autre chose.",
    "music.search.rubrics": "Rubriques",
    "music.search.rubric.t": "Recherche",
    "music.search.rubric.d": "Trouver par titre / artiste / genre.",

    "music.upload.rubrics": "Rubriques",
    "music.upload.slots.t": "Slots",
    "music.upload.slots.d": "En construction.",
    "music.upload.bulk.t": "Upload",
    "music.upload.bulk.d": "En construction.",
    "music.upload.rights.t": "Droits",
    "music.upload.rights.d": "En construction.",
    "music.upload.library.t": "Bibliotheque",
    "music.upload.library.d": "En construction.",

    "music.library": "Bibliotheque (futur)",
    "music.player": "Lecteur (futur)",
    "music.filters": "Filtres",
    "music.filter.genre": "Genre",
    "music.genre.all": "Tous",
    "music.genre.other": "Autre",

    "music.meta.likes": "J’aime",
    "music.meta.later": "Plus tard",
    "music.meta.comments": "Commentaires",

    "music.rank.mode": "Classement",
    "music.rank.views": "Vues",
    "music.rank.ratings": "Notes",
    "music.rank.likes": "J’aime",

    "music.like": "J’aime",
    "music.later": "Plus tard",
    "music.share": "Partager",
    "music.toast.copied": "Lien copie",
    "music.toast.cleared": "Donnees locales supprimees",
    "music.toast.added": "Ajoute",
    "music.toast.need_title_mp3": "Titre + MP3 URL requis",
    "music.toast.need_youtube": "Lien YouTube requis",
    "music.toast.added_clip": "Clip ajoute",
    "music.toast.playlist_created": "Playlist creee",
    "music.toast.added_to_playlist": "Ajoute a la playlist",

    "music.rating": "Note",
    "music.rating_clear": "Effacer la note",
    "music.playlist.add": "Ajouter",
    "music.playlist.choose": "Playlist…",
    "music.open_youtube": "Ouvrir sur YouTube",

    "music.comments": "Commentaires",
    "music.comment.add": "Ajouter un commentaire",
    "music.comment.emoji_ph": "Emoji (optionnel)",
    "music.comment.media_ph": "Lien image/video (optionnel)",
    "music.comment.text_ph": "Ecris ton commentaire…",
    "music.comment.reply_ph": "Repondre a (id optionnel)",
    "music.comment.post": "Publier",
    "music.comment.open_media": "Ouvrir le media",
    "music.comments.empty": "Aucun commentaire.",

    "music.playlists.title": "Playlists",
    "music.playlists.name_ph": "Nom de playlist",
    "music.playlists.create": "Creer",
    "music.playlists.remove": "Retirer",
    "music.playlists.empty": "En construction.",
    "music.playlists.none": "Aucune playlist",

    "music.settings": "Parametres",
    "music.settings.add_track": "Ajouter une musique (URL)",
    "music.settings.title_ph": "Titre",
    "music.settings.artist_ph": "Artiste",
    "music.settings.genre_ph": "Genre",
    "music.settings.mp3_ph": "MP3 URL (https://...)",
    "music.settings.youtube_ph": "YouTube URL (optionnel)",
    "music.settings.add": "Ajouter",
    "music.settings.add_clip": "Ajouter un clip (YouTube)",
    "music.settings.clip_title_ph": "Titre",
    "music.settings.clip_cat_ph": "Categorie",
    "music.settings.clip_url_ph": "Lien YouTube (https://...)",
    "music.settings.clip_upload_soon": "En construction.",
    "music.settings.storage": "Stockage local",
    "music.settings.storage_note": "En construction.",
    "music.settings.clear": "Vider",

    "music.fav.empty.t": "Aucun favori",
    "music.fav.empty.d": "En construction.",
    "music.no_track": "Aucun titre",

    "music.clips.title": "Clips video",
    "music.clips.note": "En construction.",
    "music.clips.source": "Source",
    "music.clips.bad_url": "Lien YouTube invalide",
    "music.clips.empty": "Aucun clip",

    "music.genres.rubrics": "Rubriques",
    "music.genres.categories.t": "Categories",
    "music.genres.categories.d": "En construction.",
    "music.genres.tendances.t": "Tendances",
    "music.genres.tendances.d": "En construction.",
    "music.genres.recherche.t": "Recherche",
    "music.genres.recherche.d": "En construction.",
    "music.genres.nouveautes.t": "Nouveautes",
    "music.genres.nouveautes.d": "En construction.",

    "music.classement.rubrics": "Rubriques",
    "music.classement.vues.t": "Vues",
    "music.classement.vues.d": "En construction.",
    "music.classement.notes.t": "Notes",
    "music.classement.notes.d": "En construction.",
    "music.classement.jaime.t": "J’aime",
    "music.classement.jaime.d": "En construction.",
    "music.classement.categories.t": "Par categories",
    "music.classement.categories.d": "En construction.",

    "music.playlists.rubrics": "Rubriques",
    "music.playlists.creer.t": "Creer",
    "music.playlists.creer.d": "En construction.",
    "music.playlists.ajouter.t": "Ajouter",
    "music.playlists.ajouter.d": "En construction.",
    "music.playlists.partager.t": "Partager",
    "music.playlists.partager.d": "En construction.",
    "music.playlists.lecture.t": "Lecture",
    "music.playlists.lecture.d": "En construction.",

    "music.favoris.rubrics": "Rubriques",
    "music.favoris.plus_tard.t": "Plus tard",
    "music.favoris.plus_tard.d": "En construction.",
    "music.favoris.likes.t": "J’aime",
    "music.favoris.likes.d": "En construction.",
    "music.favoris.playlist.t": "Playlist",
    "music.favoris.playlist.d": "En construction.",
    "music.favoris.historique.t": "Historique",
    "music.favoris.historique.d": "En construction.",

    "music.clips.rubrics": "Rubriques",
    "music.clips.youtube.t": "YouTube",
    "music.clips.youtube.d": "En construction.",
    "music.clips.categories.t": "Categories",
    "music.clips.categories.d": "En construction.",
    "music.clips.tendances.t": "Tendances",
    "music.clips.tendances.d": "En construction.",
    "music.clips.upload.t": "Upload",
    "music.clips.upload.d": "En construction.",

    "music.parametres.rubrics": "Rubriques",
    "music.parametres.profil.t": "Preferences",
    "music.parametres.profil.d": "En construction.",
    "music.parametres.confidentialite.t": "Confidentialite",
    "music.parametres.confidentialite.d": "En construction.",
    "music.parametres.notifications.t": "Notifications",
    "music.parametres.notifications.d": "En construction.",
    "music.parametres.storage.t": "Stockage",
    "music.parametres.storage.d": "En construction.",

    "emploi.title": "Emploi (futur)",
    "emploi.hint": "En construction.",
    "emploi.tabs": "En construction.",
    "emploi.detail": "En construction.",
    "emploi.tab.offres": "Offres (futur)",
    "emploi.tab.demandes": "Demandes (futur)",
    "emploi.tab.missions": "Missions (futur)",
    "emploi.tab.recrutement": "Recrutement (futur)",
    "emploi.desc.offres": "En construction.",
    "emploi.desc.demandes": "En construction.",
    "emploi.desc.missions": "En construction.",
    "emploi.desc.recrutement": "En construction.",

    "nav.menu": "Menu",
    "nav.open": "Ouvrir navigation (futur)",
    "nav.close": "Fermer navigation (futur)",
    "nav.hint_open": "Ouvrir menu (futur)",
    "nav.hint_close": "Fermer menu (futur)",

    "common.open": "Ouvrir",
    "common.close": "Fermer",
    "common.refresh": "Actualiser",
    "common.back_home": "Retour accueil",
    "common.hub_market": "Hub market",
    "common.friends_feed": "Fil d’actualite amis",
    "common.section_coming": "Section en construction",
    "common.mode_dark": "Mode sombre",
    "common.mode_light": "Mode clair",
    "common.back_temples": "Revenir aux Temples",

    "market.title": "Market (futur)",
    "market.hero_sub": "Traduction extraterrestre a incorporer plus tard.",
    "market.cat.emploi.desc": "En construction.",
    "market.cat.vendre.desc": "En construction.",
    "market.cat.acheter.desc": "En construction.",
    "market.cat.donner.desc": "En construction.",
    "market.cat.services.desc": "En construction.",
    "market.cat.sortie.desc": "En construction.",
    "market.cat.voyage.desc": "En construction.",
    "market.cat.sport_loisir.desc": "En construction.",
    "market.cat.animaux.desc": "En construction.",

    "acheter.title": "Acheter",
    "acheter.hint": "En construction.",
    "acheter.tabs": "En construction.",
    "acheter.detail": "En construction.",
    "acheter.soon": "En construction.",
    "acheter.tab.parcourir": "Parcourir",
    "acheter.tab.filtrer": "Filtrer",
    "acheter.tab.favoris": "Favoris",
    "acheter.tab.contacter": "Contacter",
    "acheter.desc.parcourir": "En construction.",
    "acheter.desc.filtrer": "En construction.",
    "acheter.desc.favoris": "En construction.",
    "acheter.desc.contacter": "En construction.",

    "acheter.parcourir.rubrics": "Rubriques",
    "acheter.parcourir.categories.t": "Categories",
    "acheter.parcourir.categories.d": "En construction.",
    "acheter.parcourir.nouveautes.t": "Nouveautes",
    "acheter.parcourir.nouveautes.d": "En construction.",
    "acheter.parcourir.proximite.t": "Proximite",
    "acheter.parcourir.proximite.d": "En construction.",
    "acheter.parcourir.premium.t": "Premium",
    "acheter.parcourir.premium.d": "En construction.",

    "acheter.filtrer.rubrics": "Rubriques",
    "acheter.filtrer.prix.t": "Prix",
    "acheter.filtrer.prix.d": "En construction.",
    "acheter.filtrer.etat.t": "Etat",
    "acheter.filtrer.etat.d": "En construction.",
    "acheter.filtrer.localisation.t": "Localisation",
    "acheter.filtrer.localisation.d": "En construction.",
    "acheter.filtrer.tri.t": "Tri",
    "acheter.filtrer.tri.d": "En construction.",

    "acheter.favoris.rubrics": "Rubriques",
    "acheter.favoris.sauver.t": "Sauver",
    "acheter.favoris.sauver.d": "En construction.",
    "acheter.favoris.listes.t": "Listes",
    "acheter.favoris.listes.d": "En construction.",
    "acheter.favoris.alertes.t": "Alertes",
    "acheter.favoris.alertes.d": "En construction.",
    "acheter.favoris.suivi.t": "Suivi",
    "acheter.favoris.suivi.d": "En construction.",

    "acheter.contacter.rubrics": "Rubriques",
    "acheter.contacter.message.t": "Message",
    "acheter.contacter.message.d": "En construction.",
    "acheter.contacter.negocier.t": "Negocier",
    "acheter.contacter.negocier.d": "En construction.",
    "acheter.contacter.rdv.t": "RDV",
    "acheter.contacter.rdv.d": "En construction.",
    "acheter.contacter.securite.t": "Securite",
    "acheter.contacter.securite.d": "En construction.",

    "vendre.title": "Vendre",
    "vendre.hint": "En construction.",
    "vendre.tabs": "En construction.",
    "vendre.detail": "En construction.",
    "vendre.soon": "En construction.",
    "vendre.tab.publier": "Publier vente normale",
    "vendre.tab.gerer": "Gerer",
    "vendre.tab.messages": "Messages",
    "vendre.tab.livraison": "Livraison",
    "vendre.desc.publier": "En construction.",
    "vendre.desc.gerer": "En construction.",
    "vendre.desc.messages": "En construction.",
    "vendre.desc.livraison": "En construction.",

    "vendre.publier.rubrics": "Rubriques",
    "vendre.publier.titre.t": "Titre",
    "vendre.publier.titre.d": "En construction.",
    "vendre.publier.photos.t": "Photos",
    "vendre.publier.photos.d": "En construction.",
    "vendre.publier.prix.t": "Prix",
    "vendre.publier.prix.d": "En construction.",
    "vendre.publier.categorie.t": "Categorie",
    "vendre.publier.categorie.d": "En construction.",

    "vendre.gerer.rubrics": "Rubriques",
    "vendre.gerer.stock.t": "Stock",
    "vendre.gerer.stock.d": "En construction.",
    "vendre.gerer.etat.t": "Etat",
    "vendre.gerer.etat.d": "En construction.",
    "vendre.gerer.boost.t": "Boost",
    "vendre.gerer.boost.d": "En construction.",
    "vendre.gerer.desactiver.t": "Desactiver",
    "vendre.gerer.desactiver.d": "En construction.",

    "vendre.messages.rubrics": "Rubriques",
    "vendre.messages.reponses.t": "Reponses",
    "vendre.messages.reponses.d": "En construction.",
    "vendre.messages.negociation.t": "Negociation",
    "vendre.messages.negociation.d": "En construction.",
    "vendre.messages.rdv.t": "RDV",
    "vendre.messages.rdv.d": "En construction.",
    "vendre.messages.securite.t": "Securite",
    "vendre.messages.securite.d": "En construction.",

    "vendre.livraison.rubrics": "Rubriques",
    "vendre.livraison.mainpropre.t": "Main propre",
    "vendre.livraison.mainpropre.d": "En construction.",
    "vendre.livraison.envoi.t": "Envoi",
    "vendre.livraison.envoi.d": "En construction.",
    "vendre.livraison.paiement.t": "Paiement",
    "vendre.livraison.paiement.d": "En construction.",
    "vendre.livraison.confirmation.t": "Confirmation",
    "vendre.livraison.confirmation.d": "En construction.",

    "donner.title": "Donner",
    "donner.hint": "En construction.",
    "donner.tabs": "En construction.",
    "donner.detail": "En construction.",
    "donner.soon": "En construction.",
    "donner.tab.donner": "Donner",
    "donner.tab.echanger": "Echanger",
    "donner.tab.entraide": "Entraide",
    "donner.tab.collectes": "Collectes",
    "donner.desc.donner": "En construction.",
    "donner.desc.echanger": "En construction.",
    "donner.desc.entraide": "En construction.",
    "donner.desc.collectes": "En construction.",

    "donner.donner.rubrics": "Rubriques",
    "donner.donner.publier.t": "Publier",
    "donner.donner.publier.d": "En construction.",
    "donner.donner.localiser.t": "Localiser",
    "donner.donner.localiser.d": "En construction.",
    "donner.donner.conditions.t": "Conditions",
    "donner.donner.conditions.d": "En construction.",
    "donner.donner.rejoindre.t": "Rejoindre",
    "donner.donner.rejoindre.d": "En construction.",

    "donner.echanger.rubrics": "Rubriques",
    "donner.echanger.proposer.t": "Proposer",
    "donner.echanger.proposer.d": "En construction.",
    "donner.echanger.negocier.t": "Negocier",
    "donner.echanger.negocier.d": "En construction.",
    "donner.echanger.securite.t": "Securite",
    "donner.echanger.securite.d": "En construction.",
    "donner.echanger.finaliser.t": "Finaliser",
    "donner.echanger.finaliser.d": "En construction.",

    "donner.entraide.rubrics": "Rubriques",
    "donner.entraide.besoin.t": "Besoin",
    "donner.entraide.besoin.d": "En construction.",
    "donner.entraide.proposer.t": "Proposer",
    "donner.entraide.proposer.d": "En construction.",
    "donner.entraide.reseau.t": "Reseau",
    "donner.entraide.reseau.d": "En construction.",
    "donner.entraide.retour.t": "Retour",
    "donner.entraide.retour.d": "En construction.",

    "donner.collectes.rubrics": "Rubriques",
    "donner.collectes.lancer.t": "Lancer",
    "donner.collectes.lancer.d": "En construction.",
    "donner.collectes.dons.t": "Dons",
    "donner.collectes.dons.d": "En construction.",
    "donner.collectes.transparence.t": "Transparence",
    "donner.collectes.transparence.d": "En construction.",
    "donner.collectes.suivi.t": "Suivi",
    "donner.collectes.suivi.d": "En construction.",

    "services.title": "Services",
    "services.hint": "En construction.",
    "services.tabs": "En construction.",
    "services.detail": "En construction.",
    "services.soon": "En construction.",
    "services.tab.proposer": "Proposer",
    "services.tab.demander": "Demander",
    "services.tab.trouver": "Trouver",
    "services.tab.devis": "Devis",
    "services.desc.proposer": "En construction.",
    "services.desc.demander": "En construction.",
    "services.desc.trouver": "En construction.",
    "services.desc.devis": "En construction.",

    "services.proposer.rubrics": "Rubriques",
    "services.proposer.publier.t": "Publier",
    "services.proposer.publier.d": "En construction.",
    "services.proposer.tarifs.t": "Tarifs",
    "services.proposer.tarifs.d": "En construction.",
    "services.proposer.planning.t": "Planning",
    "services.proposer.planning.d": "En construction.",
    "services.proposer.avis.t": "Avis",
    "services.proposer.avis.d": "En construction.",

    "services.demander.rubrics": "Rubriques",
    "services.demander.decrire.t": "Decrire",
    "services.demander.decrire.d": "En construction.",
    "services.demander.budget.t": "Budget",
    "services.demander.budget.d": "En construction.",
    "services.demander.zone.t": "Zone",
    "services.demander.zone.d": "En construction.",
    "services.demander.urgence.t": "Urgence",
    "services.demander.urgence.d": "En construction.",

    "services.trouver.rubrics": "Rubriques",
    "services.trouver.parcourir.t": "Parcourir",
    "services.trouver.parcourir.d": "En construction.",
    "services.trouver.filtrer.t": "Filtrer",
    "services.trouver.filtrer.d": "En construction.",
    "services.trouver.contacter.t": "Contacter",
    "services.trouver.contacter.d": "En construction.",
    "services.trouver.securite.t": "Securite",
    "services.trouver.securite.d": "En construction.",

    "services.devis.rubrics": "Rubriques",
    "services.devis.comparaison.t": "Comparer",
    "services.devis.comparaison.d": "En construction.",
    "services.devis.conditions.t": "Conditions",
    "services.devis.conditions.d": "En construction.",
    "services.devis.paiement.t": "Paiement",
    "services.devis.paiement.d": "En construction.",
    "services.devis.suivi.t": "Suivi",
    "services.devis.suivi.d": "En construction.",

    "sortie.title": "Sortie",
    "sortie.hint": "En construction.",
    "sortie.tabs": "En construction.",
    "sortie.detail": "En construction.",
    "sortie.soon": "En construction.",
    "sortie.tab.events": "Events",
    "sortie.tab.sorties": "Sorties",
    "sortie.tab.rencontres": "Rencontres",
    "sortie.tab.clubs": "Clubs",
    "sortie.desc.events": "En construction.",
    "sortie.desc.sorties": "En construction.",
    "sortie.desc.rencontres": "En construction.",
    "sortie.desc.clubs": "En construction.",

    "sortie.events.rubrics": "Rubriques Events",
    "sortie.events.agenda.t": "Agenda",
    "sortie.events.agenda.d": "En construction.",
    "sortie.events.proposer.t": "Proposer",
    "sortie.events.proposer.d": "En construction.",
    "sortie.events.filtrer.t": "Filtrer",
    "sortie.events.filtrer.d": "En construction.",
    "sortie.events.rejoindre.t": "Rejoindre",
    "sortie.events.rejoindre.d": "En construction.",

    "sortie.sorties.rubrics": "Rubriques Sorties",
    "sortie.sorties.lieux.t": "Lieux",
    "sortie.sorties.lieux.d": "En construction.",
    "sortie.sorties.groupes.t": "Groupes",
    "sortie.sorties.groupes.d": "En construction.",
    "sortie.sorties.moments.t": "Moments",
    "sortie.sorties.moments.d": "En construction.",
    "sortie.sorties.chat.t": "Chat",
    "sortie.sorties.chat.d": "En construction.",

    "sortie.rencontres.rubrics": "Rubriques Rencontres",
    "sortie.rencontres.match.t": "Match",
    "sortie.rencontres.match.d": "En construction.",
    "sortie.rencontres.securite.t": "Securite",
    "sortie.rencontres.securite.d": "En construction.",
    "sortie.rencontres.themes.t": "Themes",
    "sortie.rencontres.themes.d": "En construction.",
    "sortie.rencontres.inviter.t": "Inviter",
    "sortie.rencontres.inviter.d": "En construction.",

    "sortie.clubs.rubrics": "Rubriques Clubs",
    "sortie.clubs.rechercher.t": "Rechercher",
    "sortie.clubs.rechercher.d": "En construction.",
    "sortie.clubs.creer.t": "Creer",
    "sortie.clubs.creer.d": "En construction.",
    "sortie.clubs.planning.t": "Planning",
    "sortie.clubs.planning.d": "En construction.",
    "sortie.clubs.regles.t": "Regles",
    "sortie.clubs.regles.d": "En construction.",

    "voyage.title": "Voyage",
    "voyage.hint": "Destinations · Itineraire · Co-voyage · Hebergement",
    "voyage.tabs": "Categories Voyage",
    "voyage.detail": "Detail",
    "voyage.soon": "En construction.",
    "voyage.tab.destinations": "Destinations",
    "voyage.tab.itineraire": "Itineraire",
    "voyage.tab.covoyage": "Co-voyage",
    "voyage.tab.hebergement": "Hebergement",
    "voyage.tab.conseils": "Conseils",
    "voyage.desc.destinations": "En construction.",
    "voyage.desc.itineraire": "En construction.",
    "voyage.desc.covoyage": "En construction.",
    "voyage.desc.hebergement": "En construction.",
    "voyage.desc.conseils": "En construction.",

    "voyage.destinations.rubrics": "Rubriques Destinations",
    "voyage.destinations.decouvrir.t": "Decouvrir",
    "voyage.destinations.decouvrir.d": "En construction.",
    "voyage.destinations.tendances.t": "Tendances",
    "voyage.destinations.tendances.d": "En construction.",
    "voyage.destinations.budget.t": "Budget",
    "voyage.destinations.budget.d": "En construction.",
    "voyage.destinations.securite.t": "Securite",
    "voyage.destinations.securite.d": "En construction.",

    "voyage.itineraire.rubrics": "Rubriques Itineraire",
    "voyage.itineraire.planifier.t": "Planifier",
    "voyage.itineraire.planifier.d": "En construction.",
    "voyage.itineraire.jours.t": "Jours et etapes",
    "voyage.itineraire.jours.d": "En construction.",
    "voyage.itineraire.checklist.t": "Checklist",
    "voyage.itineraire.checklist.d": "En construction.",
    "voyage.itineraire.partager.t": "Partager",
    "voyage.itineraire.partager.d": "En construction.",

    "voyage.covoyage.rubrics": "Rubriques Co-voyage",
    "voyage.covoyage.trouver.t": "Trouver",
    "voyage.covoyage.trouver.d": "En construction.",
    "voyage.covoyage.profil.t": "Profil",
    "voyage.covoyage.profil.d": "En construction.",
    "voyage.covoyage.match.t": "Match",
    "voyage.covoyage.match.d": "En construction.",
    "voyage.covoyage.chat.t": "Chat",
    "voyage.covoyage.chat.d": "En construction.",

    "voyage.hebergement.rubrics": "Rubriques Hebergement",
    "voyage.hebergement.chercher.t": "Chercher",
    "voyage.hebergement.chercher.d": "En construction.",
    "voyage.hebergement.partager.t": "Partager",
    "voyage.hebergement.partager.d": "En construction.",
    "voyage.hebergement.dates.t": "Dates",
    "voyage.hebergement.dates.d": "En construction.",
    "voyage.hebergement.regles.t": "Regles",
    "voyage.hebergement.regles.d": "En construction.",

    "voyage.conseils.rubrics": "Rubriques Conseils",
    "voyage.conseils.formalites.t": "Formalites",
    "voyage.conseils.formalites.d": "En construction.",
    "voyage.conseils.sante.t": "Sante",
    "voyage.conseils.sante.d": "En construction.",
    "voyage.conseils.culture.t": "Culture",
    "voyage.conseils.culture.d": "En construction.",
    "voyage.conseils.astuces.t": "Astuces",
    "voyage.conseils.astuces.d": "En construction.",

    "civet.search_ph": "Recherche E.T (futur)…",
    "civet.hint": "Temple E.T (futur)",
    "civet.hub": "Voir toutes les civilisations",
    "civtemple.kicker": "TEMPLE E.T (futur)",
    "civtemple.title": "Civilisations E.T (futur)",

    "civhub.title": "Temple central (futur)",
    "civhub.subtitle": "Traduction extraterrestre a incorporer plus tard.",
    "civhub.open_book": "Ouvrir le Livre",
    "civhub.enter_temple_of": "Entrer dans le Temple de",

    "ia40.title": "Temple 40 IA (futur)",
    "ia40.hint": "4 familles · 10 IA (futur)",
    "ia40.f1": "1. Soin (futur)",
    "ia40.f2": "2. Justice (futur)",
    "ia40.f3": "3. Terre (futur)",
    "ia40.f4": "4. Cosmique (futur)",

    "langnote.kicker": "Traduction (futur)",
    "langnote.title": "Contenu extraterrestre a venir",
    "langnote.text": "Langue extraterrestre a incorporer plus tard. Pour l’instant, ce contenu est en francais.",
    "langnote.to_fr": "Passer en francais",

    "auth.login": "Connexion",
    "auth.register": "Inscription",
    "auth.logout": "Deconnexion",

    "nav.home": "Accueil",
    "nav.temple": "Temple",
    "nav.forum": "Forum",
    "nav.book": "Livre sacre",
    "nav.profile": "Profil",
    "nav.notifications.open": "Notifications (futur)",
    "nav.notifications": "Notifications (futur)",
    "nav.friends": "Amis (futur)",
    "nav.friends_feed": "Actu (futur)",
    "nav.friends_lounge": "Salon (futur)",
    "nav.temples": "Temples",
    "nav.creator_temple": "Temple Createur",
    "nav.admin": "Administration",

    "theme.mode_dark": "Mode sombre",
    "theme.mode_light": "Mode clair",

    "dock.join": "Rejoindre",
    "dock.join_call_aria": "Rejoindre l'appel video",
    "dock.discussions": "Discussions",
    "dock.open_discussions": "Ouvrir les discussions",
    "dock.close_discussions": "Fermer les discussions",
    "dock.unread_messages": "Nouveaux messages",
    "dock.back_home": "Retour a l'accueil",
    "dock.friends_actions": "Actions amis",
    "dock.feed": "Actu",
    "dock.music": "Musique",
    "dock.friends": "Amis",
    "dock.requests": "Demandes",
    "dock.new": "Nouveaux",
    "dock.calls": "Appels",
    "dock.lounge": "Salon amis",
    "dock.hidden_guest": "Connecte toi (futur)",
    "dock.hidden_authed": "Reseau infini (futur)",

    "book.writing": "Texte en cours d’ecriture…",
    "book.chapters": "Chapitres",
    "book.search": "Recherche (futur)...",
    "book.your_favs": "Favoris",
    "book.favorite": "favori",
    ...VOYAGE_DELUXE_TRANSLATIONS.et,
    ...IMMOBILIER_TRANSLATIONS.et,
    ...CONFIRMATION_TRANSLATIONS.et,
  },
};
